export default {
  translation: {
    'Ο εταιρικός λογαριασμός υπάρχει ήδη': 'The business account already exists',
    'Το ερωτηματολογίο συμπληρώθηκε επιτυχώς': 'The questionnaire was successfully completed',
    'Αγόρασε πακέτο Επανεκτίμησης NutriGenetix': 'Purchase a NutriGenetix Reevaluation Package',
    'Αγορά πακέτου': 'Buy a package',
    Αγορά: 'Buy',
    'Fill out a new questionnaire': 'Fill out a new questionnaire',
    Διαθέσιμες: 'Available',
    επανεκτιμήσεις: 'revaluations',
    'Επανεκτιμήσεις NutriGenetix': 'NutriGenetix Revaluations',
    'Επανεκτίμηση Nutrigenetix': 'NutriGenetix Reevaluation',
    'Awaiting registration completion': 'Awaiting registration completion',
    Νοσοκομείο: 'Hospital',
    'NutriGenetix Δυναμική Παρακολούθηση': 'NutriGenetix Dynamic Monitoring',
    DynamicMonitoring: 'Dynamic Monitoring',
    'Δυναμική παρακολούθηση': 'Dynamic Monitoring',
    'Δες το συμπληρωμένο ερωτηματολόγιο': 'View the completed questionnaire',
    'Δες το': 'View',
    'Συμπληρωμένο Ερωτηματολόγιο': 'Completed Questionnaire',
    'No options': 'No options',
    'Patients report': 'Patient\'s report',
    companyActivity: 'Δραστηριότητα εταιρείας',
    'Doctors report': 'Doctor\'s report',
    continue: 'Continue',
    Action: 'Action',
    'Καταχώρηση παραπεμπτικού': 'Referral registration',
    'Αν έχετε λάβει παραπεμπτικό από τον θεράποντα ιατρό σας για τη διεξαγωγή του iDNA PGx CNS, καταχωρήστε τον αριθμό παραπεμπτικού στο παρακάτω πεδίο.': 'If you have received a referral from your doctor for the iDNA PGx CNS,  please input the referral number in the field below.',
    'Αν δεν τον καταχωρήσετε σε αυτό το βήμα, ΔΕΝ θα έχετε τη δυνατότητα καταχώρησης αυτού σε επόμενο στάδιο.': 'If you do not register it at this step, you will NOT be able to register it at a later stage.',
    'Αριθμός παραπεμπτικού': 'Referral number',
    'Καταχωρήστε τον αριθμό παραπεμπτικού του πελάτη/ασθενή σας για τη Φαρμακογενετική Ανάλυση iDNA PGx CNS, στο παρακάτω πεδίο.': 'Input the referral number for your client/patient for iDNA PGx CNS to be conducted, in the field below.',
    'Συμπληρώστε το μοναδικό αριθμό παραπεμπτικού': 'Enter the unique referral number',
    'Συμβουλευτείτε το παρακάτω δείγμα παραπεμπτικού για να συμπληρώσετε τον αριθμό παραπεμπτικού': 'Consult the sample referral form below to fill in the referral number',
    'Στοιχεία Θεράποντα Ιατρού': 'Doctor personal data',
    'ΔΕΙΓΜΑ ΠΑΡΑΠΕΜΠΤΙΚΟΎ': 'REFERRAL SAMPLE',
    Μεγέθυνση: 'Zoom in',

    wrongRegistrationType: 'Wrong kit category',
    userDisabled: 'Your account has been deactivated. Call +30 2111021821, if you need help.',

    'no-data': 'No Data',
    source: 'Source',
    add: 'Add',
    remove: 'Remove',
    carbohydrates: 'Carbohydrates',
    registeredKits: 'Registered kits',
    'iDNA Test 3 σε 1': 'iDNA Test 3in1',
    whatIsPRS: 'What is PRS?',
    whatIsADJPRS: 'What is Adjusted PRS?',
    Διατροφή: 'iDNA Test Nutrition',
    'Βιταμίνες και Ιχνοστοιχεία': 'Vitamins and Minerals',
    'Προσαρμοσμένο PRS (Adjusted PRS)': 'Adjusted PRS',
    ok: 'Ok',
    'Βιταμίνες & Ιχνοστοιχεία': 'Vitamins & Minerals',
    Βιταμίνες: 'Vitamins',
    Άθληση: 'Sports',
    search: 'Search',
    'Ευαισθησία στο Αλάτι': 'Sensitivity to Salt',
    review: 'Review',
    Υδατάνθρακες: 'Carbohydrates',
    'Κορεσμένα λιπαρά': 'Saturated Fat',
    Πρωτεΐνες: 'Proteins',
    Λιπαρά: 'Fat',
    Γονίδιο: 'Gene',
    'Γονιδιακός τόπος': 'Gene locus',
    'Η παραλλαγή σου': 'Your variant',
    'Σημαντικές Πληροφορίες': 'Important Information',
    Αποτελέσματα: 'Results',
    Eρωτηματολογίο: 'Questionnaire',
    areYouSureDeleteAccount: 'Are you sure you want to delete your account?',

    deleteAccountText1: 'This action cannot be undone and all data will be permanently deleted.',
    deleteAccountText11: 'Your account will be scheduled for deletion within 30 days.',
    deleteAccountText12: 'If you change your mind, you can reactivate it by contacting the Support Team within this period.',
    deleteAccountText2: 'To proceed, confirm the selection by pressing the button',
    deleteAccountText3: 'Thanks for using our app.',
    deleteAccountButtonText: 'button',
    confirmDeletion: 'Confirm Deletion',

    'Βιταμίνη Α': 'Vitamin A',
    'Βιταμίνη Β6': 'Vitamin B6',
    'Βιταμίνη Β9 - Φολικό & Φυλλικό οξύ': 'Vitamin Β9 - Folate & Folic Acid',
    'Βιταμίνη Β12': 'Vitamin Β12',
    'Βιταμίνη C': 'Vitamin C',
    'Βιταμίνη D': 'Vitamin D',
    'Βιταμίνη E': 'VItamin E',

    questionnaireAnswers: 'Questionnaire Responses',

    'Ικανότητα Αποτοξίνωσης': 'Detoxification Ability',
    'Αντιοξειδωτικές ανάγκες': 'Antioxidant needs',

    'Ασβέστιο-χαμηλά επίπεδα ασβεστίου': 'Calcium - low calcium levels',
    'Επίπεδα ασβεστίου-αυξημένη συγκέντρωση ασβεστίου': 'Calcium levels-increased calcium concentration',
    'Σίδηρος-χαμηλά επίπεδα σιδήρου': 'Iron - low iron levels',
    'Υπερφόρτωση σιδήρου': 'Iron overload',
    Μαγνήσιο: 'Magnesium',

    Αντοχή: 'Stamina',
    'Μυϊκή δύναμη': 'Muscle power',
    Ισχύς: 'Power',
    'Αεροβική ικανότητα και καρδιoαναπνευστικά οφέλη': 'Aerobic capacity and cardiorespiratory benefits',
    'Ικανότητα ανάπτυξης μυϊκής μάζας': 'Ability to develop muscle mass',
    'Κίνητρο για άσκηση': 'Motivation to exercise',

    'Τραυματισμός τενόντων σε γόνατο (jumper\'s knee) και αγκώνα (tennis elbow)': 'Tendon injury in knee (jumper\'s knee) and elbow (tennis elbow)',
    'Τραυματισμός αχίλλειου τένοντα': 'Achilles tendon injury',
    'Μυοσκελετική υγεία': 'Musculoskeletal health',
    'Αποκατάσταση μετά την άσκηση': 'Recovery after exercise',
    deleteAccount: 'Delete account',
    'Στεφανιαία νόσος': 'Coronary artery disease',
    'Μυοκαρδιοπάθεια - Διατατική': 'Cardiomyopathy - Dilated',
    'Μυοκαρδιοπάθεια - Υπερτροφική': 'Cardiomyopathy - Hypertrophic',
    'Καρδιακή Ανεπάρκεια': 'Heart Failure',
    'Αρρυθμία - Kολπική μαρμαρυγή': 'Arrhythmia - Atrial fibrillation',
    'Ισχαιμικό εγκεφαλικό επεισόδιο': 'Ischemic stroke',

    'Επεξήγηση συμβόλων': 'Επεξήγηση συμβόλων',
    brandName: 'Company name',
    'Ω6/Ω3 Λιπαρά οξέα': 'Ω6/Ω3 Fatty acids',
    'Τρανς λιπαρά': 'Trans fats',
    'Ευαισθησία στην Καφεΐνη': 'Sensitivity to coffee',
    'Ευαισθησία στο Αλκοόλ': 'Sensitivity to Alcohol',
    Σνακς: 'Snacks',
    'Ευαισθησία στη Λακτόζη': 'Sensitivity to Lactose',
    'Ευαισθησία στη Γλουτένη': 'Sensitivity to Gluten',
    'Προτίμηση στη γλυκιά γεύση': 'Sweet taste preference',
    'Βιολογικό Ρολόι': 'Biological Clock',
    hello: 'Hello',
    'iDNA Βιολογική Ηλικία': 'iDNA Biological Age',
    'iDNA Test Διατροφή': 'iDNA Test Nutrition',
    nutritionalGuide: 'Nutritional Guide',
    personalFolder: 'Personal Folder',
    iDNATest3to1: 'iDNA Test 3in1',
    viewThe: 'View the',
    resultsS: 'results',
    biologicalAge: 'Biological Age',
    dietVitaminsSports: 'Nutrition, Vitamins & Minerals, Exercise',
    biologicalClock: 'Biological Clock',
    high: 'High',
    High: 'High',
    typical: 'Intermediate',
    Typical: 'Intermediate',
    increased: 'Increased',
    Increased: 'Increased',
    low: 'Low',
    Reduced: 'Reduced',
    vitaminsTraceElements: 'Vitamins & Minerals',
    weightManagement: 'Weight management',
    diet: 'Diet',
    Yes: 'Yes',
    No: 'No',
    vitamins: 'Vitamins',
    cardiometabolicHealth: 'Cardiovascular health',
    detoxificationCapacityAntioxidantNeeds: 'Detoxification capacity & antioxidant needs',
    detoxificationCapacity: 'Detoxification Capacity',
    traceElements: 'Minerals',
    foodSensitivities: 'Food sensitivities',
    sensitivityProfile: 'Sensitivity Profile',
    proteins: 'Proteins',
    sports: 'Sports',
    fat: 'Fat',
    questionnaireSubmittedTitle: 'Information',
    questionnaireSubmittedContent: 'You have already submitted the Form',
    eatingSnacksBetweenMeals: 'Eating Snacks Between Meals',
    preferenceForSweetTaste: 'Preference for sweet taste',
    results: 'Results',
    explanationOfResults: 'Results interpretation',
    download: 'Download',
    downloadFormal: 'Download',
    download1: 'Download the',
    dummy: 'dummy',
    personalAccount: 'Personal account',
    civilian: 'Personal',
    shop: 'Shop',
    doctorHealthProfessional: 'Doctor / Health Professional',
    doctorsHealthProfessionals: 'Doctors / Health Professionals',
    corporateCustomer: 'Corporate',
    next: 'Next',
    registerKit: 'Register',
    newKitRegister: 'Register new kit / Resume registration',
    general: 'General',
    profile: 'Profile',
    athleticProfile: 'Athletic profile',
    injuryPredisposition: 'Injury predisposition',
    makeAnAppointment: 'Book an Appointment',
    'emr-imaging-exams': 'EMR Imaging Exams',
    'laboratory-test-results': 'Laboratory Test Results',
    'polygenic-risk-scores': 'Polygenic Risk Scores',
    'data-from-mobile-app': 'Data from Mobile APP',
    'refer-a-friend': 'Refer A Friend',
    messages: 'Messages',
    questionnaires: 'Questionnaires',
    questionnaire: 'Questionnaire',
    settings: 'Settings',
    somethingWentWrong: 'Something went wrong',
    invalidCredentials: 'Incorrect username or password',
    invalidConfirmationCode: 'Invalid confirmation code',
    signIn: 'Sign in',
    signUp: 'Sign up',
    logout: 'Log out',
    security: 'Security',
    learnMore: 'Learn More',
    alreadyHaveAccount: 'Already have an account?',
    noAccountYet: 'Don\'t have an account?',
    confirmCode: 'Confirm',
    confirmAccount: 'Confirm Account',
    resendCode: 'Resend code',
    haveNotReceivedConfirmationCode: 'Have not yet received a confirmation code?',
    accountAlreadyExists: 'Account already exists',
    step2verification: '2 Step verification',
    step2verificationDesc: 'Please enter the confirmation code to complete sign in',
    forgotPassword: 'Forgot password?',
    passwordRecovery: 'Recover your password',
    recovery: 'Recover',
    sessionExpired: 'Your session has expired. Please login again.',
    networkError: 'Network error. Please check your internet connection.',
    userExtraDetails: 'Personal details',
    personalDetails: 'Personal Data',
    userExtraDetailsDescription: 'Please fill in the fields below to finalize your account',
    nextStep: 'Next step',
    complete: 'Completion',
    back: 'Back',
    kitRegister: 'New kit registration',
    newKitRegistration: 'New kit registration',
    resumeRegistration: 'Resume registration',
    deleteKit: 'Delete kit',
    advice: 'Advice',
    yourResult: 'Your result',
    'Confirm change password': 'Confirm change password',
    here: 'here',
    'dd/mm/yyyy': 'dd/mm/yyyy',
    'έτος-μμ-ηη': 'year-mm-dd',
    kitRegisterConsents: 'Consent form',
    invalidSerialNumber: 'Serial number is either invalid or does not exist or is already registered',
    registerNewKit: 'Register a new kit',
    'Verify your EMAIL': 'Verify your EMAIL',
    kitFollowInstructions: 'Sample collection instructions',
    'Invalid serial number. Please check again': 'Invalid serial number. Please check again',
    invalidPaymentStatus: 'Invalid serial number. Please contact us at 211 1021881 ',
    kitFollowInstructionsContent: 'Please follow the buccal swab (saliva) sample collection instructions provided in the kit you received or click ',
    sendInstructions: 'Sample dispatch instructions',
    'We inform you that we have received the buccal swab sample with name': 'We inform you that we have received the buccal swab (saliva) sample under the name of',
    'We inform you that the results report for the serial number': 'We inform you that the results report for serial number',
    resultReceipt: 'Παραλαβή αποτελεσμάτων',
    Αριθμός: 'Number',
    'Πληρωμή Kit': 'Payment of Kit',
    resultReceiptContentCustomer: 'Your results report will be accessible on your account page within {{days}} business days of receiving your sample. A notification will be sent to your email. At the same time, your doctor will also be notified, and will have access to your results report.',
    resultReceiptContentDoctor: 'Your patient’s/ client’s personalized report will be available in your myEMR account within {{days}} business days of receiving the buccal swab sample from our laboratory. You will be notify by email. You will be able to view, download, send  via the platform or via email your personalized patient results report.',
    resultReceiptContentDoctorAL: 'Your patient’s/ client’s personalized report will be available in your myEMR account within {{days}} business days of receiving the buccal swab sample at Trimed Healthcare premises. You will be notify by email. You will be able to view, download, send  via the platform or via email your personalized patient results report.',
    wlResultReceiptContent: 'Εντός 20 εργάσιμων ημερών από την παραλαβή του δείγματος παρειακού επιχρίσματος από το εργαστήριό μας, η έκθεση αποτελεσμάτων σας θα είναι διαθέσιμη στην σελίδα του λογαριασμού σας. Θα σας σταλεί ειδοποίηση στο ηλεκτρονικό σας ταχυδρομείο. Αν έχετε ζητήσει να δοθεί πρόσβαση στον ηλεκτρονικό σας φάκελο και σε άλλο πρόσωπο, και αυτό το πρόσωπο έχει αποδεχτεί την αίτηση σας, τότε ταυτόχρονα, θα ειδοποιηθεί και αυτός, και θα έχει πρόσβαση στην έκθεση αποτελεσμάτων σας.',
    bioAgeResultReceiptContent: 'Your patient’s/client’s personalized report will be accessible in your account within 3 business days from the day of the questionnaire completion with their personal information and the results of their blood tests. A notification will be sent to your registered email. You will be able to view, download, send it through the platform or by email.',
    Ανάλυση: 'Analysis',
    completeRegistration: 'Complete registration',
    'Από > Εώς': 'From > To',
    successfulKitRegistration: 'Επιτυχής εγγραφή',
    successfulKitRegistrationContent: 'Η ολοκλήρωση της εγγραφής του κιτ ήταν επιτυχής',
    save: 'Save',
    userDetails: 'User personal details',
    customerDetails: 'Customer / Patient personal details',
    male: 'Male',
    female: 'Female',
    Άνδρας: 'Male',
    Γυναίκα: 'Female',
    other: 'Other',
    'Select a kit from the dropdown list to see and edit the consents': 'Επιλέξτε ένα κιτ από την λίστα για να δείτε και να επεξεργαστείτε τις συγκατάθεσεις',
    yes: 'YES',
    no: 'NO',
    firstName: 'First Name',
    lastName: 'Last Name',
    parentFirstName: 'Father\'s name',
    profession: 'Specialty/Profession',
    streetAddress: 'Street Address & Number',
    postalCode: 'Postal Code',
    selectYourDomain: 'Select your domain',
    cityOrTown: 'Town / City',
    dateOfBirth: 'Date of birth',
    'I accept the terms and conditions': 'I accept the terms and conditions',
    'Read the terms and conditions': 'Read the terms and conditions',
    'Terms & Consents': 'Terms & Consents',
    'Completion of Submission': 'Completion of Submission',
    'You should agree': 'Acceptance of terms of use is required',
    password: 'Password',
    email: 'E-mail',
    mobileNumber: 'Mobile number',
    houseNumber: 'Landline number',
    businessNumber: 'Business number',
    phone: 'Phone',
    physicalAddress: 'Address',
    contactDetails: 'Contact details',
    'Προσωπικά στοιχεία ιατρού': 'Doctor personal details',
    doctorDetails: 'Doctor personal details',
    gender: 'Biological Gender',
    searchForADoctor: 'Search for a Doctor / Health Professional',
    'biological gender is defined as the gender you were born with': 'biological gender is defined as the gender you were assigned at birth',
    'Biological Gender\n (biological gender is defined as the gender you were born with)': 'Biological Gender\n (biological gender is defined as the gender you were born with)',
    serialNumber: 'Serial number',
    'Here you will find your personal results report in a printable format.': 'Here you will find your personal results report in a printable format.',
    kitRegistration: 'Kit Registration',
    hereYouWillFind: 'Here you will find your Pharmacogenetic analysis for drugs related to diseases of the Central Nervous System. The results help your doctor to choose the appropriate personalized treatment: which drug and at which dosage you will have the best response, with the minimum side effects.',
    'Ο γονιδιακός έλεγχος περιλαμβάνει τη Φαρμακογενετική ανάλυση για 30 φάρμακα.': 'Genetic testing includes Pharmacogenetic analysis for 30 drugs.',

    'Αντιψυχωσικά Φάρμακα': 'Antipsychotic Drugs',
    'Αντικαταθλιπτικά Φάρμακα': 'Antidepressant Drugs',
    'Αντιεπιληπτικά Φάρμακα': 'Antiepileptic Drugs',
    'Άλλα φάρμακα ΚΝΣ': 'More CNS Drugs',
    'Με βάση τη Φαρμακογενετική Ανάλυση επιτυγχάνονται:': 'Based on the Pharmacogenetic Analysis, the following are achieved:',
    'Λιγότερες ανεπιθύμητες ενέργειες': 'Fewer side effects',
    'Βέλτιστη επιλογή θεραπείας και µείωση της πιθανότητας αποτυχίας της αγωγής': 'Selection of optimal medication and reduction of the probability of treatment failure',
    'Καλύτερη ποιότητα ζωής για τον ασθενή': 'Better quality of life for patients',

    ηη: 'dd',
    μμ: 'mm',
    έτος: 'year',
    dd: 'ηη',
    mm: 'μμ',
    year: 'έτος',
    agree: 'I agree',
    onlyAgree: 'Agree',
    gdpr: 'General Data Protection Regulation Information',
    'Συμφωνητικό Επεξεργασίας Προσωπικών Δεδομένων': 'Agreement Regarding Processing Of Personal Data',
    gdprPrompt: 'Important information & general data protection regulation ',
    'Συναίνεση ασθενή': 'Συναίνεση ασθενή',
    'Εδώ θα βρείτε το έντυπο που πρέπει να μοιραστείτε με τον ασθενή σας προς ενημέρωση και υπογραφή.': 'Εδώ θα βρείτε το έντυπο που πρέπει να μοιραστείτε με τον ασθενή σας προς ενημέρωση και υπογραφή.',
    'Δείτε την Ενημέρωση για την Προστασία Δεδομένων Προσωπικού Χαρακτήρα': 'Δείτε την Ενημέρωση για την Προστασία Δεδομένων Προσωπικού Χαρακτήρα',
    'Παρακαλώ πολύ κρατήστε το συμπληρωμένο έγγραφο στα αρχεία σας και καταγράψτε τη συγκατάθεση που λάβατε.': 'Παρακαλώ πολύ κρατήστε το συμπληρωμένο έγγραφο στα αρχεία σας και καταγράψτε τη συγκατάθεση που λάβατε.',
    'Ο ασθενής δίνει ρητώς τη συγκατάθεσή του, για τη χρήση των ανωνυμοποιημένων ή ψευδωνυμοποιημένων (με κωδικοποιημένη μορφή) αποτελεσμάτων των γενετικών του αναλύσεων για ερευνητικούς και στατιστικούς σκοπούς.': 'The patient  explicitly consents to the use of the anonymized or pseudonymized (coded) results of his genetic analyses for research and statistical purposes.',
    'Διενέργεια της Φαρμακογενετικής ανάλυσης, επανάληψη δείγματος αν κριθεί ακατάλληλο, ακριβή και αληθή στοιχεία': 'Conducting the Pharmacogenetic analysis, repeating the sample if deemed inappropriate, accurate and true data',
    dataCollectionConsentReview: 'Collection and processing of personal data concerning special categories of data (genetic, health) for the purpose of conducting the Pharmacogenetic analysis by iDNA Laboratories',
    dataCollectionConsentReviewNonPGx: 'The patient/client provides consents for the collection and processing of their personal data (genetics, health) for the purpose of conducting the Genetic analysis by iDNA Genomics.',
    'Δίνω ρητώς τη συγκατάθεσή μου για τη συλλογή και επεξεργασία των προσωπικών μου δεδομένων που αφορούν σε ειδικών κατηγοριών δεδομένα (γενετικά, υγείας) με σκοπό τη διεξαγωγή της Γενετικής ανάλυσης από την iDNA Genomics.': 'For the collection and processing of my personal data (genetic, health) for the purposes of the genetic analysis from iDNA Genomics.',
    'I explicitly provide my consent': 'I explicitly provide my consent for the following:',
    consents: {
      pgx: {
        general: {
          inform: 'I hereby declare that I have been fully and thoroughly informed about the necessity, the purpose, the nature, and the way of conducting the Pharmacogenetic Analysis (PGx), of the company iDNA Laboratories S.A., concerning 30 drugs of the Central Nervous System.',
          proceed: 'Following this information, I declare that I give my consent to the above company to carry out the above analysis, with the competent and appropriate personnel, which aims to improve the selected medication by my doctor',
          destroy: 'I also declare that I agree, if and when the sample is found to be unsuitable for the aforementioned analysis, it may be destroyed and a new sample may be requested at no additional charge.',
          doctor: 'I also state that I explicitly consent to the dispatch of my test results to the referring doctor.',
          trueAndAccurate: 'Fully acknowledging the consequences of the law, I explicitly declare that all personal and medical history data provided here are accurate and true. ',
        },
        doctorExtra: 'The patient  explicitly consents to the use of the anonymized or pseudonymized (coded) results of his genetic analyses for research and statistical purposes.',
        doctorExtraOther: 'The patient explicitly consents to the collection and processing of his personal data (genetics, health) for the purpose of conducting the Pharmacogenetic analysis by iDNA Laboratories.',
        extra: 'Δίνω ρητώς τη συγκατάθεσή μου για τη συλλογή και επεξεργασία των προσωπικών μου δεδομένων που αφορούν σε ειδικών κατηγοριών δεδομένα (γενετικά, υγείας) με σκοπό τη διεξαγωγή της Φαρμακογενετικής ανάλυσης από την iDNA Genomics.',
      },
      wellness: {
        general: {
          inform: 'I hereby state that I have been fully and thoroughly informed regarding the necessity, purpose and nature of the genetic analysis, as well as the methodology used by iDNA Genomics S.A.',
          proceed: 'Following this information, I declare that I explicitly provide my consent to the above company to proceed with the above analysis.',
          destroy: 'In case my sample is found unsuitable for analysis for any reason, I agree that this sample may be destroyed, and a new sample may be requested at no additional charge.',
          trueAndAccurate: 'Fully acknowledging the consequences of the law, I explicitly declare that all my personal and medical history data provided here are accurate and true.',
          trueAndAccurateChild: 'Fully acknowledging the consequences of the law, I explicitly declare that all personal and medical history data provided here are accurate and true. ',
        },

        general_minor: {
          inform: 'I hereby state that I have been fully and thoroughly informed regarding the necessity, purpose and nature of the genetic analysis, as well as the methodology used by iDNA Genomics S.A.',
          proceed: 'Following this information, I declare that I explicitly provide my consent to the above company to proceed with the above analysis.',
          destroy: 'In case the sample is found unsuitable for analysis for any reason, I agree that this sample may be destroyed, and a new sample may be requested at no additional charge.',
          trueAndAccurate: 'Fully acknowledging the consequences of the law, I explicitly declare that all personal and medical history data provided here are accurate and true.',
          trueAndAccurateChild: 'Fully acknowledging the consequences of the law, I explicitly declare that all personal and medical history data provided here are accurate and true. ',
        },
        extra: 'For the collection and processing of my personal data (genetic, health) for the purposes of the genetic analysis from iDNA Genomics.',
        doctor_extra: 'I explicitly declare that for any personal data (sensitive, biometric, age, gender, diseases, preferences, etc.) of a patient/client that I will send to the company "IDNA GENOMICS S.A.", I will obtain the consent of the patient, in order to keep, process, use for research & scientific purposes and store their personal data, in accordance with current legislation. The above data will be given to "IDNA GENOMICS S.A.", because they are considered necessary for the provision of genetic analysis services for each patient/client.',
        extra_extra: 'The patient/client explicitly consents to the use of the anonymized or pseudonymized (coded) results of their genetic analysis for research and statistical purposes.',
        doctorExtra: 'The patient/client explicitly consents to the use of the anonymized or pseudonymized (coded) results of their genetic analysis for research and statistical purposes.',
        doctorExtraOtherOther: 'The patient/client explicitly consents to iDNA Genomics and its partners to send news and promotional material to their email.',
        doctorExtraOther: 'The patient/client explicitly consents to the collection and processing of their personal data (genetics, health) for the purpose of conducting the Genetic analysis by iDNA Genomics.',
      },
      bioAge: {
        general: {
          inform: 'I hereby state that I have been fully and thoroughly informed regarding the necessity, purpose and nature of the Biological Age measurement, as well as the methodology used by iDNA Genomics S.A.',
          proceed: 'Following this information, I declare that I explicitly provide my consent to the above company to proceed with the above analysis.',
          trueAndAccurate: 'Fully acknowledging the consequences of the law, I explicitly declare that all my personal and medical history data provided here are accurate and true.',
        },
        extra: 'For the collection and processing of my personal data concerning special categories of data (i.e. racial origin, health data) for the purposes of the measurement of my Biological Age from iDNA Genomics.',
        extraHelper: 'We are unable to provide services without your consent',
        doctorExtra: 'The patient/client explicitly consents to the use of anonymized or pseudonymized (coded) results of Biological Age measurements for research and statistical purposes.',
        doctorExtraOther: 'The patient/client explicitly consents to the use of the anonymized or pseudonymized (coded) results of their Biological Age measurements for research and statistical purposes.',
      },
      bioAge_anonymous_consent: 'For the use of my anonymized or pseudo-anonymized (in coded form) results of the Biological Age measurement for research or statistical purposes.',
      anonymous_research_dna_consent: 'For the use of my anonymized or pseudo-anonymized (in coded form) genetic results for research or statistical purposes.',
      anonymous_research_dna_consent_child: 'For the use of the anonymized or pseudo-anonymized (in coded form) genetic results for research or statistical purposes.',
      anonymous_research_results_consent: 'I explicitly give my consent to the use of my anonymized or pseudonymized (in coded form) results of my genetic analyses for research purposes.',
      informative_material: 'For iDNA Genomics and their partners to send news and promotional material to my email.',
    },
    readHere: 'Read here',
    pgxUserDetailsPrompt: 'Please enter the data of the person from whom the sample will be collected',
    userDetailsPrompt: 'Please enter the data of the person from whom the sample will be collected',
    nutriUserDetailsPrompt: 'Please enter the data of the person from whom the sample will be collected',
    bioAgeUserDetailsPrompt: 'Please enter the details of the person for whom the Biological Age test will be performed',
    Προσθήκη: 'Add',
    Διαγραφή: 'Delete',
    doctorConsentPrompt: 'In order to be able to receive your results, you must request the consent of your treating doctor for the Pharmacogenetic analysis  to be conducted.',
    pGXMore: 'Read more regarding Pharmacogenetic analysis',
    pGXInformation: 'Pharmacogenetic analysis can help your doctor determine which drug is right for you. That is, with which drug, and at which dosage you will have the best response, with the fewest side effects. Several genes directly affect the metabolism of drugs in the body as well as ultimately the therapeutic benefit that a specific patient has from the administration of a drug. This is the main reason why the same drug, at the same dose, can affect patients with the same disease in a very different way.',
    today: 'Today',
    yesterday: 'Yesterday',
    registeredAt: 'Registered',
    resumeKitRegistration: 'Resume kit registration',
    shippingToPhysicalAddress: 'Αποστολή σε φυσική διεύθυνση',
    shippingToPhysicalAddressPrompt: 'Παρακαλώ συμπληρώστε τα στοιχεία της φυσικής διεύθυνσης που θέλετε να αποσταλούν τα αποτελέσματά σας',
    thirdPersonEntitlement: 'Εξουσιοδότηση τρίτου προσώπου',
    thirdPersonEntitlementPrompt: 'Παρακαλώ συμπληρώστε τα στοιχεία του τρίτου προσώπου όπως αυτά σας ζητούνται στην παρακάτω φόρμα',
    home: 'Home',
    entitleThirdParty: 'Δηλώνω ότι επιθυμώ, εκτός από τον προσωπικό μου φάκελο στο ΕΜR τα αποτελέσματα (επιλέξτε ένα από τα παρακάτω)',
    skipStep: 'Skip this step',
    fillSampleCollection: 'Date of buccal swab sample collection',
    sampleCollectionDate: 'Date of sample collection',
    sampleReceivedDate: 'Sample received date',
    alreadyInvitedDoctor: 'You have already sent an invitation to your doctor. You may continue',
    healthcareProfessionalInvitationPrompt: 'Should you wish to provide access to your electronic file to a third party (e.g., Doctor / Healthcare professional), please fill in their details below.',
    'I have read and understood the above': 'I read & consent to the above',
    sendInstructionsContent1: 'iDNA Genomics S.A., 25-27 Evrota street, 14564, Kifissia, Greece',
    sendInstructionsContent1PGx: 'iDNA Laboratories S.A., 25-27 Evrota street, 14564, Kifissia, Greece',
    pending: 'Pending',
    sendInstructionsContent2: 'Tel. +30 211 102 18 21',
    approvalStatus: 'Approval Status',
    sendInstructionsContent2PGx: 'Tel. +30 211 1021881',
    sendInstructionsContent3: 'Follow the sample dispatch instructions provided in the kit you received or click',
    alreadyInvitedHealthcareProfessional: 'You have already sent an invitation. Please proceed',
    healthcareProfessionalDetails: 'Doctor / Healthcare Professional Details',
    areYouAHealthcareProfessional: 'Are you a healthcare professional',
    areYouAnIndividual: 'In order to login as a regular user:',
    'Sample received': 'Sample received',
    'Sample analysis': 'Sample analysis',
    click: 'Click',
    needHelp: 'Need help?',
    clickHere: 'Click here',
    'my-patients': 'My patients',
    'header-name': 'Name',
    'header-surname': 'Surname',
    'Product not purchased': 'Product not purchased',
    'Report available': 'Report available',
    'Report availability': 'Report availability',
    'Awaiting sample receipt': 'Awaiting sample receipt',
    'header-dob': 'Date of birth',
    'pending-invitations-title': 'Pending invitations',
    'pending-invitations-description': 'You have some pending invitations.You may accept or reject the invitation.',
    createdAt: 'Created at',
    invitationFrom: 'Invitation from',
    'for serial number': 'for serial number',
    observation: 'Observation',
    consent: 'Consent',
    'You must select a doctor': 'You must select a doctor',
    acceptInvitationPrompt: 'Are you sure you want to accept the invitation ?',
    rejectInvitationPrompt: 'Are you sure you want to reject the invitation ?',
    dataCollectionConsentReviewDocBioAge: 'The patient/client provides consents to proceed with the Biological Age measurement and declares that their data are accurate and true',
    accept: 'Accept',
    cancel: 'Cancel',
    cancelApp: 'Cancel Appointment',
    decline: 'Decline',
    'Your account has been verified': 'Your account has been verified',
    'Verification Code Sent': 'Verification Code Sent',
    reject: 'Reject',
    'Something went wrong. Please try again in a moment': 'Something went wrong. Please try again in a moment',
    'Verify your Account': 'Verify your Account',
    'We have sent you a verification code during registration process': 'We have sent you a verification code during registration process',
    'We have sent you a verification code at': 'We have sent you a verification code at',
    'Your password has changed': 'Your password has changed',
    close: 'Close',
    'Select a registered kit for which you would like to send an invitation to your doctor': 'Select a registered kit for which you would like to send an invitation to your doctor',
    selectAKit: 'Select a kit',
    'You have started registering the serial number in your account': 'You have started registering the serial number in your account',
    'The server is not responding. Please try again later': 'The server is not responding. Please try again later',
    notifications: 'Notifications',
    all: 'All',
    country: 'Country',
    unread: 'Unread',
    'Complete Kit Registration': 'Complete Kit Registration',
    'You have kits that are pending registration': 'You have kits that are pending registration',

    'my-consents': 'Consents',
    specialty: 'Specialty',
    'doctor-invitations': 'Doctors\' invitations ',
    'my-doctors': 'My doctors',
    invitations: 'Invitations',
    'pending/rejected': 'Pending / Rejected',
    submit: 'Submit',
    reportAvailabilityDate: 'Report availability date',
    notificationsPage: {
      pgx: {
        doctorTitle: 'Registration of the test Pharmacogenetic analysis CNS Pgx kit with serial number',
        doctorText: 'asks for your consent to perform the test Pharmacogenetic analysis CNS PGx kit of the company iDNA Genomics and the receipt of the corresponding report of results.',
        doctorReportTitle: 'Report of test results Pharmacogenetic analysis CNS PGx kit',
        doctorReportText: 'The Report results of the test Pharmacogenetic analysis CNS Pgx kit',
        doctorReportText1: 'with serial number',
        doctorReportText2: ',is available in your personal folder.',
        request: 'Consent Request',
        accept: 'Accept Consent',
        reject: 'Reject Consent',
        requestKit: 'The request for the Kit',
        send: 'has been send',
        doctor: 'Doctor',
        acceptConsent: 'has given consent to perform the test Pharmacogenetic analysis CNS PGx kit with serial number',
        rejectConsent: 'has not given consent to perform the test Pharmacogenetic analysis CNS PGx kit with serial number',
        order: 'which you have ordered.',
        accept1: 'Consent Acceptance',
        reject1: 'Refusal of Consent',
      },
      healthcare: {
        doctorTitle: 'Invitation from',
        doctorText: 'has sent an invitation to access his/her personal file in MyEMR of iDNA Genomics',
        request: 'Monitoring Request',
        accept: 'Accept Follow-up',
        doctorReportText1: 'with serial number',
        reject: 'Reject Follow-up',
        requestKit: 'The request for the Kit',
        send: 'has been send',
        doctor: 'HealthCare Professional',
        acceptConsent: 'has accepted your invitation to access your personal folder in the iDNA Genomics service for the serial number',
        rejectConsent: 'does not accept your invitation to access your personal folder in the iDNA Genomics service for the serial number',
      },
    },
    accepted: 'Accepted',
    'Λίστα ασθενών / πελατών': 'List of patients / clients',
    'Λίστα ασθενών': 'List of patients',
    rejected: 'Rejected',
    'On hold': 'On hold',
    bioAgeQuestion10Title: '10. Date of blood test results',
    bioAgeQuestion11Info1: 'This section of Poll uses a question table.',
    inAllResults: 'In the indications of normal values ​​for which',
    noRange: 'there is no indication',
    fillDash: 'fill with a dash (-).',
    bioAgeQuestion11Title: '11. Hematological Data',
    hematologicalResults: 'Results with decimal expression (.)',
    hematologicalNormal: 'Normal Values (from - to)',
    albumin: 'Albumin (g/dL):',
    alkalinePhos: 'Alkaline phosphatase (U / L):',
    creatinine: 'Creatinine (mg / dL):',
    cProtein: 'C-reactive protein (CRP) (mg / L):',
    'No records': 'No records',
    '1 record': '1 record',
    from: 'from',
    records: 'records',
    cProteinInfo: 'C-reactive protein (CRP) (mg / L): If your result is in mg / dL,then multiply the value and the limits x 10 (eg 0.13 x 10 = 1.3).',
    sugar: 'Sugar (mg/dL):',
    lemfokytes: 'Lymphocytes (%):',
    lemfokytesInfo: 'Lymphocytes (%): For lymphocytes fill in the test result with %.Typical value range is 20-45%.',
    volumeReds: 'Average volume of reds (fL):',
    redDistribution: 'Red cells distribution range (RDW) (%):',
    redDistributionInfo: 'Red cell distribution range (RDW) (%): Fill in the result of exams at with a rate of %. Typical value range is 11-15%.',
    whiteCells: 'White blood cells (k * 10 ^ 3 / μL):',
    hemoglobin: 'Hemoglobin (g / dL):',
    hematocrit: 'Hematocrit (%):',
    biAgeQuestion12Title: '12.Have you done a biological iDNA test again?',
    age: 'Age',
    'Book a phone appointment with our scientific team to explain the personalized results report.': 'Book a phone appointment with our scientific team to explain the personalized results report.',
    biAgeQuestion12Info: '*If yes, please fill in your results, starting from the most recent measurement:',
    date: 'Date',
    bioAgeFromLbl: 'From',
    bioAgeToLbl: 'To',
    bioAgeValueLbl: 'Value',
    gdprConsent: 'I explicitly give my consent to the collection and processing of my personal data concerning special categories of data (genetic, health) for the purpose of conducting the Pharmacogenetic analysis by iDNA Laboratories.',
    validation: {
      requiredField: 'This field is required',
      requiredPass: 'Please enter your password',
      passwordError: 'The password must consist of at least 8  characters,  1 uppercase letter, 1 lowercase letter, 1 number and 1 special character',
      atLeast: 'Must be at least',
      noMore: 'Cannot be more than',
      atMost10Characters: 'Cannot be more than 10 characters',
      elevenChars: 'Must be 11 characters',
      nineChars: 'Must be 9 digits',
      characters: 'characters',
      emailNoValid: 'A valid email address is required',
      hasNumber: 'Must contain at least one number',
      hasNumberOrDash: 'Must contain at least one number or dash',
      lowercase: 'Must contain at least one lowercase',
      uppercase: 'Must contain at least one uppercase',
      specialChar: 'Must contain at least one special character',
      phoneNumberNoValid: 'Invalid phone number',
      dateNoValid: 'Invalid date',
      genderNoValid: 'Invalid value for gender',
      childCantBeAdult: 'The minor must be under 18 years of age.',
    },
    inviteADoctor: 'Invite A Doctor',
    pgxAccept: 'A statement of concent is required',
    consentSelectOption: 'Please make a selection',

    'Βαθμολογία PRS': 'PRS Score',
    'Βαθμολογία εκτίμησης τρέχουσας κατάστασης καρδιαγγειακής υγείας': 'Current cardiovascular health status',
    'επί του πληθυσμού. Αυτό σημαίνει ότι σε κάθε 100 άτομα, το εκτιμώμενο δικό σου PRS είναι υψηλότερο από {{prsScore}} άτομα και ίδιο ή χαμηλότερο από τα υπόλοιπα {{prsScore100}} άτομα. Επομένως, το γενετικό σου υπόβαθρο σε θέτει σε': 'relative to the population. This means that for every 100 people, your estimated risk is higher than {{prsScore}} individuals and the same or lower than the other {{prsScore100}} individuals. Therefore, your genetic background places you at',
    'Η βαθμολογία PRS είναι': 'Your PRS is',
    'ρίσκο εμφάνισης της πάθησης': 'risk of developing the disease',
    'Βαθμολογία πολυγονιδιακού ρίσκου': 'Polygenic Risk Score',
    'Το Προσαρμοσμένο PRS (Adjusted PRS) εκτιμάται ότι είναι': 'Your adjusted PRS is estimated to be',
    δηλαδή: 'which is',
    'σε σχέση με την βαθμολογία του PRS και βρίσκεται σε': 'compared to the PRS and is at',
    επίπεδα: 'levels',
    επίπεδαEL: '',
    'ρίσκου σε σχέση με το γενικό πληθυσμό. Η τήρηση υγιεινών συνηθειών και η συμμόρφωση με τις οδηγίες του γιατρού σου, μπορεί να συμβάλουν στη βέλτιστη καρδιαγγειακή υγεία και στην πρόληψη καρδιαγγειακών παθήσεων.': 'risk relative to the general population.  Maintaining healthy habits and following your doctor\'s recommendations can contribute to optimal cardiovascular health and the prevention of cardiovascular diseases.',
    'Η κολπική μαρμαρυγή είναι ένας ακανόνιστος και συχνά πολύ γρήγορος καρδιακός ρυθμός (αρρυθμία) που μπορεί να οδηγήσει σε θρόμβους στην καρδιά. Για πολλούς ανθρώπους, η κολπική μαρμαρυγή μπορεί να μην έχει συμπτώματα, ωστόσο μπορεί να προκαλέσει ταχυκαρδία, δύσπνοια ή αδυναμία. Τα επεισόδια κολπικής μαρμαρυγής μπορεί να έρχονται και να παρέρχονται ή μπορεί να είναι επίμονα.': 'Atrial fibrillation is an irregular and often very rapid heart rhythm (arrhythmia) that can lead to blood clots in the heart. For many people, atrial fibrillation may have no symptoms, but it may cause a fast, pounding heartbeat (palpitations), shortness of breath or weakness. Atrial fibrillation episodes can be occasional (symptoms come and go) or persistent.',
    τυπικά: 'intermediate',
    μειωμένο: 'low',
    αυξημένο: 'high',
    Τυπική: 'Intermediate',
    Υψηλή: 'High',
    Βέλτιστη: 'Ideal',
    Mειωμένη: 'Poor',
    τυπικό: 'intermediate',
    'Η στεφανιαία νόσος αναπτύσσεται όταν οι στεφανιαίες αρτηρίες, δηλαδή τα κύρια αιμοφόρα αγγεία που τροφοδοτούν την καρδιά με αίμα πλούσιο σε οξυγόνο, δυσλειτουργούν. Η αθηροσκλήρωση που προκαλείται από  τις εναποθέσεις (αθηρωματικές πλάκες) που περιέχουν χοληστερόλη και η φλεγμονή που προκαλούν στις στεφανιαίες αρτηρίες, ευθύνεται συνήθως για τη στεφανιαία νόσο. Στην ηλικία των 50 ετών, περίπου το 5% των ατόμων αναπτύσσει στεφανιαία νόσο, ενώ στην ηλικία των 80 ετών το ποσοστό εμφάνισης της νόσου αγγίζει το 25%.': 'Coronary artery disease develops when the coronary arteries, which are the main blood vessels that supply the heart with oxygen-rich blood, malfunction. Atherosclerosis caused by the deposits (atheromatous plaque) containing cholesterol and the inflammation they cause in coronary arteries, is usually responsible for coronary heart disease. At the age of 50, about 5% of people develop coronary artery disease, while at the age of 80 the incidence of the disease reaches 25%.',
    'Ένα επεισόδιο συμβαίνει όταν διακόπτεται ή μειώνεται η παροχή αίματος σε μέρος του εγκεφάλου, εμποδίζοντας με αυτό τον τρόπο τον εγκεφαλικό ιστό να πάρει οξυγόνο και θρεπτικά συστατικά. Αποτελεί μια επείγουσα ιατρική κατάσταση της οποίας έγκαιρη αντιμετώπιση είναι ζωτικής σημασίας.': 'An ischemic stroke occurs when the blood supply to part of the brain is interrupted or reduced, preventing brain tissue from getting oxygen and nutrients. It is a medical emergency for which early treatment is vital.',
    'Η υπερτροφική μυοκαρδιοπάθεια είναι μια ασθένεια κατά την οποία ο καρδιακός μυς γίνεται αφύσικα παχύς (υπερτροφικός) και μπορεί να δυσκολέψει την καρδιά να αντλήσει αίμα. Η υπερτροφική μυοκαρδιοπάθεια συχνά μένει αδιάγνωστη επειδή η πλειοψηφία των ανθρώπων με τη νόσο έχουν λίγα, ή και καθόλου, συμπτώματα και μπορούν να ζήσουν μια φυσιολογική ζωή χωρίς σημαντικά προβλήματα. Ωστόσο, σε έναν μικρό αριθμό ατόμων, ο παχύς καρδιακός μυς μπορεί να προκαλέσει δύσπνοια, πόνο στο στήθος ή προβλήματα στο ηλεκτρικό σύστημα της καρδιάς, με αποτέλεσμα απειλητικούς για τη ζωή μη φυσιολογικούς καρδιακούς ρυθμούς (αρρυθμίες).': 'Hypertrophic cardiomyopathy is a disease in which the heart muscle becomes thickened (hypertrophied). The thickened heart muscle can make it harder for the heart to pump blood. Hypertrophic cardiomyopathy often goes undiagnosed because many people with the disease have few, if any, symptoms and can have a normal life without health issues. However, in a small number of people, the thickened heart muscle can cause shortness of breath, chest pain or changes in the heart\'s electrical system, resulting in life-threatening irregular heart rhythms (arrhythmias) or sudden death.',
    'Η καρδιακή ανεπάρκεια (δυσλειτουργία του μυοκαρδίου) εμφανίζεται όταν ο καρδιακός μυς αδυνατεί να κυκλοφορήσει την απαιτούμενη ποσότητα αίματος που χρειάζεται το σώμα. Όταν συμβαίνει αυτό, υγρό μπορεί να συσσωρευτεί στους πνεύμονες, προκαλώντας δύσπνοια. Ένας τρόπος πρόληψης της καρδιακής ανεπάρκειας είναι ο έλεγχος καταστάσεων που μπορεί να την προκαλέσουν, όπως η στεφανιαία νόσος, η υψηλή αρτηριακή πίεση, ο διαβήτης και η παχυσαρκία.': 'Heart failure (myocardial dysfunction) occurs when the heart muscle becomes unable to circulate the required amount of blood that the body needs. When this happens, blood often backs up and fluid can build up in the lungs, causing shortness of breath. One way to prevent heart failure is to prevent and control conditions that can cause it, such as coronary artery disease, high blood pressure, diabetes and obesity.',
    'Η μυοκαρδιοπάθεια είναι μια ασθένεια του καρδιακού μυός που δυσκολεύει την καρδιά να μεταφέρει αίμα στο υπόλοιπο σώμα και μπορεί να οδηγήσει σε καρδιακή ανεπάρκεια. Η διατατική μυοκαρδιοπάθεια είναι ένας τύπος καρδιακής μυϊκής νόσου που προκαλεί τους θαλάμους της καρδιάς (κοιλίες) να λεπταίνουν και να τεντώνονται, και άρα να μεγαλώνουν. Ως αποτέλεσμα, δυσκολεύει την καρδιά να αντλεί αίμα στο υπόλοιπο σώμα. Ένα άτομο με διατατική μυοκαρδιοπάθεια μπορεί να μην παρατηρήσει κανένα σύμπτωμα στην αρχή, ενώ κοινά συμπτώματα, όπως η κόπωση και η δύσπνοια, μπορεί να μιμούνται άλλες νόσους. Η διατατική μυοκαρδιοπάθεια είναι μια κοινή αιτία καρδιακής ανεπάρκειας και μπορεί να γίνει απειλητική για τη ζωή.': 'Cardiomyopathy is a disease of the heart muscle that makes it difficult for the heart to pump blood to the rest of the body and it can lead to heart failure. Dilated cardiomyopathy is a type of heart muscle disease that causes the heart\'s chambers (ventricles) to thin and stretch, and therefore enlarge. As a result, it makes it harder for the heart to pump blood to the rest of the body. There may be no symptoms in the early stages of dilated cardiomyopathy, whereas common symptoms such as shortness of breath and fatigue may mimic other disorders. Dilated cardiomyopathy is a common cause of heart failure and can become life-threatening.',
    'Με το παρειακό επίχρισμα που λάβαμε από εσένα, πραγματοποιήθηκε γενετική ανάλυση για τον εντοπισμό των παραλλαγών ως προς τους πολυμορφισμούς που υπάρχουν στο DNA σου. Κάθε παραλλαγή αντιστοιχεί σε διαφοροποιημένη γονιδιακή λειτουργία και συσχετίζεται με διαφοροποιημένη προδιάθεση. Με βάση το γονότυπό σου υπολογίστηκε το PRS σου για κάθε καρδιαγγειακή πάθηση.': 'With the buccal swab that we received from you, genetic analysis was performed to identify the Single Nucleotide Polymorphism (SNP) variants present in your DNA. Each variant corresponds to differential gene function and is associated with differential predisposition to disease. Based on your genotype, your PRS for each cardiovascular condition was calculated.',
    'Με τη συμπλήρωση του ερωτηματολογίου* διερευνήθηκαν τα χαρακτηριστικά του τρόπου ζωής και του φαινοτύπου σου (διατροφικές συνήθειες, επίπεδο σωματικής άσκησης, κάπνισμα, δείκτης μάζας σώματος, αρτηριακή πίεση, ολική χοληστερόλη και σάκχαρο) και αξιολογήθηκε η τωρινή σου κατάσταση καρδιαγγειακής υγείας. Με βάση την κατηγοριοποίηση καρδιαγγειακής υγείας και την ηλικία σου, και σε συνδυασμό με το PRS σου, υπολογίστηκε το Προσαρμοσμένο PRS σου για κάθε πάθηση υπό εξέταση.': 'By completing the questionnaire*, your lifestyle and phenotypic characteristics (dietary habits, level of physical exercise, smoking habits, body mass index, blood pressure, total cholesterol and blood glucose) were investigated and your current cardiovascular health status was assessed. Based on your cardiovascular health classification and age, and in combination with your PRS, your Adjusted PRS was calculated for each condition under investigation.',
    'Συμπλήρωση Eρωτηματολογίου': 'Questionnaire',
    'Γενετική Ανάλυση': 'Genetic analysis',
    'Βαθμολογία Πολυγονιδιακού Ρισκου': 'Polygenic Risk Score',
    'Το PRS λαμβάνει υπόψη πλήθος γενετικών πολυμορφισμών (SNPs) για την εκτίμηση του γενετικού ρίσκου για ανάπτυξη μιας συγκεκριμένης πάθησης. Κάθε γενετικός πολυμορφισμός μπορεί να είναι προστατευτικός ή προδιαθεσικός, ενώ από μόνος του τείνει να συμβάλλει σε μικρό βαθμό στο ρίσκο εμφάνισης μίας πάθησης. Αθροιστικά όμως, αυτές οι μικρές γενετικές διαφορές μπορεί να έχουν σημαντικά μεγαλύτερο αντίκτυπο. Συνεπώς, το PRS είναι ένα σταθμισμένο άθροισμα του αριθμού των αλληλομόρφων ρίσκου που φέρει ένα άτομο. Τόσο τα αλληλόμορφα ρίσκου όσο και η βαρύτητά τους καθορίζονται από τις επιδράσεις τους, όπως αυτές ανιχνεύονται σε δημοσιευμένες μελέτες γενετικής συσχέτισης (Genome Wide Association Studies - GWAS).': 'The PRS takes into account a number of genetic polymorphisms (SNPs) to estimate the genetic risk for developing a particular condition. Each genetic polymorphism can be either protective or predisposing, while on its own it tends to contribute little to the overall risk of developing a condition. However, cumulatively these small genetic differences can have a significantly larger impact. Therefore, the PRS is a weighted sum of the number of risk alleles carried by an individual. Both the risk alleles and their weights are determined by their measured effects as detected in published Genome Wide Association Studies (GWAS).',
    'Προσαρμοσμένη Βαθμολογία Πολυγονιδιακού Ρισκου (Adjusted PRS)': 'Adjusted PRS',
    'Το Προσαρμοσμένο PRS εκτιμά δυναμικά το συνδυαστικό ρίσκο εμφάνισης καρδιαγγειακών παθήσεων, συνεκτιμώντας χαρακτηριστικά του τρόπου ζωής και του φαινοτύπου, μέσω εγκεκριμένου ερωτηματολογίου καρδιαγγειακής υγείας*. Συγκεκριμένα, εξετάζει τις διατροφικές συνήθειες, το επίπεδο σωματικής άσκησης, το κάπνισμα, το δείκτη μάζας σώματος (Body Mass Index - BMI), την αρτηριακή πίεση, την ολική χοληστερόλη και το σάκχαρο, για να προσαρμόσει το PRS και να εκτιμήσει το ρίσκο με βάση την ηλικία και την τρέχουσα κατάσταση καρδιαγγειακής υγείας του ατόμου. Ενώ το PRS υπολογίζεται μία φορά και είναι απαράλλαχτο σε όλη τη διάρκεια της ζωής, το Προσαρμοσμένο PRS μπορεί να υπολογιστεί πολλές φορές στη διάρκεια της ζωής με βάση την εκάστοτε κατάσταση του τρόπου ζωής και του φαινοτύπου του ατόμου.': 'The Adjusted PRS dynamically estimates the combined risk of cardiovascular disease, taking into account lifestyle and phenotypic characteristics, through a validated cardiovascular health questionnaire*. Specifically, it examines dietary habits, level of physical activity, smoking, body mass index (BMI), blood pressure, total cholesterol and blood glucose to adjust the PRS and estimate risk based on the individual\'s age and current cardiovascular health status. While the PRS is calculated once and is constant throughout life, the Adjusted PRS can be calculated multiple times over the lifetime based on the individual\'s current lifestyle and phenotype.',
    'Παρακαλώ απαντήστε την ερώτηση.': 'Please answer the question.',

    cvd_answer_1_1: 'White or Caucasian',
    cvd_answer_1_2: 'Asian',
    cvd_answer_1_3: 'Black/African-American',
    cvd_answer_1_4: 'Hispanic/Latin',
    cvd_answer_1_5: 'Arab',
    cvd_answer_1_6: 'Mixed',
    cvd_answer_1_7: 'Other',
    cvd_answer_1_8: 'I prefer not to answer',
    cvd_answer_2_1: 'Current smoker',
    cvd_answer_2_2: 'Former smoker, quitted less than 12 months ago',
    cvd_answer_2_3: 'Former smoker, quitted more than 12 months ago',
    cvd_answer_2_4: 'Never smoked',
    cvd_answer_7_1: '4,5 or more cups',
    cvd_answer_7_2: 'Less than 4,5 cups',
    cvd_answer_8_1: 'Less than 3 servings',
    cvd_answer_8_2: '3 or more servings',
    cvd_answer_9_1: 'Less than 3',
    cvd_answer_9_2: '3 or more',
    cvd_answer_10_1: 'Less than 2 servings',
    cvd_answer_10_2: '2 or more servings',
    cvd_answer_11_1: 'I consume less than 1/3 tsp of salt daily',
    cvd_answer_11_2: 'I consume more than 1/3 tsp of salt daily',
    cvd_answer_14_1: 'Yes',
    cvd_answer_14_2: 'No',
    cvd_answer_16_1: 'Yes',
    cvd_answer_16_2: 'No',
    cvd_answer_18_1: 'Yes',
    cvd_answer_18_2: 'No',

    doc_cvd_answer_1_1: 'White or Caucasian',
    doc_cvd_answer_1_2: 'Asian',
    doc_cvd_answer_1_3: 'Black/African-American',
    doc_cvd_answer_1_4: 'Hispanic/Latin',
    doc_cvd_answer_1_5: 'Arab',
    doc_cvd_answer_1_6: 'Mixed',
    doc_cvd_answer_1_7: 'Other',
    doc_cvd_answer_1_8: 'I prefer not to answer',
    doc_cvd_answer_2_1: 'Current smoker',
    doc_cvd_answer_2_2: 'Former smoker, quitted less than 12 months ago',
    doc_cvd_answer_2_3: 'Former smoker, quitted more than 12 months ago',
    doc_cvd_answer_2_4: 'Never smoked',
    doc_cvd_answer_7_1: '4,5 or more cups',
    doc_cvd_answer_7_2: 'Less than 4,5 cups',
    doc_cvd_answer_8_1: 'Less than 3 servings',
    doc_cvd_answer_8_2: '3 or more servings',
    doc_cvd_answer_9_1: 'Less than 3',
    doc_cvd_answer_9_2: '3 or more',
    doc_cvd_answer_10_1: 'Less than 2 servings',
    doc_cvd_answer_10_2: '2 or more servings',
    doc_cvd_answer_11_1: 'My patient/client consumes less than 1/3tsp of salt daily',
    doc_cvd_answer_11_2: 'My patient/client consumes more than 1/3tsp of salt daily',
    doc_cvd_answer_14_1: 'Yes',
    doc_cvd_answer_14_2: 'No',
    doc_cvd_answer_16_1: 'Yes',
    doc_cvd_answer_16_2: 'No',
    doc_cvd_answer_18_1: 'Yes',
    doc_cvd_answer_18_2: 'No',

    child_cvd_answer_1_1: 'White or Caucasian',
    child_cvd_answer_1_2: 'Asian',
    child_cvd_answer_1_3: 'Black/African-American',
    child_cvd_answer_1_4: 'Hispanic/Latin',
    child_cvd_answer_1_5: 'Arab',
    child_cvd_answer_1_6: 'Mixed',
    child_cvd_answer_1_7: 'Other',
    child_cvd_answer_1_8: 'I prefer not to answer',
    child_cvd_answer_2_1: 'Current smoker',
    child_cvd_answer_2_2: 'Former smoker, quitted less than 12 months ago',
    child_cvd_answer_2_3: 'Former smoker, quitted more than 12 months ago',
    child_cvd_answer_2_4: 'Never smoked',
    child_cvd_answer_7_1: '4,5 or more cups',
    child_cvd_answer_7_2: 'Less than 4,5 cups',
    child_cvd_answer_8_1: 'Less than 3 servings',
    child_cvd_answer_8_2: '3 or more servings',
    child_cvd_answer_9_1: 'Less than 3',
    child_cvd_answer_9_2: '3 or more',
    child_cvd_answer_10_1: 'Less than 2 servings',
    child_cvd_answer_10_2: '2 or more servings',
    child_cvd_answer_11_1: 'Your child consumes less than 1/3 teaspoon of salt per day',
    child_cvd_answer_11_2: 'Your child consumes more than 1/3 teaspoon of salt per day',
    child_cvd_answer_14_1: 'Yes',
    child_cvd_answer_14_2: 'No',
    child_cvd_answer_16_1: 'Yes',
    child_cvd_answer_16_2: 'No',
    child_cvd_answer_18_1: 'Yes',
    child_cvd_answer_18_2: 'No',

    bi_answer_1_1: 'White or Caucasian',
    bi_answer_1_2: 'Asian',
    bi_answer_1_3: 'Black/African-American',
    bi_answer_1_4: 'Hispanic/Latin',
    bi_answer_1_5: 'Arab',
    bi_answer_1_6: 'Mixed',
    bi_answer_1_7: 'Other',
    bi_answer_1_8: 'I prefer not to answer',
    bi_answer_4_1: 'Yes',
    bi_answer_4_2: 'No',
    bi_answer_5_1: 'Almost non-existent',
    bi_answer_5_2: 'Moderate',
    bi_answer_5_3: 'Very good',
    bi_answer_6_1: 'Yes',
    bi_answer_6_2: 'No',
    bi_answer_20_1: 'Yes',
    bi_answer_20_2: 'No',

    doc_bi_answer_1_1: 'White or Caucasian',
    doc_bi_answer_1_2: 'Asian',
    doc_bi_answer_1_3: 'Black/African-American',
    doc_bi_answer_1_4: 'Hispanic/Latin',
    doc_bi_answer_1_5: 'Arab',
    doc_bi_answer_1_6: 'Mixed',
    doc_bi_answer_1_7: 'Other',
    doc_bi_answer_1_8: 'I prefer not to answer',
    doc_bi_answer_4_1: 'Yes',
    doc_bi_answer_4_2: 'No',
    doc_bi_answer_5_1: 'Almost non-existent',
    doc_bi_answer_5_2: 'Moderate',
    doc_bi_answer_5_3: 'Very good',
    doc_bi_answer_6_1: 'Yes',
    doc_bi_answer_6_2: 'No',
    doc_bi_answer_20_1: 'Yes',
    doc_bi_answer_20_2: 'No',

    ng_answer_1_1: 'Diet for weight loss / Obesity management',
    ng_answer_1_2: 'Diet for weight gain',
    ng_answer_1_3: 'Diet for weight maintenance',
    ng_answer_1_4: 'Nutrition during pregnancy',
    ng_answer_1_5: 'Nutrition during breastfeeding',
    ng_answer_1_6: 'Sports nutrition',
    ng_answer_1_7: 'Nutritional management of metabolic syndrome',
    ng_answer_1_8: 'Nutritional management of cardiovascular diseases (hypertension, dyslipidemia, atherosclerosis, coronary artery disease, infarction, etc.)',
    ng_answer_1_9: 'Nutritional management of Type 2 Diabetes Mellitus',
    ng_answer_2_1: 'Light',
    ng_answer_2_2: 'Moderate',
    ng_answer_2_3: 'Intense',
    ng_answer_3_1: 'Light',
    ng_answer_3_2: 'Moderate',
    ng_answer_3_3: 'Intense',
    ng_answer_4_1: 'I don\'t have a known medical history',
    ng_answer_4_2: 'Nephropathy',
    ng_answer_4_3: 'Diabetes Mellitus',
    ng_answer_4_4: 'Iron deficiency anemia (low iron)',
    ng_answer_4_5: 'Cardiovascular diseases',
    ng_answer_4_6: 'Hypercholesterolemia',
    ng_answer_4_7: 'Megaloblastic anemia (low B9, B12)',
    ng_answer_4_8: 'Hypertension',
    ng_answer_4_9: 'Diseases of the digestive tract, please specify',
    ng_answer_4_10: 'Other, please specify',
    ng_answer_5_1: 'I am not taking any medication',
    ng_answer_5_2: 'Antihypertensive drugs',
    ng_answer_5_3: 'Statins or other drugs for hypercholesterolemia ',
    ng_answer_5_4: 'Antidiabetic drugs',
    ng_answer_5_5: 'Other, please specify',
    ng_answer_6_1: 'I am not taking any supplements',
    ng_answer_6_2: 'Multivitamin',
    ng_answer_6_3: 'Vitamin A',
    ng_answer_6_4: 'Vitamin C',
    ng_answer_6_5: 'Vitamin D',
    ng_answer_6_6: 'Vitamin E',
    ng_answer_6_7: 'B complex',
    ng_answer_6_8: 'Calcium',
    ng_answer_6_9: 'Iron',
    ng_answer_6_10: 'Magnesium',
    ng_answer_6_11: 'Omega-3 fat/cod liver oil',
    ng_answer_6_12: 'Coenzyme Q-10',
    ng_answer_6_13: 'Other, please specify',
    ng_answer_9_1: 'Yes',
    ng_answer_9_2: 'No',
    ng_answer_12_1: 'No, I don\'t follow any specific diet',
    ng_answer_12_2: 'Mediterranean diet',
    ng_answer_12_3: 'Vegetarian diet',
    ng_answer_12_4: 'Lacto-vegetarian diet',
    ng_answer_12_5: 'Ovo-vegetarian diet',
    ng_answer_12_6: 'Lacto-ovo-vegetarian diet',
    ng_answer_12_7: 'Lacto-ovo-pesco-vegetarian diet',
    ng_answer_12_8: 'Strict vegetarianism (veganism)',
    ng_answer_12_9: 'Other, please specify',

    ng_answer_13_1: 'None',
    ng_answer_13_2: 'Milk',
    ng_answer_13_3: 'Yoghurt',
    ng_answer_13_4: 'Yellow cheese',
    ng_answer_13_5: 'Feta cheese',
    ng_answer_13_6: 'Pudding',
    ng_answer_13_7: 'Rice pudding',
    ng_answer_13_8: 'Fruit juice',
    ng_answer_13_9: 'Honey',
    ng_answer_13_10: 'Jam',
    ng_answer_13_11: 'Peanut butter',
    ng_answer_13_12: 'Margarine',
    ng_answer_13_13: 'Butter',
    ng_answer_13_14: 'Tahini',
    ng_answer_13_15: 'Toasted bread',
    ng_answer_13_16: 'Cereals',
    ng_answer_13_17: 'Oats',
    ng_answer_13_18: 'Almonds',
    ng_answer_13_19: 'Hazelnuts',
    ng_answer_13_20: 'Walnuts',
    ng_answer_13_21: 'Cashews',
    ng_answer_13_22: 'Cereal bar',
    ng_answer_13_23: 'Sesame candy',
    ng_answer_13_24: 'Egg',
    ng_answer_13_25: 'Egg white',
    ng_answer_13_26: 'Omelet',

    ng_answer_14_1: 'None',
    ng_answer_14_2: 'Lamb',
    ng_answer_14_3: 'Goat',
    ng_answer_14_4: 'Pork',
    ng_answer_14_5: 'Ham',
    ng_answer_14_6: 'Chicken',
    ng_answer_14_7: 'Turkey',
    ng_answer_14_8: 'Beef',
    ng_answer_14_9: 'Salmon',
    ng_answer_14_10: 'Sea bass',
    ng_answer_14_11: 'Sea bream',
    ng_answer_14_12: 'Porgy',
    ng_answer_14_13: 'Perch',
    ng_answer_14_14: 'Sole',
    ng_answer_14_15: 'Sardines',
    ng_answer_14_16: 'Anchovies',
    ng_answer_14_17: 'Tuna',

    ng_answer_15_1: 'None',
    ng_answer_15_2: 'Vegetables in tomato sauce',
    ng_answer_15_3: 'Legumes',
    ng_answer_15_4: 'Rice',
    ng_answer_15_5: 'Bulgur',
    ng_answer_15_6: 'Quinoa',
    ng_answer_15_7: 'Buckwheat',
    ng_answer_15_8: 'Pasta',
    ng_answer_15_9: 'Bread',
    ng_answer_15_10: 'Rusk',
    ng_answer_15_11: 'Potato',
    ng_answer_15_12: 'Sweet potato',
    ng_answer_15_13: 'Rice cakes',
    ng_answer_15_14: 'Corn',

    ng_answer_16_1: 'None',
    ng_answer_16_2: 'Green salad',
    ng_answer_16_3: 'Courgetti',
    ng_answer_16_4: 'Aubergine',
    ng_answer_16_5: 'Tomato salad',
    ng_answer_16_6: 'Spinach',
    ng_answer_16_7: 'Broccoli',
    ng_answer_16_8: 'Cauliflower',
    ng_answer_16_9: 'Banana',
    ng_answer_16_10: 'Apple',
    ng_answer_16_11: 'Pear',
    ng_answer_16_12: 'Kiwi',
    ng_answer_16_13: 'Orange',
    ng_answer_16_14: 'Tangerine',
    ng_answer_16_15: 'Melon',
    ng_answer_16_16: 'Watermelon',
    ng_answer_16_17: 'Apricot',
    ng_answer_16_18: 'Peach',
    ng_answer_16_19: 'Cranberries',
    ng_answer_16_20: 'Blueberries',

    ng_answer_20_1: 'At all',
    ng_answer_20_2: 'Seldom',
    ng_answer_20_3: 'Sometimes',
    ng_answer_20_4: 'Often',
    ng_answer_20_5: 'Always',
    ng_answer_21_1: 'At all',
    ng_answer_21_2: 'Seldom',
    ng_answer_21_3: 'Sometimes',
    ng_answer_21_4: 'Often',
    ng_answer_21_5: 'Always',
    ng_answer_23_1: '0 - 4 tablespoons',
    ng_answer_23_2: '> 4 tsp. Soup',
    ng_answer_24_1: '0 - 2',
    ng_answer_24_2: '> 2',
    ng_answer_25_1: '0 - 3',
    ng_answer_25_2: '> 3',
    ng_answer_26_1: '0 - 1',
    ng_answer_26_2: '> 1',
    ng_answer_27_1: '0 - 1',
    ng_answer_27_2: '> 1',
    ng_answer_28_1: '0 - 1',
    ng_answer_28_2: '> 1',
    ng_answer_29_1: '0 - 3',
    ng_answer_29_2: '> 3',
    ng_answer_30_1: '0 - 3',
    ng_answer_30_2: '> 3',
    ng_answer_31_1: '0 - 3',
    ng_answer_31_2: '> 3',
    ng_answer_32_1: 'Never',
    ng_answer_32_2: 'Rarely',
    ng_answer_32_3: 'Sometimes',
    ng_answer_32_4: 'Often',
    ng_answer_32_5: 'Always',
    ng_answer_33_1: 'Never',
    ng_answer_33_2: 'Rarely',
    ng_answer_33_3: 'Sometimes',
    ng_answer_33_4: 'Often',
    ng_answer_33_5: 'Always',
    ng_answer_34_1: 'Never',
    ng_answer_34_2: 'Rarely',
    ng_answer_34_3: 'Sometimes',
    ng_answer_34_4: 'Often',
    ng_answer_34_5: 'Always',
    ng_answer_35_1: 'White or Caucasian',
    ng_answer_35_2: 'Asian',
    ng_answer_35_3: 'Black/African American',
    ng_answer_35_4: 'Hispanic/Latino',
    ng_answer_35_5: 'Arabic',
    ng_answer_35_6: 'Mixed',
    ng_answer_35_7: 'Other',
    ng_answer_35_8: 'I prefer not to respond',

    child_ng_answer_1_1: 'Diet for weight loss / Obesity management',
    child_ng_answer_1_2: 'Diet for weight gain',
    child_ng_answer_1_3: 'Diet for weight maintenance',
    child_ng_answer_1_4: 'Nutrition during pregnancy',
    child_ng_answer_1_5: 'Nutrition during breastfeeding',
    child_ng_answer_1_6: 'Sports nutrition',
    child_ng_answer_1_7: 'Nutritional management of metabolic syndrome',
    child_ng_answer_1_8: 'Nutritional management of cardiovascular diseases (hypertension, dyslipidemia, atherosclerosis, coronary artery disease, infarction, etc.)',
    child_ng_answer_1_9: 'Nutritional management of Type 2 Diabetes Mellitus',
    child_ng_answer_2_1: 'Light',
    child_ng_answer_2_2: 'Moderate',
    child_ng_answer_2_3: 'Intense',
    child_ng_answer_3_1: 'Light',
    child_ng_answer_3_2: 'Moderate',
    child_ng_answer_3_3: 'Intense',
    child_ng_answer_4_1: 'I don\'t have a known medical history',
    child_ng_answer_4_2: 'Nephropathy',
    child_ng_answer_4_3: 'Diabetes Mellitus',
    child_ng_answer_4_4: 'Iron deficiency anemia (low iron)',
    child_ng_answer_4_5: 'Cardiovascular diseases',
    child_ng_answer_4_6: 'Hypercholesterolemia',
    child_ng_answer_4_7: 'Megaloblastic anemia (low B9, B12)',
    child_ng_answer_4_8: 'Hypertension',
    child_ng_answer_4_9: 'Diseases of the digestive tract, please specify',
    child_ng_answer_4_10: 'Other, please specify',
    child_ng_answer_5_1: 'I am not taking any medication',
    child_ng_answer_5_2: 'Antihypertensive drugs',
    child_ng_answer_5_3: 'Statins or other drugs for hypercholesterolemia ',
    child_ng_answer_5_4: 'Antidiabetic drugs',
    child_ng_answer_5_5: 'Other, please specify',
    child_ng_answer_6_1: 'I am not taking any supplements',
    child_ng_answer_6_2: 'Multivitamin',
    child_ng_answer_6_3: 'Vitamin A',
    child_ng_answer_6_4: 'Vitamin C',
    child_ng_answer_6_5: 'Vitamin D',
    child_ng_answer_6_6: 'Vitamin E',
    child_ng_answer_6_7: 'B complex',
    child_ng_answer_6_8: 'Calcium',
    child_ng_answer_6_9: 'Iron',
    child_ng_answer_6_10: 'Magnesium',
    child_ng_answer_6_11: 'Omega-3 fat/cod liver oil',
    child_ng_answer_6_12: 'Coenzyme Q-10',
    child_ng_answer_6_13: 'Other, please specify',
    child_ng_answer_9_1: 'Yes',
    child_ng_answer_9_2: 'No',
    child_ng_answer_12_1: 'No, I don\'t follow any specific diet',
    child_ng_answer_12_2: 'Mediterranean diet',
    child_ng_answer_12_3: 'Vegetarian diet',
    child_ng_answer_12_4: 'Lacto-vegetarian diet',
    child_ng_answer_12_5: 'Ovo-vegetarian diet',
    child_ng_answer_12_6: 'Lacto-ovo-vegetarian diet',
    child_ng_answer_12_7: 'Lacto-ovo-pesco-vegetarian diet',
    child_ng_answer_12_8: 'Strict vegetarianism (veganism)',
    child_ng_answer_12_9: 'Other, please specify',
    child_ng_answer_13_1: 'Milk',
    child_ng_answer_13_2: 'Yoghurt',
    child_ng_answer_13_3: 'Yellow cheese',
    child_ng_answer_13_4: 'Feta cheese',
    child_ng_answer_13_5: 'Pudding',
    child_ng_answer_13_6: 'Rice pudding',
    child_ng_answer_13_7: 'Fruit juice',
    child_ng_answer_13_8: 'Honey',
    child_ng_answer_13_9: 'Jam',
    child_ng_answer_13_10: 'Peanut butter',
    child_ng_answer_13_11: 'Margarine',
    child_ng_answer_13_12: 'Butter',
    child_ng_answer_13_13: 'Tahini',
    child_ng_answer_13_14: 'Toasted bread',
    child_ng_answer_13_15: 'Cereals',
    child_ng_answer_13_16: 'Oats',
    child_ng_answer_13_17: 'Almonds',
    child_ng_answer_13_18: 'Hazelnuts',
    child_ng_answer_13_19: 'Walnuts',
    child_ng_answer_13_20: 'Cashews',
    child_ng_answer_13_21: 'Cereal bar',
    child_ng_answer_13_22: 'Sesame candy',
    child_ng_answer_13_23: 'Egg',
    child_ng_answer_13_24: 'Egg white',
    child_ng_answer_13_25: 'Omelet',
    child_ng_answer_14_1: 'Lamb',
    child_ng_answer_14_2: 'Goat',
    child_ng_answer_14_3: 'Pork',
    child_ng_answer_14_4: 'Ham',
    child_ng_answer_14_5: 'Chicken',
    child_ng_answer_14_6: 'Turkey',
    child_ng_answer_14_7: 'Beef',
    child_ng_answer_14_8: 'Salmon',
    child_ng_answer_14_9: 'Sea bass',
    child_ng_answer_14_10: 'Sea bream',
    child_ng_answer_14_11: 'Porgy',
    child_ng_answer_14_12: 'Perch',
    child_ng_answer_14_13: 'Sole',
    child_ng_answer_14_14: 'Sardines',
    child_ng_answer_14_15: 'Anchovies',
    child_ng_answer_14_16: 'Tuna',
    child_ng_answer_15_1: 'Vegetables in tomato sauce',
    child_ng_answer_15_2: 'Legumes',
    child_ng_answer_15_3: 'Rice',
    child_ng_answer_15_4: 'Bulgur',
    child_ng_answer_15_5: 'Quinoa',
    child_ng_answer_15_6: 'Buckwheat',
    child_ng_answer_15_7: 'Pasta',
    child_ng_answer_15_8: 'Bread',
    child_ng_answer_15_9: 'Rusk',
    child_ng_answer_15_10: 'Potato',
    child_ng_answer_15_11: 'Sweet potato',
    child_ng_answer_15_12: 'Rice cakes',
    child_ng_answer_15_13: 'Corn',
    child_ng_answer_16_1: 'Green salad',
    child_ng_answer_16_2: 'Courgetti',
    child_ng_answer_16_3: 'Aubergine',
    child_ng_answer_16_4: 'Tomato salad',
    child_ng_answer_16_5: 'Spinach',
    child_ng_answer_16_6: 'Broccoli',
    child_ng_answer_16_7: 'Cauliflower',
    child_ng_answer_16_8: 'Banana',
    child_ng_answer_16_9: 'Apple',
    child_ng_answer_16_10: 'Pear',
    child_ng_answer_16_11: 'Kiwi',
    child_ng_answer_16_12: 'Orange',
    child_ng_answer_16_13: 'Tangerine',
    child_ng_answer_16_14: 'Melon',
    child_ng_answer_16_15: 'Watermelon',
    child_ng_answer_16_16: 'Apricot',
    child_ng_answer_16_17: 'Peach',
    child_ng_answer_16_18: 'Cranberries',
    child_ng_answer_16_19: 'Blueberries',
    child_ng_answer_20_1: 'At all',
    child_ng_answer_20_2: 'Seldom',
    child_ng_answer_20_3: 'Sometimes',
    child_ng_answer_20_4: 'Often',
    child_ng_answer_20_5: 'Always',
    child_ng_answer_21_1: 'At all',
    child_ng_answer_21_2: 'Seldom',
    child_ng_answer_21_3: 'Sometimes',
    child_ng_answer_21_4: 'Often',
    child_ng_answer_21_5: 'Always',
    child_ng_answer_23_1: '0 - 4 tablespoons',
    child_ng_answer_23_2: '> 4 tsp. Soup',
    child_ng_answer_24_1: '0 - 2',
    child_ng_answer_24_2: '> 2',
    child_ng_answer_25_1: '0 - 3',
    child_ng_answer_25_2: '> 3',
    child_ng_answer_26_1: '0 - 1',
    child_ng_answer_26_2: '> 1',
    child_ng_answer_27_1: '0 - 1',
    child_ng_answer_27_2: '> 1',
    child_ng_answer_28_1: '0 - 1',
    child_ng_answer_28_2: '> 1',
    child_ng_answer_29_1: '0 - 3',
    child_ng_answer_29_2: '> 3',
    child_ng_answer_30_1: '0 - 3',
    child_ng_answer_30_2: '> 3',
    child_ng_answer_31_1: '0 - 3',
    child_ng_answer_31_2: '> 3',
    child_ng_answer_32_1: 'Never',
    child_ng_answer_32_2: 'Rarely',
    child_ng_answer_32_3: 'Sometimes',
    child_ng_answer_32_4: 'Often',
    child_ng_answer_32_5: 'Always',
    child_ng_answer_33_1: 'Never',
    child_ng_answer_33_2: 'Rarely',
    child_ng_answer_33_3: 'Sometimes',
    child_ng_answer_33_4: 'Often',
    child_ng_answer_33_5: 'Always',
    child_ng_answer_34_1: 'Never',
    child_ng_answer_34_2: 'Rarely',
    child_ng_answer_34_3: 'Sometimes',
    child_ng_answer_34_4: 'Often',
    child_ng_answer_34_5: 'Always',
    child_ng_answer_35_1: 'White or Caucasian',
    child_ng_answer_35_2: 'Asian',
    child_ng_answer_35_3: 'Black/African American',
    child_ng_answer_35_4: 'Hispanic/Latino',
    child_ng_answer_35_5: 'Arabic',
    child_ng_answer_35_6: 'Mixed',
    child_ng_answer_35_7: 'Other',
    child_ng_answer_35_8: 'I prefer not to respond',

    doc_ng_answer_1_1: 'Diet for weight loss / Obesity management',
    doc_ng_answer_1_2: 'Diet for weight gain',
    doc_ng_answer_1_3: 'Diet for weight maintenance',
    doc_ng_answer_1_4: 'Nutrition during pregnancy',
    doc_ng_answer_1_5: 'Nutrition during breastfeeding',
    doc_ng_answer_1_6: 'Sports nutrition',
    doc_ng_answer_1_7: 'Nutritional management of metabolic syndrome',
    doc_ng_answer_1_8: 'Nutritional management of cardiovascular diseases (hypertension, dyslipidemia, atherosclerosis, coronary artery disease, infarction, etc.)',
    doc_ng_answer_1_9: 'Nutritional management of Type 2 Diabetes Mellitus',
    doc_ng_answer_2_1: 'Light',
    doc_ng_answer_2_2: 'Moderate',
    doc_ng_answer_2_3: 'Intense',
    doc_ng_answer_3_1: 'Light',
    doc_ng_answer_3_2: 'Moderate',
    doc_ng_answer_3_3: 'Intense',
    doc_ng_answer_4_1: 'I don\'t have a known medical history',
    doc_ng_answer_4_2: 'Nephropathy',
    doc_ng_answer_4_3: 'Diabetes Mellitus',
    doc_ng_answer_4_4: 'Iron deficiency anemia (low iron)',
    doc_ng_answer_4_5: 'Cardiovascular diseases',
    doc_ng_answer_4_6: 'Hypercholesterolemia',
    doc_ng_answer_4_7: 'Megaloblastic anemia (low B9, B12)',
    doc_ng_answer_4_8: 'Hypertension',
    doc_ng_answer_4_9: 'Diseases of the digestive tract, please specify',
    doc_ng_answer_4_10: 'Other, please specify',
    doc_ng_answer_5_1: 'I am not taking any medication',
    doc_ng_answer_5_2: 'Antihypertensive drugs',
    doc_ng_answer_5_3: 'Statins or other drugs for hypercholesterolemia ',
    doc_ng_answer_5_4: 'Antidiabetic drugs',
    doc_ng_answer_5_5: 'Other, please specify',
    doc_ng_answer_6_1: 'I am not taking any supplements',
    doc_ng_answer_6_2: 'Multivitamin',
    doc_ng_answer_6_3: 'Vitamin A',
    doc_ng_answer_6_4: 'Vitamin C',
    doc_ng_answer_6_5: 'Vitamin D',
    doc_ng_answer_6_6: 'Vitamin E',
    doc_ng_answer_6_7: 'B complex',
    doc_ng_answer_6_8: 'Calcium',
    doc_ng_answer_6_9: 'Iron',
    doc_ng_answer_6_10: 'Magnesium',
    doc_ng_answer_6_11: 'Omega-3 fat/cod liver oil',
    doc_ng_answer_6_12: 'Coenzyme Q-10',
    doc_ng_answer_6_13: 'Other, please specify',
    doc_ng_answer_9_1: 'Yes',
    doc_ng_answer_9_2: 'No',
    doc_ng_answer_12_1: 'No, I don\'t follow any specific diet',
    doc_ng_answer_12_2: 'Mediterranean diet',
    doc_ng_answer_12_3: 'Vegetarian diet',
    doc_ng_answer_12_4: 'Lacto-vegetarian diet',
    doc_ng_answer_12_5: 'Ovo-vegetarian diet',
    doc_ng_answer_12_6: 'Lacto-ovo-vegetarian diet',
    doc_ng_answer_12_7: 'Lacto-ovo-pesco-vegetarian diet',
    doc_ng_answer_12_8: 'Strict vegetarianism (veganism)',
    doc_ng_answer_12_9: 'Other, please specify',
    doc_ng_answer_13_1: 'Milk',
    doc_ng_answer_13_2: 'Yoghurt',
    doc_ng_answer_13_3: 'Yellow cheese',
    doc_ng_answer_13_4: 'Feta cheese',
    doc_ng_answer_13_5: 'Pudding',
    doc_ng_answer_13_6: 'Rice pudding',
    doc_ng_answer_13_7: 'Fruit juice',
    doc_ng_answer_13_8: 'Honey',
    doc_ng_answer_13_9: 'Jam',
    doc_ng_answer_13_10: 'Peanut butter',
    doc_ng_answer_13_11: 'Margarine',
    doc_ng_answer_13_12: 'Butter',
    doc_ng_answer_13_13: 'Tahini',
    doc_ng_answer_13_14: 'Toasted bread',
    doc_ng_answer_13_15: 'Cereals',
    doc_ng_answer_13_16: 'Oats',
    doc_ng_answer_13_17: 'Almonds',
    doc_ng_answer_13_18: 'Hazelnuts',
    doc_ng_answer_13_19: 'Walnuts',
    doc_ng_answer_13_20: 'Cashews',
    doc_ng_answer_13_21: 'Cereal bar',
    doc_ng_answer_13_22: 'Sesame candy',
    doc_ng_answer_13_23: 'Egg',
    doc_ng_answer_13_24: 'Egg white',
    doc_ng_answer_13_25: 'Omelet',
    doc_ng_answer_14_1: 'Lamb',
    doc_ng_answer_14_2: 'Goat',
    doc_ng_answer_14_3: 'Pork',
    doc_ng_answer_14_4: 'Ham',
    doc_ng_answer_14_5: 'Chicken',
    doc_ng_answer_14_6: 'Turkey',
    doc_ng_answer_14_7: 'Beef',
    doc_ng_answer_14_8: 'Salmon',
    doc_ng_answer_14_9: 'Sea bass',
    doc_ng_answer_14_10: 'Sea bream',
    doc_ng_answer_14_11: 'Porgy',
    doc_ng_answer_14_12: 'Perch',
    doc_ng_answer_14_13: 'Sole',
    doc_ng_answer_14_14: 'Sardines',
    doc_ng_answer_14_15: 'Anchovies',
    doc_ng_answer_14_16: 'Tuna',
    doc_ng_answer_15_1: 'Vegetables in tomato sauce',
    doc_ng_answer_15_2: 'Legumes',
    doc_ng_answer_15_3: 'Rice',
    doc_ng_answer_15_4: 'Bulgur',
    doc_ng_answer_15_5: 'Quinoa',
    doc_ng_answer_15_6: 'Buckwheat',
    doc_ng_answer_15_7: 'Pasta',
    doc_ng_answer_15_8: 'Bread',
    doc_ng_answer_15_9: 'Rusk',
    doc_ng_answer_15_10: 'Potato',
    doc_ng_answer_15_11: 'Sweet potato',
    doc_ng_answer_15_12: 'Rice cakes',
    doc_ng_answer_15_13: 'Corn',
    doc_ng_answer_16_1: 'Green salad',
    doc_ng_answer_16_2: 'Courgetti',
    doc_ng_answer_16_3: 'Aubergine',
    doc_ng_answer_16_4: 'Tomato salad',
    doc_ng_answer_16_5: 'Spinach',
    doc_ng_answer_16_6: 'Broccoli',
    doc_ng_answer_16_7: 'Cauliflower',
    doc_ng_answer_16_8: 'Banana',
    doc_ng_answer_16_9: 'Apple',
    doc_ng_answer_16_10: 'Pear',
    doc_ng_answer_16_11: 'Kiwi',
    doc_ng_answer_16_12: 'Orange',
    doc_ng_answer_16_13: 'Tangerine',
    doc_ng_answer_16_14: 'Melon',
    doc_ng_answer_16_15: 'Watermelon',
    doc_ng_answer_16_16: 'Apricot',
    doc_ng_answer_16_17: 'Peach',
    doc_ng_answer_16_18: 'Cranberries',
    doc_ng_answer_16_19: 'Blueberries',
    doc_ng_answer_20_1: 'At all',
    doc_ng_answer_20_2: 'Seldom',
    doc_ng_answer_20_3: 'Sometimes',
    doc_ng_answer_20_4: 'Often',
    doc_ng_answer_20_5: 'Always',
    doc_ng_answer_21_1: 'At all',
    doc_ng_answer_21_2: 'Seldom',
    doc_ng_answer_21_3: 'Sometimes',
    doc_ng_answer_21_4: 'Often',
    doc_ng_answer_21_5: 'Always',
    doc_ng_answer_23_1: '0 - 4 tablespoons',
    doc_ng_answer_23_2: '> 4 tsp. Soup',
    doc_ng_answer_24_1: '0 - 2',
    doc_ng_answer_24_2: '> 2',
    doc_ng_answer_25_1: '0 - 3',
    doc_ng_answer_25_2: '> 3',
    doc_ng_answer_26_1: '0 - 1',
    doc_ng_answer_26_2: '> 1',
    doc_ng_answer_27_1: '0 - 1',
    doc_ng_answer_27_2: '> 1',
    doc_ng_answer_28_1: '0 - 1',
    doc_ng_answer_28_2: '> 1',
    doc_ng_answer_29_1: '0 - 3',
    doc_ng_answer_29_2: '> 3',
    doc_ng_answer_30_1: '0 - 3',
    doc_ng_answer_30_2: '> 3',
    doc_ng_answer_31_1: '0 - 3',
    doc_ng_answer_31_2: '> 3',
    doc_ng_answer_32_1: 'Never',
    doc_ng_answer_32_2: 'Rarely',
    doc_ng_answer_32_3: 'Sometimes',
    doc_ng_answer_32_4: 'Often',
    doc_ng_answer_32_5: 'Always',
    doc_ng_answer_33_1: 'Never',
    doc_ng_answer_33_2: 'Rarely',
    doc_ng_answer_33_3: 'Sometimes',
    doc_ng_answer_33_4: 'Often',
    doc_ng_answer_33_5: 'Always',
    doc_ng_answer_34_1: 'Never',
    doc_ng_answer_34_2: 'Rarely',
    doc_ng_answer_34_3: 'Sometimes',
    doc_ng_answer_34_4: 'Often',
    doc_ng_answer_34_5: 'Always',
    doc_ng_answer_35_1: 'White or Caucasian',
    doc_ng_answer_35_2: 'Asian',
    doc_ng_answer_35_3: 'Black/African American',
    doc_ng_answer_35_4: 'Hispanic/Latino',
    doc_ng_answer_35_5: 'Arabic',
    doc_ng_answer_35_6: 'Mixed',
    doc_ng_answer_35_7: 'Other',
    doc_ng_answer_35_8: 'I prefer not to respond',

    wl_answer_3_1: 'Smoker',
    wl_answer_3_2: 'Nonsmoker',
    wl_answer_5_1: 'Diet for weight loss / Obesity management',
    wl_answer_5_2: 'Diet for weight gain',
    wl_answer_5_3: 'Diet for weight maintenance',
    wl_answer_5_4: 'Nutrition during pregnancy',
    wl_answer_5_5: 'Nutrition during breastfeeding',
    wl_answer_5_6: 'Sports nutrition',
    wl_answer_5_7: 'Nutritional management of metabolic syndrome',
    wl_answer_5_8: 'Nutritional management of cardiovascular diseases (hypertension, dyslipidemia, atherosclerosis, coronary artery disease, infarction, etc.)',
    wl_answer_5_9: 'Nutritional management of Type 2 Diabetes Mellitus',
    wl_answer_6_1: 'I don\'t have a known medical history',
    wl_answer_6_2: 'Nephropathy',
    wl_answer_6_3: 'Diabetes Mellitus',
    wl_answer_6_4: 'Iron deficiency anemia (low iron)',
    wl_answer_6_5: 'Cardiovascular diseases',
    wl_answer_6_6: 'Hypercholesterolemia',
    wl_answer_6_7: 'Megaloblastic anemia (low B9, B12)',
    wl_answer_6_8: 'Hypertension',
    wl_answer_6_9: 'Diseases of the digestive tract, please specify',
    wl_answer_6_10: 'Other, please specify',
    wl_answer_7_1: 'I am not taking any medication',
    wl_answer_7_2: 'Antihypertensive drugs',
    wl_answer_7_3: 'Statins or other drugs for hypercholesterolemia',
    wl_answer_7_4: 'Antidiabetic drugs',
    wl_answer_7_5: 'Other, please specify',
    wl_answer_8_1: 'I am not taking any supplements',
    wl_answer_8_2: 'Multivitamin',
    wl_answer_8_3: 'Vitamin A',
    wl_answer_8_4: 'Vitamin C',
    wl_answer_8_5: 'Vitamin D',
    wl_answer_8_6: 'Vitamin Ε',
    wl_answer_8_7: 'B complex',
    wl_answer_8_8: 'Calcium',
    wl_answer_8_9: 'Iron',
    wl_answer_8_10: 'Magnesium',
    wl_answer_8_11: 'Omega-3 fat/cod liver oil',
    wl_answer_8_12: 'Coenzyme Q-9',
    wl_answer_8_13: 'Other, please specify',

    doc_wl_answer_3_1: 'Yes',
    doc_wl_answer_3_2: 'No',
    doc_wl_answer_5_1: 'Diet for weight loss / Obesity management',
    doc_wl_answer_5_2: 'Diet for weight gain',
    doc_wl_answer_5_3: 'Diet for weight maintenance',
    doc_wl_answer_5_4: 'Diet for weight maintenance',
    doc_wl_answer_5_5: 'Nutrition during breastfeeding',
    doc_wl_answer_5_6: 'Sports nutrition',
    doc_wl_answer_5_7: 'Nutritional management of metabolic syndrome',
    doc_wl_answer_5_8: 'Nutritional management of cardiovascular diseases (hypertension, dyslipidemia, atherosclerosis, coronary artery disease, infarction, etc.)',
    doc_wl_answer_5_9: 'Nutritional management of Type 2 Diabetes Mellitus',
    doc_wl_answer_6_1: 'No known medical history',
    doc_wl_answer_6_2: 'Nephropathy',
    doc_wl_answer_6_3: 'Diabetes Mellitus',
    doc_wl_answer_6_4: 'Iron deficiency anemia (low iron)',
    doc_wl_answer_6_5: 'Cardiovascular diseases',
    doc_wl_answer_6_6: 'Hypercholesterolemia',
    doc_wl_answer_6_7: 'Megaloblastic anemia (low B9, B12)',
    doc_wl_answer_6_8: 'Hypertension',
    doc_wl_answer_6_9: 'Diseases of the digestive tract, please specify',
    doc_wl_answer_6_10: 'Other, please specify',
    doc_wl_answer_7_1: 'No medication',
    doc_wl_answer_7_2: 'Antihypertensive drugs',
    doc_wl_answer_7_3: 'Statins or other drugs for hypercholesterolemia',
    doc_wl_answer_7_4: 'Antidiabetic drugs',
    doc_wl_answer_7_5: 'Antidiabetic drugs',
    doc_wl_answer_8_1: 'No supplements',
    doc_wl_answer_8_2: 'Multivitamin',
    doc_wl_answer_8_3: 'Vitamin A',
    doc_wl_answer_8_4: 'Vitamin C',
    doc_wl_answer_8_5: 'Vitamin D',
    doc_wl_answer_8_6: 'Vitamin Ε',
    doc_wl_answer_8_7: 'B complex',
    doc_wl_answer_8_8: 'Calcium',
    doc_wl_answer_8_9: 'Iron',
    doc_wl_answer_8_10: 'Magnesium',
    doc_wl_answer_8_11: 'Omega-3 fat/cod liver oil',
    doc_wl_answer_8_12: 'Coenzyme Q-9',
    doc_wl_answer_8_13: 'Other, please specify',

    child_wl_answer_3_1: 'Yes',
    child_wl_answer_3_2: 'No',
    child_wl_answer_5_1: 'Diet for weight loss / Obesity management',
    child_wl_answer_5_2: 'Diet for weight gain',
    child_wl_answer_5_3: 'Diet for weight maintenance',
    child_wl_answer_5_4: 'Diet for weight maintenance',
    child_wl_answer_5_5: 'Nutrition during breastfeeding',
    child_wl_answer_5_6: 'Sports nutrition',
    child_wl_answer_5_7: 'Nutritional management of metabolic syndrome',
    child_wl_answer_5_8: 'Nutritional management of cardiovascular diseases (hypertension, dyslipidemia, atherosclerosis, coronary artery disease, infarction, etc.)',
    child_wl_answer_5_9: 'Nutritional management of Type 2 Diabetes Mellitus',
    child_wl_answer_6_1: 'No known medical history',
    child_wl_answer_6_2: 'Nephropathy',
    child_wl_answer_6_3: 'Diabetes Mellitus',
    child_wl_answer_6_4: 'Iron deficiency anemia (low iron)',
    child_wl_answer_6_5: 'Cardiovascular diseases',
    child_wl_answer_6_6: 'Hypercholesterolemia',
    child_wl_answer_6_7: 'Megaloblastic anemia (low B9, B12)',
    child_wl_answer_6_8: 'Hypertension',
    child_wl_answer_6_9: 'Diseases of the digestive tract, please specify',
    child_wl_answer_6_10: 'Other, please specify',
    child_wl_answer_7_1: 'No medication',
    child_wl_answer_7_2: 'Antihypertensive drugs',
    child_wl_answer_7_3: 'Statins or other drugs for hypercholesterolemia',
    child_wl_answer_7_4: 'Antidiabetic drugs',
    child_wl_answer_7_5: 'Antidiabetic drugs',
    child_wl_answer_8_1: 'No supplements',
    child_wl_answer_8_2: 'Multivitamin',
    child_wl_answer_8_3: 'Vitamin A',
    child_wl_answer_8_4: 'Vitamin C',
    child_wl_answer_8_5: 'Vitamin D',
    child_wl_answer_8_6: 'Vitamin Ε',
    child_wl_answer_8_7: 'B complex',
    child_wl_answer_8_8: 'Calcium',
    child_wl_answer_8_9: 'Iron',
    child_wl_answer_8_10: 'Magnesium',
    child_wl_answer_8_11: 'Omega-3 fat/cod liver oil',
    child_wl_answer_8_12: 'Coenzyme Q-9',
    child_wl_answer_8_13: 'Other, please specify',

    vi_answer_3_1: 'Smoker',
    vi_answer_3_2: 'Nonsmoker',
    vi_answer_5_1: 'I don\'t have a known medical history',
    vi_answer_5_2: 'Nephropathy',
    vi_answer_5_3: 'Diabetes Mellitus',
    vi_answer_5_4: 'Iron deficiency anemia (low iron)',
    vi_answer_5_5: 'Cardiovascular diseases',
    vi_answer_5_6: 'Hypercholesterolemia',
    vi_answer_5_7: 'Megaloblastic anemia (low B9, B12)',
    vi_answer_5_8: 'Hypertension',
    vi_answer_5_9: 'Diseases of the digestive tract, please specify',
    vi_answer_5_10: 'Other, please specify',
    vi_answer_6_1: 'I am not taking any medication',
    vi_answer_6_2: 'Antihypertensive drugs',
    vi_answer_6_3: 'Statins or other drugs for hypercholesterolemia',
    vi_answer_6_4: 'Antidiabetic drugs',
    vi_answer_6_5: 'Other, please specify',
    vi_answer_7_1: 'I am not taking any supplements',
    vi_answer_7_2: 'Multivitamin',
    vi_answer_7_3: 'Vitamin A',
    vi_answer_7_4: 'Vitamin C',
    vi_answer_7_5: 'Vitamin D',
    vi_answer_7_6: 'Vitamin Ε',
    vi_answer_7_7: 'B complex',
    vi_answer_7_8: 'Calcium',
    vi_answer_7_9: 'Iron',
    vi_answer_7_10: 'Magnesium',
    vi_answer_7_11: 'Omega-3 fat/cod liver oil',
    vi_answer_7_12: 'Coenzyme Q-9',
    vi_answer_7_13: 'Other, please specify',

    doc_vi_answer_3_1: 'Yes',
    doc_vi_answer_3_2: 'No',
    doc_vi_answer_5_1: 'No known medical history',
    doc_vi_answer_5_2: 'Nephropathy',
    doc_vi_answer_5_3: 'Diabetes Mellitus',
    doc_vi_answer_5_4: 'Iron deficiency anemia (low iron)',
    doc_vi_answer_5_5: 'Cardiovascular diseases',
    doc_vi_answer_5_6: 'Hypercholesterolemia',
    doc_vi_answer_5_7: 'Megaloblastic anemia (low B9, B12)',
    doc_vi_answer_5_8: 'Hypertension',
    doc_vi_answer_5_9: 'Diseases of the digestive tract, please specify',
    doc_vi_answer_5_10: 'Other, please specify',
    doc_vi_answer_6_1: 'No medication',
    doc_vi_answer_6_2: 'Antihypertensive drugs',
    doc_vi_answer_6_3: 'Statins or other drugs for hypercholesterolemia',
    doc_vi_answer_6_4: 'Antidiabetic drugs',
    doc_vi_answer_6_5: 'Antidiabetic drugs',
    doc_vi_answer_7_1: 'No supplements',
    doc_vi_answer_7_2: 'Multivitamin',
    doc_vi_answer_7_3: 'Vitamin A',
    doc_vi_answer_7_4: 'Vitamin C',
    doc_vi_answer_7_5: 'Vitamin D',
    doc_vi_answer_7_6: 'Vitamin Ε',
    doc_vi_answer_7_7: 'B complex',
    doc_vi_answer_7_8: 'Calcium',
    doc_vi_answer_7_9: 'Iron',
    doc_vi_answer_7_10: 'Magnesium',
    doc_vi_answer_7_11: 'Omega-3 fat/cod liver oil',
    doc_vi_answer_7_12: 'Coenzyme Q-9',
    doc_vi_answer_7_13: 'Other, please specify',

    child_vi_answer_3_1: 'Yes',
    child_vi_answer_3_2: 'No',
    child_vi_answer_5_1: 'No known medical history',
    child_vi_answer_5_2: 'Nephropathy',
    child_vi_answer_5_3: 'Diabetes Mellitus',
    child_vi_answer_5_4: 'Iron deficiency anemia (low iron)',
    child_vi_answer_5_5: 'Cardiovascular diseases',
    child_vi_answer_5_6: 'Hypercholesterolemia',
    child_vi_answer_5_7: 'Megaloblastic anemia (low B9, B12)',
    child_vi_answer_5_8: 'Hypertension',
    child_vi_answer_5_9: 'Diseases of the digestive tract, please specify',
    child_vi_answer_5_10: 'Other, please specify',
    child_vi_answer_6_1: 'No medication',
    child_vi_answer_6_2: 'Antihypertensive drugs',
    child_vi_answer_6_3: 'Statins or other drugs for hypercholesterolemia',
    child_vi_answer_6_4: 'Antidiabetic drugs',
    child_vi_answer_6_5: 'Antidiabetic drugs',
    child_vi_answer_7_1: 'No supplements',
    child_vi_answer_7_2: 'Multivitamin',
    child_vi_answer_7_3: 'Vitamin A',
    child_vi_answer_7_4: 'Vitamin C',
    child_vi_answer_7_5: 'Vitamin D',
    child_vi_answer_7_6: 'Vitamin Ε',
    child_vi_answer_7_7: 'B complex',
    child_vi_answer_7_8: 'Calcium',
    child_vi_answer_7_9: 'Iron',
    child_vi_answer_7_10: 'Magnesium',
    child_vi_answer_7_11: 'Omega-3 fat/cod liver oil',
    child_vi_answer_7_12: 'Coenzyme Q-9',
    child_vi_answer_7_13: 'Other, please specify',

    id_answer_1_1: 'Dementia',
    id_answer_1_2: 'Developmental disorder',
    id_answer_1_3: 'Depression',
    id_answer_1_4: 'Βipolar disorder',
    id_answer_1_5: 'Psychosis',
    id_answer_1_6: 'Anxiety Disorder',
    id_answer_1_7: 'Panic disorder',
    id_answer_1_8: 'Phobics',
    id_answer_1_9: 'Post-traumatic disorder',
    id_answer_1_10: 'Obsessive-compulsive disorder',
    id_answer_1_11: 'Sleep disorders',
    id_answer_1_12: 'Epilepsy',

    doc_id_answer_1_1: 'F00.- Dementia in Alzheimer disease',
    doc_id_answer_1_2: 'F01.- Vascular dementia',
    doc_id_answer_1_3: 'F05.- Delirium',
    doc_id_answer_1_4: 'F20.- Schizophrenia',
    doc_id_answer_1_5: 'F22.- Persistent delusional disorders',
    doc_id_answer_1_6: 'F25.-Schizoaffective disorders',
    doc_id_answer_1_7: 'F30.- Manic episode',
    doc_id_answer_1_8: 'F31.- Bipolar affective disorder',
    doc_id_answer_1_9: 'F32.- Depressive episode',
    doc_id_answer_1_10: 'F33.- Recurrent depressive disorder',
    doc_id_answer_1_11: 'F34.1 Dysthymia',
    doc_id_answer_1_12: 'F40.- Phobic anxiety disorders',
    doc_id_answer_1_13: 'F41.0 Panic disorder',
    doc_id_answer_1_14: 'F41.1 Generalized anxiety disorder',
    doc_id_answer_1_15: 'F41.2 Mixed anxiety and depressive disorder',
    doc_id_answer_1_16: 'F42.- Obsessive - compulsive disorder',
    doc_id_answer_1_17: 'F43.- Reaction to severe stress, and adjustment disorders',
    doc_id_answer_1_18: 'F43.1 Post-traumatic stress disorder',
    doc_id_answer_1_19: 'F45.2 Hypochondriacal disorder',
    doc_id_answer_1_20: 'F51.- Nonorganic sleep disorders',
    doc_id_answer_1_21: 'F61.- Mixed and other personality disorders',
    doc_id_answer_1_22: 'G20.- Parkinson disease',
    doc_id_answer_1_23: 'G30.- Alzheimer disease',
    doc_id_answer_1_24: 'G31.- Other degenerative diseases of nervous system, not elsewhere classified',
    doc_id_answer_1_25: 'G40.- Epilepsy',
    doc_id_answer_1_26: 'G50.- Disorders of trigeminal nerve',
    doc_id_answer_1_27: 'R52.- Pain, not elsewhere classified',
    doc_id_answer_1_28: 'R56.- Convulsions, not elsewhere classified',

    'Η τιμή θα πρέπει να είναι μεταξύ {{limit_down}} και {{limit_up}}.': 'The value should be between {{limit_down}} and {{limit_up}}',
    'Οι τιμές θα πρέπει να είναι μεταξύ {{limit_down}} και {{limit_up}}.': 'The values should be between {{limit_down}} and {{limit_up}}',
    'Οι απαντήσεις δεν είναι έγκυρες': 'The answers are not valid',
    'Δεν έχουν απαντηθεί όλες οι ερωτήσεις': 'There are missing answers',
    'Η απάντησή σου': 'Your response',
    'Η έγκαιρη ανίχνευση, η πρόληψη και η εξατομικευμένη παρέμβαση είναι θεμελιώδεις στόχοι για την προαγωγή της βέλτιστης καρδιαγγειακής υγείας. Μέχρι σήμερα, η πρόβλεψη κλινικού ρίσκου βασίζεται σε δημογραφικά χαρακτηριστικά (ηλικία, φύλο, εθνικότητα), στον τρόπο ζωής (κάπνισμα, κατανάλωση αλκοόλ, διατροφή, σωματική άσκηση), σε παραμέτρους υγείας (δείκτης μάζας σώματος, αρτηριακή πίεση, αιματολογικές εξετάσεις) και στο οικογενειακό ιστορικό. Παραδόξως, ο γενετικός έλεγχος τείνει να απουσιάζει από αυτή τη λίστα, τη στιγμή που η γενετική προδιάθεση μπορεί να εξεταστεί νωρίτερα στη ζωή από οποιοδήποτε άλλο παράγοντα ρίσκου.': 'Early detection, prevention, and personalized intervention are fundamental goals for promoting optimal cardiovascular health. To date, clinical risk prediction is based on demographic characteristics (age, sex, ethnicity), lifestyle (smoking, alcohol consumption, diet, physical activity), health parameters (body mass index, blood pressure, blood tests) and family history. Surprisingly, genetic testing tends to be absent from this list, at a time when genetic predisposition can be addressed earlier in life than any other risk factor.',
    'Πλέον, η Βαθμολογία Πολυγονιδιακού Ρίσκου (Polygenic Risk Score - PRS) είναι ένα σύγχρονο εργαλείο ανάλυσης του γενετικού προφίλ που εκτιμά την πιθανολογική ευαισθησία (προδιάθεση) σε πλήθος καρδιαγγειακών παθήσεων, από μία και μόνο απλή εξέταση παρειακού επιχρίσματος. Επιπροσθέτως, το Προσαρμοσμένο PRS (Adjusted PRS) αποτελεί μία μοναδική και καινοτόμο μέθοδο που συνδυάζει το PRS με τα τρέχοντα χαρακτηριστικά του τρόπου ζωής και του φαινοτύπου σου, παρέχοντας με αυτό τον τρόπο την ικανότητα δυναμικής παρακολούθησης από εσένα, του ρίσκου για ανάπτυξη καρδιαγγειακών παθήσεων.': 'The Polygenic Risk Score (PRS) is a novel genetic profiling tool that estimates the probabilistic susceptibility (predisposition) to a number of cardiovascular diseases, from a single simple buccal swab test. In addition, the Adjusted PRS is a unique and innovative method that combines the PRS with the current characteristics of your lifestyle and phenotype, thus providing the ability to dynamically monitor your risk of developing cardiovascular disease.',
    'Η Βαθμολογία Πολυγονιδιακού Ρίσκου (PRS) και το Προσαρμοσμένο PRS (Adjusted PRS) λειτουργούν ως εργαλείο εκτίμησης – screening του γενετικού και φαινοτυπικού ρίσκου εμφάνισης καρδιαγγειακών παθήσεων και ο ρόλος τους είναι η πρόληψη.': 'The Polygenic Risk Score (PRS) and the Adjusted PRS function as a screening tool for estimating the genetic and phenotypic risk of developing cardiovascular diseases and their role lies in prevention.',
    accordingToQuestionnaire: 'According to the questionnaire concerning characteristics of your lifestyle and phenotype, such as eating habits, level of physical activity, smoking, body mass index (BMI), blood pressure, total cholesterol and blood glucose, your current cardiovascular health status is:',
    'Έλεγχος και οριστικοποίηση εγγραφής': 'Review and finalize registration',
    'Receipt of Results': 'Results',
    'Εντός {{days}} εργάσιμων ημερών από την παραλαβή του δείγματος παρειακού επιχρίσματος από το εργαστήριό μας, η έκθεση αποτελεσμάτων σας θα είναι διαθέσιμη στην σελίδα του λογαριασμού σας. Θα σας σταλεί ειδοποίηση στο ηλεκτρονικό σας ταχυδρομείο. Αν έχετε ζητήσει να δοθεί πρόσβαση στον ηλεκτρονικό σας φάκελο και σε άλλο πρόσωπο, και αυτό το πρόσωπο έχει αποδεχτεί την αίτηση σας, τότε ταυτόχρονα, θα ειδοποιηθεί και αυτός, και θα έχει πρόσβαση στην έκθεση αποτελεσμάτων σας.': 'Your personalized report will be accessible in your account within {{days}} business days from the day our laboratory receives your saliva sample. A notification will be sent to your registered email. In the case you have requested to provide access for a third party to your electronic file and the third party has accepted it, a notification will also be sent to the third party’s email to have access to your personalized report.',
    'Παρακαλούμε ακολουθήστε τις οδηγίες λήψης του δείγματος παρειακού επιχρίσματος, που υπάρχουν μέσα στο kit που έχετε παραλάβει ή κάντε κλικ': 'Please follow the buccal swab (saliva) sample collection instructions provided in the kit you received or click',
    sendInstructionsContent: 'Place the saliva sample in the Test Kit box, and return it to iDNA Genomics S.A.',
    sendInstructionsContentPGx: 'Place the saliva sample in the Test Kit box, and return it to iDNA Laboratories S.A.',
    'The shipping address is:': 'The shipping address is:',
    questionnaireFirstWarning: 'It is mandatory to fill in ALL the details and answer ALL the questions. If they are not filled in, the registration process of your kit cannot be completed.',
    questionnaireFirstWarningChild: 'It is mandatory to fill in ALL the details and answer ALL the questions. If they are not filled in, the registration process of the kit cannot be completed.',
    questionnaireFirstWarningDoctor: 'It is mandatory to fill in ALL the details and answer ALL the questions. If they are not filled in, the registration process of the kit cannot be completed.',
    questionnaireSecondWarning: 'Carefully check the information you provide. This data is crucial for the representation of your results. After these are finalised and submitted, you will NOT be able to make any changes.',
    questionnaireSecondWarningChild: 'Please verify the data you provided during registration process. This information is essential for the personalized report. After completing registration, you will NOT be able to make any changes',
    questionnaireSecondWarningDoctor: 'Please verify the data you provided during registration process. This information is essential for the personalized report. After completing registration, you will NOT be able to make any changes',
    'Παρακαλούμε συμπληρώστε τo παρακάτω ερωτηματολόγιο.': 'Please complete the following questionnaire.',
    'Ερωτηματολόγιο Cardio Health': 'Cardio Health Questionnaire',
    'Ερωτηματολόγιο Biological Age': 'Biological Age Questionnaire',
    doctorSearch: 'Search for a Doctor / Health Professional',
    'Είναι σημαντικό να ελέγξετε τα στοιχεία που έχετε καταγράψει στη διαδικασία εγγραφής του kit σας. Τα στοιχεία αυτά είναι καθοριστικά για την ορθή αποτύπωση των αποτελεσμάτων σας στο προσωπικό report που θα παραλάβετε. Μετά τον έλεγχο και την οριστικοποίηση των στοιχείων,': 'It is important to check the data you provided in the registration process of your kit. This information is important for the correct representation of your results in the personal report that you will receive. After checking and finalising the details, you will',
    'childΕίναι σημαντικό να ελέγξετε τα στοιχεία που έχετε καταγράψει στη διαδικασία εγγραφής του kit σας. Τα στοιχεία αυτά είναι καθοριστικά για την ορθή αποτύπωση των αποτελεσμάτων σας στο προσωπικό report που θα παραλάβετε. Μετά τον έλεγχο και την οριστικοποίηση των στοιχείων,': 'It is important to check the data you provided in the registration process of your kit. This information is important for the correct representation of the results in the personal report that you will receive. After checking and finalising the details, you will',
    ΔΕΝ: 'NOT',
    'θα μπορείτε να κάνετε αλλαγές.': 'be able to make any changes.',
    'Το προσωπικό σου αρχείο εξατομικευμένων αναλύσεων υγείας και ευζωίας': 'Your personal record of personalised health and wellness analyses',
    'Εδώ θα βλέπεις τα αποτελέσματα των test που έχεις εγγράψει, θα μπορείς να εγγράψεις νέα kit που θα αγοράσεις, να δίνεις πρόσβαση σε επαγγελματίες υγείας στα αποτελέσματά σου, εφόσον το επιθυμείς, και να διαχειρίζεσαι το προφίλ σου.': 'Here you have access to the results of your registrered tests. You will be able to register new kits that you purchase, give access to health professionals to view  your results, if you wish, and manage your profile.',
    'Εδώ θα βρεις το εξατομικευμένο report που έχει προκύψει από όλες τις γενετικές και φαινοτυπικές πληροφορίες που συλλέξαμε από σένα. Περιλαμβάνει εκτίμηση του γενετικού σου ρίσκου εμφάνισης καρδιαγγειακών παθήσεων όπως η στεφανιαία νόσος, η μυοκαρδιοπάθεια (διατατική, υπερτροφική), η καρδιακή ανεπάρκεια, η αρρυθμία - κολπική μαρμαρυγή και το ισχαιμικό εγκεφαλικό επεισόδιο.': 'Here you have access to your personalised report that resulted from all genetic and phenotypic information we collected from you. It includes an assessment of your genetic risk of developing cardiovascular diseases such as coronary heart disease, cardiomyopathy (dilated, hypertrophic), heart failure, arrhythmia - atrial fibrillation and ischemic stroke.',
    whatIsTakenIntoAccount: 'For the calculation of the Adjusted PRS, the following are taken into account:',
    important1: 'The iDNA Cardio Health bears CE mark (2022) and has been notified to the National Organization for Medicines (EOF) Medical Devices Register "Gremdis" (Protocol No. 54854 / 23-05-2022).',
    important2: 'It is ideal for healthy adults who want to know if they are at risk of developing any of the conditions examined by the test, for healthy individuals with affected relatives (positive family history) for any of the examined conditions and who have been tested negative for monogenic hereditary causes, and for asymptomatic patients who are either under observation or undergoing minimal conservative treatment by their physician.',
    important3: 'The iDNA Cardio Health aims to calculate Polygenic Risk Score (PRS) through the analysis of genetic variants that affect predisposition to cardiovascular diseases, namely coronary artery disease, cardiomyopathy (dilated cardiomyopathy, hypertrophic cardiomyopathy), heart failure, arrhythmia (atrial fibrillation), and ischemic stroke.',
    important4: 'The methodology of genetic analysis includes the laboratory isolation of DNA from the individual’s sample (non-invasive sampling: buccal smear), DNA analysis by genotyping and bioinformatics analysis of laboratory results using a state-of-the-art genotyping platform. The iDNA Genomics genotyping technology allows for identification of Single Nucleotide Polymorphisms (SNPs) for personalized molecular analysis using microarrays technology and an imputation methodology to infer unobserved genotypes.',
    important5: 'The collection of characteristics related to the lifestyle and phenotype of the individual is achieved through the use of a health questionnaire*. Through this, information is collected about age, biometric data, blood test results, as well as personal habits in relation to diet, exercise, etc. The collection of this type of data aims to assess the current cardiovascular health status of the individual and to adjust his genetic risk to estimate the Adjusted PRS for cardiovascular diseases.',
    important5_2: 'The PRS and the Adjusted PRS aim to improve prevention and assist people to achieve optimal health.',
    important6: 'The interpretation of the results is based on the latest scientific literature reporting research conducted in adult populations. Each sample is subject to quality control and the process is performed and supervised by our scientific personnel',
    important7: 'The personalised report has a counselling nature and results from the combination of the genetic analysis with phenotypic and lifestyle characteristics. If the Polygenic Risk Score places you at increased risk for developing a condition, it does not necessarily mean that you will develop that condition, but only that your predisposition is greater than a part of the population. Accordingly, if the Polygenic Risk Score places you at reduced risk, it does not mean that you will certainly not develop the condition. ',
    important8: 'For the optimal understanding and utilization of the results, it is necessary to seek advice and interpretation from a specialized Health Professional, such as a Geneticist or a Cardiologist.',
    importantLong: 'All controls are performed by specialized scientific personnel, based on the most up-to-date scientific and analytical means. The test results are based on international guidelines and the scientific literature that is currently available and does not include new data, that have not yet been published. The recommendations resulting from this analysis do not take into account all the individual variants of the tested samples and may not be assumed to take into account all appropriate medical care or other treatment methods. iDNA Cardio Health is for advisory use only and is not intended to diagnose, treat or cure any disease or condition. From the results and analysis of the test results, no liability arises for any personal injury or property damage, for any aggravation or deterioration of a person\'s physical or mental health, related to any use of the counseling instructions or for any errors or omissions. Similar PRS genetic tests may use different methodology/algorithms for risk estimation or detect different polymorphisms than those identified in the iDNA Cardio Health kit for these specific conditions. In such cases, there may be different results from another test. The iDNA Cardio Health uses published* cardiovascular disease risk assessment methodology and it is certified as an in vitro diagnostic (IVD) medical device.',
    'Σημείωση Νομικού Περιεχομένου': 'Legal note',
    'Δείγμα Παρειακού Επιχρίσματος': 'Buccal swab sample',
    'Συμπλήρωσε τον νέο σου κωδικό': 'Fill in your new password',
    'Νέος κωδικός': 'New password',
    'Σας έχει σταλεί ο κωδικός στο': 'The code has been sent to you at',
    CodeMismatchException: 'Wrong verification code',
    SelectReportLanguage: 'Language selection',
    reportLanguageCantChange: 'Language selection CANNOT be altered after registration is complete​',
    language: 'Language',
    English: 'English',
    Greek: 'Greek',
    availableLanguages: 'Available languages',
    'Επιλέξτε τη γλώσσα που θέλετε να ολοκληρώσετε την εγγραφή σας και να βλέπετε το προσωπικό σας report αποτελεσμάτων': 'Select your preferred language to complete your registration and view your personalized report',

    'ΓΕΝΙΚΗ ΙΑΤΡΙΚΗ': 'GENERAL MEDICINE',
    ΔΕΡΜΑΤΟΛΟΓΙΑ: 'DERMATOLOGY',
    ΕΝΔΟΚΡΙΝΟΛΟΓΙΑ: 'ENDOCRINOLOGY',
    ΚΑΡΔΙΟΛΟΓΙΑ: 'CARDIOLOGY',
    ΓΥΝΑΙΚΟΛΟΓΙΑ: 'GYNECOLOGY',
    ΝΕΥΡΟΛΟΓΙΑ: 'NEUROLOGY',
    ΝΕΦΡΟΛΟΓΙΑ: 'NEPHROLOGY',
    ΟΡΘΟΠΕΔΙΚΗ: 'ORTHOPEDIC',
    ΠΑΘΟΛΟΓΙΑ: 'PATHOLOGY',
    ΠΑΙΔΙΑΤΡΙΚΗ: 'PEDIATRICS',
    'ΠΛΑΣΤΙΚΗ ΧΕΙΡΟΥΡΓΙΚΗ': 'PLASTIC SURGERY',
    ΦΥΣΙΑΤΡΙΚΗ: 'PHYSICAL MEDICINE',
    ΨΥΧΙΑΤΡΙΚΗ: 'PSYCHIATRY',
    ΔΙΑΒΗΤΟΛΟΓΙΑ: 'DIABETOLOGY',
    ΔΙΑΤΡΟΦΟΛΟΓΙΑ: 'NUTRITION',
    'ΔΙΑΙΤΟΛΟΓΙΑ - ΔΙΑΤΡΟΦΟΛΟΓΙΑ': 'NUTRITION - DIETETICS',
    ΝΟΣΗΛΕΥΤΙΚΗ: 'NURSING',
    ΜΑΙΕΥΤΙΚΗ: 'OBSTETRICS',
    'ΦΥΣΙΚΗ ΑΓΩΓΗ ΚΑΙ ΑΘΛΗΤΙΣΜΟΣ': 'PHYSICAL EDUCATION AND SPORTS',
    ΑΙΣΘΗΤΙΚΗ: 'AESTHETICS',
    ΠΑΙΔΟΨΥΧΙΑΤΡΙΚΗ: 'CHILD PSYCHIATRY',
    ΦΥΣΙΚΟΘΕΡΑΠΕΙΑ: 'PHYSICAL THERAPY',
    ΧΕΙΡΟΥΡΓΙΚΗ: 'SURGERY',
    'Διενέργεια της παραπάνω ανάλυσης, επανάληψη δείγματος αν κριθεί ακατάλληλο, ακριβή και αληθή στοιχεία': 'I provide my consent to the company to proceed with the analysis of my sample, which may be repeated if deemed unsuitable and I declare that my data are accurate and true.',
    'childΔιενέργεια της παραπάνω ανάλυσης, επανάληψη δείγματος αν κριθεί ακατάλληλο, ακριβή και αληθή στοιχεία': 'I provide my consent to the company to proceed with sample analysis, which may be repeated if deemed unsuitable and I declare that the data are accurate and true.',
    'Συλλογή και επεξεργασία των προσωπικών μου δεδομένων που αφορούν σε ειδικών κατηγοριών δεδομένα (γενετικά, υγείας) με σκοπό τη διεξαγωγή της Γενετικής ανάλυσης από την iDNA Genomics': 'I provide my consent for the collection and processing of my personal data for the purposes of the genetic analysis from iDNA Genomics.',
    'childΣυλλογή και επεξεργασία των προσωπικών μου δεδομένων που αφορούν σε ειδικών κατηγοριών δεδομένα (γενετικά, υγείας) με σκοπό τη διεξαγωγή της Γενετικής ανάλυσης από την iDNA Genomics': 'I provide my consent for the collection and processing of my minor’s personal data for the purposes of the genetic analysis from iDNA Genomics.',
    'Χρήση των ανωνυμοποιημένων ή ψευδονυμοποιημένων (με κωδικοποιημένη μορφή) αποτελεσμάτων των γενετικών μου αναλύσεων για ερευνητικούς και στατιστικούς σκοπούς': 'I provide my consent for the use of my anonymized or pseudo-anonymized (in coded form) genetic results for research or statistical purposes.',
    'childΧρήση των ανωνυμοποιημένων ή ψευδονυμοποιημένων (με κωδικοποιημένη μορφή) αποτελεσμάτων των γενετικών μου αναλύσεων για ερευνητικούς και στατιστικούς σκοπούς': 'I provide my consent for the use of my minor’s anonymized or pseudo-anonymized (in coded form) genetic results for research or statistical purposes.',
    'Αποστολή ενημερωτικού και προωθητικού υλικού στην ηλεκτρονική μου διεύθυνση': 'I provide my consent to iDNA Genomics and their partners to send news and promotional material to my email.',
    'Ενημέρωση για την προστασία δεδομένων προσωπικού χαρακτήρα': 'General Data Protection Regulation',
    '8basicFactors': 'The 8 key factors & habits for optimal cardiovascular health:',
    'Είστε σίγουροι ότι θέλετε να ολοκληρώσετε την εγγραφή;': 'Are you sure you want to complete registration?',
    'Επιτυχής Εγγραφή κιτ!': 'Succeful kit registration!',
    'Η αγορά ολοκληρώθηκε επιτυχώς.': 'The purchase was completed successfully.',
    'Όροι Χρήσης & Πολιτική Απορρήτου': 'Terms of Use & Privacy Policy',
    'O Δικτυακός Τόπος': '',
    'δημιουργήθηκε από την εταιρεία IDNA GENOMICS ΙΔΙΩΤΙΚΗ ΚΕΦΑΛΑΙΟΥΧΙΚΗ ΕΤΑΙΡΕΙΑ (στο εξής «Εταιρεία»), που εδρεύει στην Κηφισιά και αποτελεί πνευματική της ιδιοκτησία. Η Εταιρεία προσφέρει τις υπηρεσίες του παρόντος Δικτυακού Τόπου με τους παρακάτω Όρους Χρήσης, τους οποίους ο αποδέκτης των υπηρεσιών (στο εξής «χρήστης» ή απλώς «εσείς») καλείται να διαβάσει προσεκτικά και να προβεί σε χρήση των υπηρεσιών μόνο εφόσον τους αποδέχεται πλήρως και συναινεί στην εφαρμογή τους.': 'is created by the company iDNA GENOMICS PRIVATE CAPITAL  (hereinafter "Company"), which is based in Kifissia and is its intellectual property. The Company offers the services of this website with the following Terms of Use, which the recipient of the services (hereinafter "user" or simply "you") is invited to read carefully and use the services only if he fully accepts them and consents to their application.',
    'Οποιαδήποτε χρήση του Δικτυακού Τόπου και των υπηρεσιών που προσφέρει συνεπάγεται την πλήρη αποδοχή των παρόντων Όρων Χρήσης εκ μέρους σας, οι οποίοι αποτελούν την μοναδική δεσμευτική συμφωνία ανάμεσα σε εσάς και την Εταιρεία και ισχύουν όπως εάν είχαν υπογραφεί εγγράφως.': 'Any use of the website and the services it offers, implies your full acceptance of these Terms of Use, which constitute the only binding agreement between you and the Company and are valid as if they had been signed in writing.',
    'Οι πληροφορίες που θα βρείτε στον Δικτυακό Τόπο προσφέρονται ως γενική πληροφόρηση του κοινού για τα εν λόγω θέματα και σε καμία περίπτωση δεν υποκαθιστούν την εξειδικευμένη και εξατομικευμένη γνώμη επαγγελματιών υγείας στους οποίους θα πρέπει πάντοτε να απευθύνεστε για οποιαδήποτε συμβουλή ιατρικής ή φαρμακευτικής φύσεως. Η Εταιρεία δεν εγγυάται σε καμία περίπτωση την ακρίβεια και ορθότητα των πληροφοριών που θα βρείτε στο site και δεν φέρει καμία ευθύνη για αυτές. Περισσότερες πληροφορίες σχετικά θα βρείτε κατωτέρω στο άρθρο 5 των παρόντων Όρων Χρήσης.': 'The information you find on the website is offered as general information to the public on the subjects in question and in no way replaces the specialised and personalised opinion of health professionals to whom you should always turn for any medical or pharmaceutical advice. The Company does not under any circumstances guarantee the accuracy and correctness of the information you will find on the site and bears no responsibility for them. More information on this can be found below in article 5 of these Terms of Use.',
    'Η Εταιρεία διατηρεί το δικαίωμα να τροποποιεί οποτεδήποτε το περιεχόμενο του Δικτυακού Τόπου και των παρόντων Όρων Χρήσης ακόμη και χωρίς προειδοποίηση. Για τον λόγο αυτό, σας παροτρύνουμε να επισκέπτεστε τακτικά αυτήν την σελίδα και να ενημερώνεστε για κάθε αλλαγή τους.': 'The Company reserves the right to modify the content of the Website and these Terms of Use at any time, even without notice. For this reason, we encourage you to visit this page regularly and be informed of any changes.',
    'Σε οποιαδήποτε τροποποίηση των παρόντων  Όρων Χρήσης, η χρήση εκ μέρους σας των υπηρεσιών του Δικτυακού Τόπου σε μεταγενέστερο της τροποποίησης χρόνο σημαίνει και την εκ νέου αποδοχή εκ μέρους σας των νεότερων Όρων Χρήσης και τη δέσμευσή σας από αυτούς.': 'In any modification of these Terms of Use, your use of the website\'s services at a time subsequent to the modification means your re-acceptance of the newest Terms of Use and your commitment to them.',
    'Η ιστοσελίδα': 'The website',
    hereinafterWebsite: '(hereinafter "website" or "site") provides the following services:',
    Ιδιώτες: 'Customers',
    afterPurchasing: 'After purchasing a genetic analysis kit or the biological age calculation service from iDNA Genomics and/or through its partners (health professionals, etc.), you have the opportunity to:',
    'Δημιουργήσετε τον προσωπικό σας λογαριασμό στην σελίδα': 'Create your personal account at myemr.idnagenomics.com',
    'Να εγγράψετε το Kit που έχετε αγοράσει, εισάγοντας το σειριακό αριθμό που θα βρείτε κολλημένο περιμετρικά του κουτιού. Ο κωδικός αυτός έχει τη μορφή ΑΒ123456, με τα 2 πρώτα ψηφία να αποτελούνται από γράμματα και τα υπόλοιπα έξι από αριθμούς.': 'Register the Kit you purchased by inputting the serial number that you will find on the box. The code has the form of AB123456, with the first 2 digits consisting of letters and the remaining six of numbers.',
    'Να καταχωρήσετε τα προσωπικά σας στοιχεία ή τα στοιχεία του χρήστη που κάνει την λήψη του δείγματος παρειακού επιχρίσματος (ονοματεπώνυμο, διεύθυνση, στοιχεία επικοινωνίας, κλπ.)': 'Input your personal information or the information of the user providing the buccal swab (saliva) sample (name, address, contact information, etc.)',
    'Να ζητήσετε συγκατάθεση από τον θεράποντα ιατρό σας για να μπορέσετε να προχωρήσετε στην παροχή υπηρεσίας Φαρμοκογενετικής ανάλυσης': 'Request consent from your attending doctor to proceed with the Pharmacogenetic analysis service',
    'Να καταχωρήσετε τα στοιχεία του επαγγελματία υγείας που θέλετε να έχει πρόσβαση στα αποτελέσματά σας, στην περίπτωση που το επιθυμείτε.': 'Enter the personal data of the health professional you want to provide access to your results, if you so wish.',
    'Να συμπληρώστε τη Δήλωση Συγκατάθεσης και να ενημερωθείτε για την Προστασία Δεδομένων Προσωπικού Χαρακτήρα του προϊόντος.': 'Provide consent and be informed about the General Data Protection Regulation',
    'Να συμπληρώστε OnLine ερωτηματολόγια αν αυτό είναι απαραίτητο για την παροχή της υπηρεσίας.': 'Complete online questionnaires if requested for the provision of the service.',
    withEMRYouCan: 'In you personal myEMR account, you can:',
    'Να παρακολουθείτε την πορεία της δημιουργίας της προσωπικής σας αναφορά αποτελεσμάτων ανά σειριακό αριθμό που έχετε εγγράψει': 'Track the progress of the creation of your personal result report by the use of the serial number you have registered',
    'Να βλέπετε τις αναφορές αποτελεσμάτων όταν αυτές είναι έτοιμες': 'View results reports when they are ready',
    'Να καταχωρείτε προσωπικά σας στοιχεία, που αφορούν την υγεία σας και την ευζωία σας, στα οποία θα έχετε μόνο εσείς πρόσβαση': 'Register your personal data, concerning your health and well-being, to which only you will have access ',
    'Να έχετε επικοινωνία με τον ιατρό σας ή με επαγγελματίες υγείας που επιθυμείτε': 'Communicate with your preferred doctor or health professional ',
    'Λοιπές υπηρεσίες για τις οποίες θα ενημερώνεστε σε τακτά χρονικά διαστήματα': 'Other services for which you will be informed occasionaly',
    'Φαρμακογενετικές Αναλύσεις': 'Pharmacogenetic Analyses',
    whenYouBuy: 'When purchasing a Pharmacogenetic analysis kit and creating a personal account of an interested party, he is asked for the consent of his treating physician, as a necessary condition for the provision of the service. As a healthcare professional, you have the ability to:',
    'Δημιουργήσετε τον προσωπικό σας λογαριασμό και προφίλ στην σελίδα www.myemr.idnagenomics.com': 'Create your personal account and profile at myemr.idnagenomics.com',
    'Να δώσετε συγκατάθεση στις φαρμακογενετικές αναλύσεις ανά σειριακό αριθμό, που θα σας ζητούνται από τους ασθενείς σας': 'Provide consent to pharmacogenetic analyses by serial number, which will be requested from your patients',
    'Να έχετε άμεση ενημέρωση για την πορεία της δημιουργίας της αναφοράς αποτελεσμάτων ανά σειριακό αριθμό': 'Get instant information on the progress of the creation of the results report by serial number',
    'Να έχετε πρόσβαση στις αναφορές αποτελεσμάτων των ασθενών σας, όταν αυτές είναι έτοιμες': 'Access your patients\' outcome reports when they are ready',
    'Να έχετε επικοινωνία με τον ασθενή σας': 'Communicate with your patient',
    'Genetic Analysis': 'Genetic Analysis',
    'Γενετικές Αναλύσεις/Υπολογισμός Βιολογικής Ηλικίας': 'Genetic Analysis/Calculation of Biological Age',
    whenPurchasingGeneticKit: 'When purchasing a Genetic Analysis Kit or the Biological Age Calculation Service from iDNA Genomics and creating a personal account of an interested party, they are given the option to invite their doctor, nutritionist or any other health professional to access the results reports of course, if the health professional accepts his invitation. As a healthcare professional, you have the ability to:',
    'Δημιουργήσετε τον προσωπικό σας λογαριασμό και προφίλ στην σελίδα': 'Create your personal account and profile at',
    'Να αποδεχτείτε ή όχι την πρόσκληση του ασθενούς/πελάτη σας': 'Approve / disapprove your patient\'s/client\'s invitation',
    'Αν την αποδεχτείτε, να έχετε ενημέρωση για την πορεία της δημιουργίας της αναφοράς αποτελεσμάτων ανά σειριακό αριθμό': 'If you accept it, you will be informed about the progress of the creation of the result report by serial number',
    'Να έχετε πρόσβαση στις αναφορές αποτελεσμάτων των ασθενών/πελάτων σας, όταν αυτές είναι έτοιμες': 'Access your patients\' outcome reports when they are ready',
    'Να έχετε επικοινωνία με τον ασθενή/πελάτη σας': 'Communicate with your patient',
    '1. ΕΜΠΟΡΙΚΑ ΣΗΜΑΤΑ ΚΑΙ ΔΙΚΑΙΩΜΑΤΑ ΠΝΕΥΜΑΤΙΚΗΣ ΙΔΙΟΚΤΗΣΙΑΣ': '1. TRADEMARKS AND INTELLECTUAL PROPERTY RIGHTS',
    'Ο Δικτυακός Τόπος δημιουργήθηκε από την Εταιρεία και στο σύνολό του αποτελεί πνευματική ιδιοκτησία της, σύμφωνα με το νόμο 2121/1993 «Περί Πνευματικής Ιδιοκτησίας», όπως αυτός έχει τροποποιηθεί και ισχύει σήμερα και τις διεθνείς συμβάσεις που έχει υπογράψει η Ελλάδα.': 'The Website was created by the Company and as a whole is its intellectual property, in accordance with Law 2121/1993 "On Intellectual Property", as amended and in force today, and the international agreements signed by Greece.',
    'Η Εταιρεία διατηρεί τα αποκλειστικά δικαιώματα πνευματικής ιδιοκτησίας στο σχεδιασμό, τον πηγαίο κώδικα και στο σύνολο του περιεχομένου του Δικτυακού Τόπου (συμπεριλαμβανομένων εικόνων, γραφικών, φωτογραφιών, βίντεο, σχεδίων, κειμένων, άρθρων, επιστημονικών παρουσιάσεων και μελετών, των παρεχομένων υπηρεσιών και γενικά όλων των αρχείων αυτού του Δικτυακού Τόπου) στο βαθμό που τα δικαιώματα αυτά δεν ανήκουν ήδη σε τρίτα πρόσωπα. Τυχόν παραβίαση των δικαιωμάτων αυτών με οποιονδήποτε τρόπο επισύρει τις ευθύνες και ποινές που ορίζει ο νόμος. Ενδεικτικά και όχι περιοριστικά απαγορεύεται η επεξεργασία, αντιγραφή, τροποποίηση, διανομή με οποιονδήποτε τρόπο, του περιεχομένου του Δικτυακού Τόπου καθώς και η με οποιονδήποτε τρόπο μη εξουσιοδοτημένη χρήση του λογισμικού του.': 'The Company retains the exclusive intellectual property rights to the design, source code and all of the content of the Website (including images, graphics, photos, videos, designs, texts, articles, scientific presentations and studies, the services provided and generally all files of this Website) to the extent that these rights do not already belong to third parties. Any violation of these rights in any way entails the responsibilities and penalties defined by law. Indicative and not restrictive, the processing, copying, modification, distribution in any way of the content of the Website is prohibited, as well as the unauthorized use of its software in any way.',
    'Τα λογότυπα που περιέχονται στον Δικτυακό Τόπο αποτελούν κατατεθειμένα εμπορικά σήματα της Εταιρείας (ή τρίτων συμβληθέντων με αυτή) και προστατεύονται από τις σχετικές διατάξεις του ελληνικού και ευρωπαϊκού δικαίου, και διεθνών συμβάσεων και συνθηκών. Η χρήση αυτών των εμπορικών σημάτων χωρίς έγγραφη άδεια του δικαιούχου απαγορεύεται απολύτως.': 'The logos contained in the Website are registered trademarks of the Company (or of third parties contracted with it) and are protected by the relevant provisions of Greek and European law, and international conventions and treaties. Use of these trademarks without the written permission of the owner is strictly prohibited.',
    '2. ΧΡΗΣΗ ΤΩΝ ΥΠΗΡΕΣΙΩΝ': '2. USE OF THE SERVICES',
    'Οι υπηρεσίες του Δικτυακού Τόπου παρέχονται για προσωπική, μη εμπορική χρήση μόνο.': 'The Website services are provided for personal, non-commercial use only.',
    '3. ΠΡΟΣΩΠΙΚΑ ΔΕΔΟΜΕΝΑ': '3. PERSONAL DATA',
    onlyPersonalDataCollected: 'The only personal data collected are those for which you have already given your consent and which are stored and processed in accordance with applicable law. Your personal data will not be disclosed or communicated to persons or entities for which you have not explicitely given your consent. As an exception, the legal and physical persons who cooperate with the Company have the right to process the data you have declared, only to the extent that it is absolutely necessary to provide technical or other support to the Website or to serve any requests and are bound by corresponding terms of respect for the privacy and security of your data.',
    youCanDenyCollection: 'Finally, you have the right at any time to be informed about the data that the Company holds about you, as well as to raise any objection to the processing, by contacting the address info@idnagenomics.com',
    '4. COOKIES': '4. COOKIES',
    cookiesExplanation: 'The Website uses cookies to recognise you in some of its services and pages. A cookie is a small piece of data that is sent to your browser from a web server and stored on your computer\'s hard drive. Cookies do not damage your system and do not affect its functionality in any way. They act as a kind of "memory" of your device and preferences and in this way make navigation on the Website easier, saving your settings and showing you information that may be of interest to you. In addition to those absolutely necessary for its operation, this Website uses targeting and advertising cookies, for the use of which we ask for your consent during your first visit to the Website. These cookies do not prevent your navigation on the Website in case you refuse their operation. We may allow the use of cookies on the Website by third parties whose advertisements or services may be included on the Website. In this case we do not control and are not held responsible for the use and operation of these third-party cookies and you should be informed about their use by third-party websites. You can refuse the use of cookies on this Website, or set your server (browser) in such a way that you are warned about the use of cookies or completely prohibit it.',
    '5. ΠΕΡΙΟΡΙΣΜΟΣ ΤΗΣ ΕΥΘΥΝΗΣ': '5. LIMITATION OF LIABILITY',
    'Η Εταιρεία μέσω του Δικτυακού Τόπου δεν παρέχει ιατρικές ή φαρμακευτικές συμβουλές και σε καμία περίπτωση οι αναγραφόμενες ή παρατιθέμενες στον Δικτυακό Τόπο πληροφορίες δεν μπορούν να αντικαταστήσουν ιατρικές γνωματεύσεις.': 'The Company through the Website does not provide medical or pharmaceutical advice and in no case the information listed on the Website can replace medical opinions.',
    'Η Εταιρεία δεν εγγυάται την ακρίβεια, εγκυρότητα ή επιστημονική ορθότητα των πληροφοριών που περιλαμβάνονται στον Δικτυακό Τόπο με οποιαδήποτε μορφή και αν παρέχονται, π.χ. εικόνες, βίντεο, κείμενα κ.τ.λ. Τα κείμενα που συμπεριλαμβάνονται σε αυτόν είτε ως συνοδευτικά των προϊόντων (βασικά χαρακτηριστικά και ιδιότητες) είτε ως άρθρα, έχουν γενικό πληροφοριακό χαρακτήρα και ακόμη και εάν προέρχονται από ειδικούς, δεν αποτελούν σε καμία περίπτωση εξατομικευμένες ιατρικές ή φαρμακευτικές συμβουλές και δεν υποκαθιστούν με κανένα τρόπο τη σχέση σας με τον προσωπικό σας ιατρό ή σύμβουλο υγείας, τον οποίο οφείλετε να συμβουλεύεστε για οποιοδήποτε θέμα αφορά την υγεία σας. Οι πληροφορίες και συμβουλές που παρέχονται δεν πρέπει σε καμία περίπτωση να θεωρηθούν ως παραίνεση για συγκεκριμένη ενέργεια, προτροπή προς αγορά ή να εκληφθούν ως θεραπευτικός ισχυρισμός σε συγκεκριμένη περίπτωση. Τυχόν ενέργειες των χρηστών που έγιναν βάσει των αναφερομένων στον Δικτυακό Τόπο πληροφοριών δεν γεννούν σε καμία περίπτωση ευθύνη της Εταιρείας.': 'The Company does not guarantee the accuracy, validity or scientific correctness of the information included in the Website in any form they are provided, e.g. images, videos, texts, etc. The texts included in it, either as accompanying products (basic features and properties) or as articles, have a general informational nature and even if they come from experts, they do not in any way constitute personalised medical or pharmaceutical advice and do not in any way replace your relationship with your personal dosctor or health advisor, whom you should consult about any matter concerning your health. The information and advice provided should in no way be considered as a recommendation for a specific action, a solicitation to purchase or be taken as a therapeutic claim in a specific case. Any user actions taken on the basis of the information mentioned on the Website do not in any case give rise to the responsibility of the Company.',
    'Η Εταιρεία δεν ευθύνεται για οποιασδήποτε μορφής ζημία υποστεί ο χρήστης των σελίδων, υπηρεσιών, επιλογών και περιεχομένων του Δικτυακού Τόπου, στην χρήση των οποίων προβαίνει με αποκλειστικά δική του πρωτοβουλία και ευθύνη.': 'The Company is not responsible for any form of damage suffered by the user of the pages, services, options and contents of the Website, the use of which is solely on his own initiative and responsibility.',
    '6. ΑΠΟΥΣΙΑ ΕΓΓΥΗΣΗΣ': '6. NO WARRANTY',
    'Το περιεχόμενο του Δικτυακού Τόπου παρέχεται «όπως ακριβώς είναι» χωρίς καμία εγγύηση ρητή ή τεκμαιρόμενη με οποιοδήποτε τρόπο, σχετικά με την εμπορευσιμότητα ή την καταλληλότητα του για συγκεκριμένο σκοπό.': 'The content of the Website is provided "as is" without warranty of any kind, stated or implied, of merchantability or fitness for a particular purpose.',
    'Δεν παρέχεται καμία ρητή εγγύηση, ότι οι σελίδες, οι υπηρεσίες, οι λειτουργίες, οι επιλογές και τα περιεχόμενά του Δικτυακού Τόπου θα παρέχονται χωρίς διακοπή, χωρίς σφάλματα και ότι τα λάθη θα επιδιορθώνονται. Επίσης μολονότι καταβάλλουμε κάθε δυνατή προσπάθεια, δεν παρέχεται καμία εγγύηση ότι ο Δικτυακός Τόπος δεν περιέχει «ιούς» ή άλλα επιζήμια συστατικά.': 'No warranty is given that the pages, services, functions, options and contents of the Website will be provided without interruption, without errors and that errors will be corrected. Also, although we make every effort, no guarantee is made that the Site is free of "viruses" or other harmful components.',
    'Σε καμία περίπτωση η Εταιρεία, οι εργαζόμενοί της ή τα πρόσωπα που συνδέονται με αυτήν δεν είναι υπεύθυνοι απέναντί σας για οποιαδήποτε τυχόν ζημία σας προκληθεί από την χρήση του Δικτυακού Τόπου.': 'In no case shall the Company, its employees or the persons connected with it be responsible towards you for any possible damage caused to you by the use of the Website.',
    '7. ΕΞΩΤΕΡΙΚΕΣ ΣΥΝΔΕΣΕΙΣ': '7. EXTERNAL LINKS',
    linksExp1: 'The Website may include links to other websites, which are controlled by third parties. In no case is the Company responsible for their content, nor for any financial or other damage suffered by the user who follows them. In no case does the Company guarantee that these links will work uninterrupted. Furthermore, external links are indicative and not exclusive or restrictive. The Company reserves the right to remove or add links without any warning to anyone and to change the content of the Website at any time.',
    linksExp2: 'By accessing the Website you understand and accept that the Company is in no way responsible for the content of the hyperlinks it includes, the services or products they offer or the advertisements they contain.',
    '8. ΕΦΑΡΜΟΣΤΕΟ ΔΙΚΑΙΟ ΚΑΙ ΛΟΙΠΟΙ ΟΡΟΙ': '8. GOVERNING LAW AND OTHER TERMS',
    'Οι ανωτέρω όροι και προϋποθέσεις χρήσης του Δικτυακού Τόπου, καθώς και οποιαδήποτε τροποποίηση τους, διέπονται και συμπληρώνονται από το ελληνικό δίκαιο, το δίκαιο της Ευρωπαϊκής Ένωσης και τις σχετικές διεθνείς συνθήκες, που έχει υπογράψει η Ελλάδα. Όλοι οι ανωτέρω όροι συνομολογούνται ως ουσιώδεις.': 'The above terms and conditions of use of the Website, as well as any modification thereof, are governed and supplemented by Greek law, European Union law and the relevant international treaties signed by Greece. All the above terms are agreed to be essential.',
    'Οποιαδήποτε διάταξη των ανωτέρω όρων καταστεί αντίθετη προς το νόμο, παύει αυτοδικαίως να ισχύει και αφαιρείται από το παρόν, χωρίς σε καμία περίπτωση να θίγεται η ισχύς των λοιπών όρων.': 'Any provision of the above terms that become contrary to the law, automatically cease to be valid and is removed from this, without in any way affecting the validity of the other terms.',
    'Εάν δεν συμφωνείτε με τους παρόντες Όρους Χρήσης οφείλετε να μη χρησιμοποιείτε τις υπηρεσίες του Δικτυακού Τόπου.': 'If you do not agree with these Terms of Use, you must not use the services of the Website.',
    'Αναμονή Εγκρισης Εγγραφής': 'Your account is pending approval.',
    'Η πρόσβασή σας δεν είναι διαθέσιμη αυτή τη στιγμή.': 'Your account is pending approval.',
    'Παρακαλούμε επικοινωνήστε μαζί μας για διευκρινίσεις σχετικά με το λογαριασμό σας.': 'Please contact us for further information regarding your account.',
    iConsent: 'I consent',
    iDontConsent: 'I don\'t consent',
    'Εκκρεμείς συγκαταθέσεις': 'Pending consents',
    'Έχετε αιτήματα για να δώσετε συγκατάθεση. Μπορείτε να δώσετε ή να μη δώσετε την συγκατάθεσή σας πατώντας το αντίστοιχο κουμπί.': 'You have requests to process. You can choose to approve/dissaprove by selecting the corresponding option.',
    'Ο χρήστης με όνομα': 'User named',
    'και serial': 'with serial',
    'ζητάει την συγκατάθεσή σας.': 'requests your consent.',
    'Είστε σίγουρος ότι θέλετε να δώσετε τη συγκατάθεσή σας;': 'Are you sure you want to give your consent?',
    'Είστε σίγουρος ότι ΔΕΝ θέλετε να δώσετε τη συγκατάθεσή σας;': 'Are you sure you do NOT want to give consent?',
    'Ο χρήστης με serial': 'User with serial number',
    'και όνομα': 'and name',
    'σας προσκαλεί για να τον παρακολουθήσετε': 'has sent you an invitation to have access to his/her personal file',
    'είναι διαθέσιμο στην επιλογή Λίστα ασθενών / πελατών.': 'is available in the List of patients / clients option.',
    'Ο χρήστης': 'User',
    'and serial number': 'and serial number',
    'είναι διαθέσιμο στην επιλογή Αποτελέσματα.': 'is available in the Results option.',
    'Ο Ιατρός δεν έχει δώσει συγκατάθεση για την διεξαγωγή του τέστ Φαρμακογενετική ανάλυση CNS PGx kit με serial number': 'The Doctor has not given consent to carry out the test Pharmacogenetic analysis CNS PGx kit with serial number',
    'Ο Ιατρός έχει προβεί σε συγκατάθεση για την διεξαγωγή του τέστ Φαρμακογενετική ανάλυση CNS PGx kit με serial number': 'The Doctor has given consent to carry out the test Pharmacogenetic analysis CNS PGx kit with serial number',
    Ο: '',
    'έχει αποδεχτεί την πρόσκληση για να αποκτήσει πρόσβαση στον προσωπικό σας φάκελο στην υπηρεσία myEMR της iDNA Genomics για το τεστ': 'has accepted the invitation to access your personal file in myEMR of iDNA for the test',
    'δεν αποδέχεται την πρόσκληση για να αποκτήσει πρόσβαση στον προσωπικό σας φάκελο στην υπηρεσία myEMR της iDNA Genomics για το τεστ': 'has not accepted the invitation to access your personal file in myEMR of iDNA for the test',
    reportLanguage: 'Report language',
    'Select a registered kit for which you wish to send an invitation to your doctor': 'Select a registered kit for which you wish to send an invitation to your doctor',
    'Δεν αποδέχτηκε': 'Rejected',
    invitationAlreadyExists: 'Invitation Already Exists',
    ή: 'or',
    International: 'International',
    SelectEmailLanguage: 'Email language',
    formalHello: 'Hello',
    doctorHello: 'Welcome to myEMR',
    mr: 'Mr.',
    mrs: 'Mrs.',
    notSend: 'Not sent',
    notSend1: 'Not sent',
    sendThroughPlatform: 'Sent by platform',
    sendThroughPlatform1: 'Sent by platform',
    'Serial and last name search': 'Search by serial number or last name',
    sendIndividually: 'Sent individually',
    sendIndividually1: 'Sent individually',
    confirm: 'Confirm',
    product: 'Product',
    patientFirstName: 'Patient\'s first name',
    patientLastName: 'Patient\'s last name',
    patientEmail: 'Patient\'s email',
    'Πρόσκληση παρακολούθησης ασθενών/πελατών': 'Patient\'s / client\'s invitations monitoring',
    'Πρόσκληση παρακολούθησης ασθενών': 'Patient\'s invitations monitoring',
    'Εγγραφή & αποτελέσματα ασθενών/πελατών': 'Registration & Results for patients / clients ',
    'Εγγραφή & αποτελέσματα ασθενών': 'Registration & Results for patients',
    sendByEmail: 'Send by Email',
    filters: 'Filters',
    patientsClientsData: 'Patients/clients data',
    selectLanguageDoctor: 'Select your preferred language to complete the registration and view your patients\'/clients\' reports',
    pgxSelectLanguageDoctor: 'Select the language in which you want to complete the registration and view your patient\'s results reports',
    doctBioGenderDefinition: 'biological gender is defined as the gender they were assigned at birth',
    patientPersonalData: 'Patient\'s/client\'s personal data',
    onlyPatientPersonalData: 'Patient personal data',
    pleaseEnterTheDataOfThePerson: 'Please enter the details of the person who provided the sample.',
    docSendInstructionsContent: 'Place the saliva sample in the Test Kit box, and return it to the below shipping address',
    docSendInstructionsContent1: 'Genome 1st, 445 N. Rossmore Ave, APT 217, Los Angeles, CA 90004, USA',
    docSendInstructionsContent2: 'Tel: +310 5707860',
    within30DaysDoctor: 'Your patient’s/ client’s personalized report will be accessible in your account within {{days}} business days from the day our laboratory receives the saliva sample. A notification will be sent to your registered email. You will be able to view, download, send it through the platform or by email.',
    within30DaysChild: 'The personalized report will be accessible in your account within {{days}} business days from the day our laboratory receives the saliva sample. A notification will be sent to your registered email. In the case you have requested to provide access for a third party to your electronic file and the third party has accepted it, a notification will also be sent to the third party’s email to have access to the personalized report.',
    within30DaysDoctorPGx: 'Within {{days}} business days of receipt of the buccal swab sample from our laboratory, your patient/client results report will be available in your myEMR account. A notification will be sent to your email. You will be able to view, download, send through the platform or by email your personalized patient results report.',
    'Επίλεξε προφίλ': 'Select type of account',
    reviewYourAnwsers1: 'It is important to check the data you provided in the registration process of the kit. This information is important for the correct representation of the results in the report that you will receive. After checking and finalizing the details, you will',
    reviewYourAnwsers1PGx: 'It is important to check the data you provided in the registration process of the kit. This information is important for the correct representation of the results in the report that you will receive. After checking and finalizing the details, you will',
    'Απαιτείται αποδοχή του Συμφωνητικoύ Επεξεργασίας Προσωπικών Δεδομένων': 'Acceptance of the agreement regarding processing of personal data',
    reviewYourAnwsers2: 'be able to make any changes.',
    'Εμφάνιση στοιχείων': 'Display data',
    'Δεν έχετε κιτ που εκκρεμούν εγγραφή': 'You have no pending kit for registration.',
    'Status αποστολής report': 'Status of sent reports',
    referential_part1: 'Enter the reference number for the iDNA PGx CNS pharmacogenetic test in the field below.',
    'Είσαι Ιδιώτης;': 'Personal account?',
    'Είσαι Ιατρός': 'Doctor',
    'Επαγγελματίας υγείας;': 'health professional?',
    'Επόμενο Βήμα': 'Proceed',
    'PROCESSING OF PERSONAL DATA': 'Processing of personal data',
    'Status Αποστολής Report': 'Sent Report Status',
    'Παρακαλώ εισάγεται τα απαιτούμενα στοιχεία. Τα δεδομένα αυτά θα χρησιμοποιηθούν προκειμένου η iDNA να μπορέσει να έρθει σε επικοινωνία.': 'Please enter the required information. This data will be used in order for iDNA to contact you.',
    'Γονέας ή κηδεμόνας': 'Parent or guardian',
    Ημέρα: 'Day',
    Ώρα: 'Hour',
    closeAppointmentExplanation: 'Book your appointment with our scientific team for a one-to-one consultation on your personal results.',
    phoneCall: 'Call',
    videoCall: 'Video call',
    appointmentAlreadyBooked: 'An appointment with this serial has already been booked.',
    invalidAppointment: 'An error occured while creating the appointment',
    'iDNA Cardio Health kit': 'iDNA Cardio Health kit',
    'iDNA 3 σε 1': 'iDNA 3in1',
    'iDNA Διατροφή': 'iDNA Nutrition',
    'Τύπος Ραντεβού': 'Type of appointment',
    'Διαθέσιμα slot': 'Available slot(s)',
    'Δεν υπάρχουν διαθέσιμα slot αυτή τη μέρα.': 'There are no available slot(s) for this day',
    'Έχετε απορίες;': 'Do you have any questions?',
    Yπηρεσία: 'Service',
    'Συγκατάθεση ως γονέας ή κηδεμόνας': 'Consent as a parent or guardian',
    'Όνομα γονέα ή κηδεμόνα': 'Parent or guardian\'s name',
    whatYouWillFindNutrition: 'Here you will find your Personal Genetic Analysis (DNA Test) based on genes related to Nutrition. This knowledge will have an advisory role in choosing the appropriate nutrition plan towards better health.',
    'Είσαι εταιρικός πελάτης?': 'Corporate account?',
    'Διαγνωστικό Κέντρο': 'Diagnostic Center',
    'Σύνδεση στο λογαριασμό σου.': 'Connect to your account.',
    'Αποτελεί ένα ασφαλές και εύχρηστο σύστημα έτσι ώστε ιδιώτες και επαγγελματίες υγείας να εγγράφουν, αποθηκεύουν, διαχειρίζονται και διαμοιράζονται πληροφορίες.': 'It is a secure and easy-to-use platform for individuals and healthcare professionals to register, store, manage and share health data. It is designed with security and privacy in mind.',
    'Η πλατφόρμα αποτελεί το προσωπικό αρχείο εξατομικευμένων αναλύσεων υγείας και ευζωίας σας.': 'Your personal record of personalized health and wellness analyses',
    Monitoring: 'Monitoring',
    'Επανάληψη κωδικού': 'Re-enter new passoword',
    'Παρακολούθηση πορείας (status) των γενετικών αναλύσεων': 'Monitoring the progress (status) of the genetic analyses',
    Λογαριασμός: 'Account',
    'Online εγγραφή test': 'Online test registration',
    Διαμοιρασμός: 'Sharing',
    'Διαχείριση γενετικών αποτελεσμάτων': 'Ability for healthcare professionals to access your results file',
    Διαχείριση: 'Management',
    'Δυνατότητα πρόσβασης από επαγγελματίες υγείας': 'Management of genetic results ',
    Πλεονεκτήματα: 'Advantages',
    'iDNA Test Άθλησης': 'iDNA Test Sports',
    'iDNA Test Βιταμίνες & Ιχνοστοιχεία': 'iDNA Test Vitamins & Minerals',

    'Επικοινωνήστε μαζί μας': 'Contact us',
    'Χρειάζεσαι βοήθεια;': 'Need help?',
    'Για άμεση εξυπηρέτηση καλέστε μας στο': 'For support call us',
    '(Δευτέρα – Παρασκευή 9πμ.- 5μμ.)': '(Monday-Friday 9am-5pm)',
    'Αποστολή email': 'Email us',

    patientClientFirstName: 'Patient/client first name',
    patientClientLastName: 'Patient/client last name',
    patientClientEmail: 'Patient/client email',
    'Στοιχεία ασθενούς': 'Patient\'s personal data',

    'Στοιχεία ασθενή/πελάτη': 'Patient/client personal data',

    heAgrees: 'Agrees',
    Ευκολία: 'Ease',
    'Εύκολη πρόσβαση στα αρχεία': 'Easy access to files',
    Αρχειοθέτηση: 'Archive',
    'Ψηφιακό αρχείο γενετικών αποτελεσμάτων': 'Digital archive of genetic results ',
    Έλεγχος: 'Control',
    'Έλεγχος των προσωπικών σας δεδομένων': 'Control of your personal data',
    Προσβασιμότητα: 'Accessibility',
    'Προσβασιμότητα και δυνατότητα αναζήτησης δεδομένων': 'Accessibility and searchability of data',
    Ασφάλεια: 'Security',
    'Ασφάλεια βάση αυστηρών πρωτόκόλλων': 'Security based on strict protocols',
    Κοινοποίηση: 'Sharing',
    'Διαμοιρασμός αρχείων με επαγγελματίες υγείας': 'File sharing with healthcare professionals',
    'Σχετικά Προϊόντα': 'Available products',

    'Οι κωδικοί πρέπει να είναι ίδιοι': 'Passwords must be the same',
    'Το email σας δε βρέθηκε στη βάση': 'Your email was not found in the database',
    Υπηρεσίες: 'Services',
    'Για Ιδιώτες': 'For individuals',
    'Για Επαγγελματίες': 'For professionals',
    Ιδιώτης: 'Personal account',
    'Ιατρός ή επαγγελματίας υγείας': 'Doctor / health professional account',
    'Κλείσε ραντεβού': 'Book an appointment',
    'Πληροφορίες του πελάτη': 'User\'s data',
    'Καλέστε στο 2111021854-5 για βοήθεια': 'Call 2111021821 for assistance',
    'Επέλεξε ένα slot': 'Select a time slot',
    'Επιβεβαιώστε τα στοιχεία του ραντεβού': 'Confirm your appointment details',
    'Ελέγξτε τα στοιχεία της κράτησης σας και πατήστε το κουμπί Επιβεβαίωση αν όλα είναι όλα σωστά.': 'Check your booking details and select the Confirm button to verify.',
    'Πληροφορίες Ραντεβού': 'Appointment info',
    'Ημερομηνία και ώρα': 'Date and time',
    'Επιστημονικός σύμβουλος': 'Scientific advisor',
    'Είσαι σίγουρος ότι θέλεις να ακυρώσεις το ραντεβού σου;': 'Are you sure you want to cancel your appointment?',
    'Το ραντεβού ακυρώθηκε επιτυχώς.': 'The appointment was successfully cancelled.',
    'Το ραντεβού δημιουργήθηκε επιτυχώς.': 'The appointment was created successfully.',
    'Το ραντεβού σας καταχωρήθηκε με επιτυχία': 'Your appointment was registered successfully.',
    'Επιβεβαίωση ραντεβού': 'Appointment confirmation',
    'Επιβεβαίωση #': 'Confirmation #',
    hereYouWillFind3InOne: 'Here you will find your personal Genetic Analysis (DNA Test), based on genes related to Nutrition, Sports, Vitamins and Minerals.',
    learnHowGenes: 'You will learn how your genes affect:',
    learnWeightControl: 'Your weight management, your cardiovascular health, your detoxification capacity & antioxidant needs, as well as your sensitivity to dietary elements.',
    learnAbsorbVitamins: 'The ability of your body to absorb and process vitamins and minerals from the food you eat, but also the possible impact of your genes on their levels.',
    learnAthleticProfile: 'Your athletic profile of strength, power and endurance, your aerobic capacity and muscle development, your injury predisposition, the post-workour ability to recover, as well as your personal motivation to exercise.',
    'Δεν έχεις επιλέξει κάποιο slot.': 'You haven\'tselected a slot.',
    'Συμπληρώστε το όνομα του γονέα ή κηδεμόνα.': 'Fill in the parent or guardian\'s name.',
    'Εντός {{days}} εργάσιμων ημερών από την παραλαβή του δείγματος παρειακού επιχρίσματος από το εργαστήριό μας, η έκθεση αποτελεσμάτων του πελάτη/ασθενή σας θα είναι διαθέσιμη στο λογαριασμό σας στο myEMR. Θα σας σταλεί ειδοποίηση στο ηλεκτρονικό σας ταχυδρομείο. Θα μπορείτε να δείτε, να κατεβάσετε, να αποστείλετε μέσω της πλατφόρμας ή μέσω email την εξατομικευμένη έκθεση αποτελεσμάτων του πελάτη/ασθενή σας.': 'Εντός {{days}} εργάσιμων ημερών από την παραλαβή του δείγματος παρειακού επιχρίσματος από το εργαστήριό μας, η έκθεση αποτελεσμάτων του πελάτη/ασθενή σας θα είναι διαθέσιμη στο λογαριασμό σας στο myEMR. Θα σας σταλεί ειδοποίηση στο ηλεκτρονικό σας ταχυδρομείο. Θα μπορείτε να δείτε, να κατεβάσετε, να αποστείλετε μέσω της πλατφόρμας ή μέσω email την εξατομικευμένη έκθεση αποτελεσμάτων του πελάτη/ασθενή σας.',
    'Η βιολογική σου ηλικία υπολογίστηκε βάσει των αιματολογικών σου εξετάσεων που πραγματοποιήθηκαν στις x/x/xx και τα αποτελέσματα ελέγχθηκαν από την εξειδικευμένη επιστημονική ομάδα μας.': 'Your biological age was calculated based on your blood test performed on {{date}} and the results were checked by our specialized scientific team.',
    getToKnowYourActualAge: 'Get to know your actual age!',
    'Η βιολογική σου ηλικία υποδεικνύει την κατάσταση της υγείας σου και τη λειτουργική ικανότητα του οργανισμού σου.': 'Your biological age indicates your health status and the functional capacity of your organism.',
    'Εξηγεί γιατί άτομα της ίδιας χρονολογικής ηλικίας έχουν βαθιές διαφορές μεταξύ τους.': 'It explains why people of the same chronological age have profound differences between them.',
    bioAgeKnowledge: 'Knowledge and systematic monitoring of your biological age, combined with the appropriate interventions, allows you to extend both your healthspan and lifespan, in addition to shrinking the number of years associated with the onset of diseases of aging. iDNA Biological Age is designed to help you do just that.',
    'Δες το report σου': 'View your report',
    'Η βιολογική σου ηλικία είναι': 'Your biological age is:',
    'Ο ρυθμός γήρανσής σου είναι': 'Your rate of aging is:',
    Συμβουλή: 'Advice',
    'To ιστορικό της βιολογικής σου ηλικίας': 'Your biological age history',
    'Μέσω της συχνής παρακολούθησης της βιολογικής σου ηλικίας και του ρυθμού γήρανσης μπορείς να βγάλεις πολύτιμα συμπεράσματα για την μεταβολή της τάσης της λειτουργικής σου ικανότητας και της συνολικής υγείας σου στον χρόνο. Μπορείς επιπλέον να κατανοήσεις την επίδραση καθημερινών σου συνηθειών στην υγεία και να παρατηρήσεις τα οφέλη θετικών παρεμβάσεων για την ευζωία και τη μακροζωία, όπως ένα νέο χόμπι, μια νέα διατροφή ή ένα νέο πρόγραμμα εκγύμνασης.': 'Through the frequent monitoring of your biological age and rate of aging, you can derive valuable insight from the change in trend of your overall health over time. You can also comprehend the effect of daily habits on your health and observe the benefits of positive interventions on well-being and longevity, such as a new hobby, a new diet, or a new workout plan.',
    'Προσπάθησε να διατηρείς τη βιολογική σου ηλικία χαμηλότερα από τη χρονολογική. Αν η βιολογική σου ηλικία ξεπεράσει τη χρονολογική, να θυμάσαι ότι η βιολογική ηλικία είναι εύπλαστη και θετικές παρεμβάσεις για την υγεία μπορούν να επιβραδύνουν ή ακόμη και να επαναφέρουν τη βιολογική σου ηλικία σε νεότερη κατάσταση.': 'Aim to keep your biological age lower than your chronological age. If your biological age exceeds your chronological age, then remember that biological age is plastic and thus positive health interventions can slow it down or even reverse it back to a younger state.',
    Ιστορικό: 'History',
    Βιοδείκτες: 'Biomarkers',
    Λειτουργία: 'Function',
    'Φυσιολογικές τιμές': 'Normal range',
    Αποτέλεσμα: 'Result',
    'Αλβουμίνη (g/dL)': 'Albumin (g/dL)',
    'Αλκαλική φωσφατάση (U/L)': 'Alkaline phosphatase (U/L)',
    'Κρεατινίνη (mg/dL)': 'Creatinine (mg/dL) ',
    'C-αντιδρώσα πρωτεΐνη (CRP) (mg/L)': 'C-reactive protein (CRP) (mg/L)',
    'Σάκχαρο (mg/dL)': 'Glucose (mg/dL)',
    'Λεμφοκύτταρα (%)': 'Lymphocyte (%)',
    'Μέσος όγκος ερυθρών (fL)': 'Mean cell volume (fL)',
    'Εύρος κατανομής ερυθρών (RDW) (%)': 'Red blood cell dist. width (RDW) (%)',
    'Λευκά αιμοσφαίρια (κ×10³/μL)': 'White blood cells (κ×10³/μL)',
    'Αιμοσφαιρίνη (g/dL)': 'Hemoglobin (g/dL)',
    'Αιματοκρίτης (%)': 'Hematocrit (%)',
    'Δείκτης μάζας σώματος (BMI)': 'Body mass index (BMI)',
    Ηπατική: 'Liver',
    Νεφρική: 'Kidney',
    Φλεγμονή: 'Inflammation',
    Μεταβολισμός: 'Metabolic',
    Ανοσοποιητική: 'Immune',
    Αιματολογική: 'Hematological',
    'Σωματικό βάρος': 'Body weight',
    'Αιματολογικές εξετάσεις': 'Blood tests',
    'Αποτελέσματα έκφραση δεκαδικών με τελεία (.)': 'Decimal expression with period (.)',
    'Φυσιολογικές Τιμές (από - έως)': 'Normal Range (from - to)',
    pleaseCheckSubmittedData: 'Please check carefully that you have filled in all the fields in the units of measurement requested. The units of measurement may differ from those shown in your test results, and explanations are given for their conversion. We are not responsible for any error in the Biological Age report resulting from incorrect completion of the questionnaire.',
    'Βέλτιστο εύρος': 'Optimal range',
    'Κανονικό εύρος αλλά πάνω από το βέλτιστο': 'Normal range but above optimal',
    'Κανονικό εύρος αλλά κάτω από το βέλτιστο': 'Normal range but below optimal',
    'Πάνω από το φυσιολογικό εύρος': 'Above normal range',
    'Kάτω από το φυσιολογικό εύρος': 'Below normal range',
    'Συνέχισε έτσι': 'Keep it up',
    'Περιθώριο βελτίωσης': 'Room for improvement',
    'Συμβουλευτείτε το γιατρό σας': 'Consult your doctor',
    siteOrInternetPlace: '(στο εξής «Δικτυακός Τόπος» ή «site») παρέχει τις παρακάτω υπηρεσίες: ',
    afterBuyingAKit: 'Μετά την αγορά ενός kit γενετικής ανάλυσης ή της υπηρεσίας υπολογισμού βιολογικής ηλικίας από την iDNA Genomics ή/και μέσω των συνεργατών της (επαγγελματίες υγείας, κ.α.), έχετε τη δυνατότητα να: ',
    insideYourPersonalFolderYouCan: 'Μέσα στον προσωπικό σας λογαριασμό myEMR, μπορείτε να:',
    asAHealthProfessionalYouCan: 'Σαν επαγγελματίας υγείας, έχετε τη δυνατότητα να:',
    personalInfoText: 'Τα προσωπικά στοιχεία (δεδομένα προσωπικού χαρακτήρα – ειδικής κατηγορίας και μη) συλλέγονται στην πλατφόρμα MyEmr της εταιρείας με την επωνυμία «iDNA Genomics A.E.». Η iDNA Genomics AE και η iDNA Laboratories (στο εξής: «Εταιρεία» ή «iDNA») δρουν ως από κοινού Υπεύθυνοι Επεξεργασίας, έχοντας καταρτίσει σχετική σύμβαση, για τους κοινούς σκοπούς επεξεργασίας Προσωπικών Δεδομένων που περιγράφονται παρακάτω. Σκοποί Επεξεργασίας: διεξαγωγή φαρμακογενετικών και γενετικών αναλύσεων, μέτρηση της βιολογικής ηλικίας, εκτίμηση εξατομικευμένου κινδύνου εμφάνισης καρδιαγγειακών παθήσεων.',
    idnaGivesImportance: 'Η iDNA αποδίδει ύψιστη σημασία στην προστασία των δεδομένων προσωπικού χαρακτήρα, και δεσμεύεται να καταβάλει κάθε προσπάθεια για να εξασφαλίσει την τήρησή τους, ειδικότερα: ',
    theInfoThatIdnaCollects: 'Τα δεδομένα που η iDNA συλλέγει (είτε μέσω των συμπληρωμένων εντύπων του kit είτε μέσω της ψηφιακής πλατφόρμας της iDNA Genomics, είτε από συνεργαζόμενους επαγγελματίες υγείας), αποθηκεύει και επεξεργάζεται, ανά περίπτωση, είναι: ',
    simpleDataAs: 'Απλά δεδομένα προσωπικού χαρακτήρα όπως: ',
    dataOfPersonalCharacter: 'Δεδομένα προσωπικού χαρακτήρα ειδικών κατηγοριών όπως: Δεδομένα υγείας, γενετικά δεδομένα, αιματολογικές εξετάσεις.',
    theDataAbove: 'Τα παραπάνω δεδομένα τηρούνται δε σε έγχαρτα αρχεία είτε στους servers της εταιρείας',
    theScopeOfDataCollection: 'Οι σκοποί της επεξεργασίας δεδομένων προσωπικού χαρακτήρα που κατέχει η iDNA, είναι κατά περίπτωση οι ακόλουθοι:',
    inTheCaseThatA: 'Στην περίπτωση που: α) θεωρηθεί πως δεν ικανοποιήθηκε επαρκώς και νομίμως κάποιο αίτημα ή β) πως το δικαίωμα στην προστασία των προσωπικών δεδομένων προσβάλλεται από κάποια επεξεργασία που πραγματοποιείται από την εταιρεία, μπορεί να υποβληθεί καταγγελία στην Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (ταχυδρομική δ/νση Κηφισίας 1-3, Τ.Κ. 115 23, Αθήνα, τηλ. 210. 6475600, δ/νση ηλεκτρονικού ταχυδρομείου (e-mail: contact@dpa.gr). ',
    patientPersonalDetails: 'Patient personal data',
    'gdprΣυλλογή και επεξεργασία των προσωπικών μου δεδομένων που αφορούν σε ειδικών κατηγοριών δεδομένα (γενετικά, υγείας) με σκοπό τη διεξαγωγή της Φαρμακογενετικής ανάλυσης από την iDNA Genomics': 'Collection and processing of my personal data concerning special categories of data (genetic, health) for the purpose of conducting the Pharmacogenetic analysis by iDNA Laboratories',
    'Αποδέχομαι το Συμφωνητικό Επεξεργασίας Προσωπικών Δεδομένων': 'I accept the agreement regarding processing of personal data',
    'Δείτε εδώ το έντυπο Συναίνεσης Ασθενούς': 'See the Patient Consent form here',
    'Συναίνεση ασθενούς': 'Patient consent',
    'Η μη συγκατάθεσή σας συνεπάγεται την αδυναμία παροχής των υπηρεσιών μας': 'We are unable to provide services without your consent',
    'Εδώ θα βρείτε το έντυπο που πρέπει να συμπληρώσει ο ασθενής για τη διεξαγωγή της Φαρμακογενετικής Ανάλυσης.': 'Here you will find the form that the patient must fill in for the Pharmacogenetic Analysis.',
    'Παρακαλώ πολύ κρατήστε το συμπληρωμένο έγγραφο στα αρχεία σας': 'Please keep the completed document for your records',
    'Δείτε εδώ το έντυπο Συναίνεσης Ασθενούς / Πελάτη': 'See the Patient / Client Consent form here',
    'Εδώ θα βρείτε το έντυπο που πρέπει να συμπληρώσει ο ασθενής/πελάτης για τη διενέργεια της υπηρεσίας μέτρησης Βιολογικής Ηλικίας.': 'Here you will find the form that the patient/client must fill in for the Biological Age measurement service.',
    'Συναίνεση ασθενούς/πελάτη': 'Patient/client declaration of consent',
    'Συγκατάθεση για τα Προσωπικά Δεδομένα': 'Personal Data',
    'Χρήση των ανωνυμοποιημένων ή ψευδονυμοποιημένων (με κωδικοποιημένη μορφή) αποτελεσμάτων των γενετικών αναλύσεων για ερευνητικούς και στατιστικούς σκοπούς': 'The patient/client provides consent for the use of their anonymized or pseudonymized (coded) results of their genetic analysis for research and statistical purposes.',
    'Χρήση των ανωνυμοποιημένων ή ψευδονυμοποιημένων (με κωδικοποιημένη μορφή) μετρήσεων Βιολογικής Ηλικίας για ερευνητικούς και στατιστικούς σκοπούς': 'The patient/client provides consent for the use of their anonymized or pseudo-anonymized (in coded form) results of the Biological Age measurement for research or statistical purposes.',
    'Εδώ θα βρείτε το έντυπο που πρέπει να συμπληρώσει ο ασθενής/πελάτης για τη διεξαγωγή της Γενετικής ανάλυσης.': 'Here you will find the form that the patient/client must fill in for the Genetic Analysis.',
    'Αποστολή ενημερωτικού και προωθητικού υλικού στην ηλεκτρονική διεύθυνση': 'The patient/client provides consents to iDNA Genomics and its partners to send news and promotional material to their email.',
    invalidThematicPackage: 'Registration for a minor is not possible for this test',
    'Εγγραφή για ανήλικο': 'Register for a minor',
    'Εγγραφή για εσάς': 'Register for you',
    'Κατά την online εγγραφή του iDNA PGx CNS Kit, σας δίνεται η δυνατότητα να πληρώσετε online την Φαρμακογενετική Ανάλυση με χρεωστική/πιστωτική ή προπληρωμένη κάρτα, με έως': 'During the online registration of the iDNA PGx CNS Kit, you have the option to pay online for the Pharmacogenetic Analysis by debit/credit or prepaid card, with up to',
    '6 άτοκες δόσεις': '6 interest-free instalments',
    '(οι δόσεις αφορούν αγορές άνω των 50€).': '(the instalments apply to purchases over 50€).',
    'Σε περίπτωση που δεν επιθυμείτε την online πληρωμή, όπως συμπληρώσετε τα συνοδευτικά έγγραφα του kit και εξοφλήσετε μέσω των συνεργαζόμενων τραπεζών της iDNA Laboratories.': 'In case you do not wish to pay online, please fill in the accompanying documents of the kit and pay through iDNA Laboratories\' cooperating banks.',
    kitFollowInstructionsContentDoctor: 'The sampling procedure shall be performed by a doctor or qualified personnel. It is very important that the procedure described ',
    kitFollowInstructionsContentDoctorAfter: ' is followed strictly.',
    consentStatement: 'Declaration of consent to conduct the test',
    'Έχει γίνει ενημέρωση των Όρων Χρήσης και του Συμφωνητικού Επεξεργασίας Προσωπικών Δεδομένων. Παρακαλώ πολύ ενημερωθείτε για να μπορέσετε να έχετε πρόσβαση στο λογαριασμό σας': 'The Terms of Use and Privacy Agreement have been updated. Please be sure to check it before you can access your account',
    'Επιλέξτε τη γλώσσα που θέλετε να ολοκληρώσετε την εγγραφή για το ανήλικο τέκνο σας και να βλέπετε το προσωπικό του report αποτελεσμάτων': 'Select your preferred language to complete the registration of your minor and view their personalized report.',
    'Προσωπικά στοιχεία ανήλικου τέκνου': 'Personal data of minor',
    'Παρακαλώ να εισαχθούν οιπληροφορίες του ατόμου από το οποίο θα παραληφθεί το δείγμα. Για ανήλικο χρήστη, ο γονέας ή κηδεμόνας θα πρέπει να δώσει τις κατάλληλες συγκαταθέσεις στο επόμενο βήμα.': 'Please enter the information of the person from whom the sample will be received. For a minor, the parent or guardian will need to provide appropriate consents in the next step.',
    'childΔίνω ρητώς τη συγκατάθεσή μου για τη συλλογή και επεξεργασία των προσωπικών μου δεδομένων που αφορούν σε ειδικών κατηγοριών δεδομένα (γενετικά, υγείας) με σκοπό τη διεξαγωγή της Γενετικής ανάλυσης από την iDNA Genomics.': 'For the collection and processing of the personal data (genetic, health) for the purposes of the Genetic analysis from iDNA Genomics.',
    'Παρακαλώ να εισαχθούν οι πληροφορίες του ατόμου από το οποίο θα παραληφθεί το δείγμα. Για ανήλικο χρήστη, ο γονέας ή κηδεμόνας θα πρέπει να δώσει τις κατάλληλες συγκαταθέσεις στο επόμενο βήμα.': 'Please enter the information of the person from whom the sample will be received. For a minor, the parent or guardian will need to provide appropriate consents in the next step.',
    'Δες τα αποτελέσματά σου': 'See your results',
    'Είστε σίγουρος ότι θέλετε να διαγράψετε το κιτ;': 'Are you sure you want to delete the kit?',
    'Επιθυμώ να διορθώσω τα στοιχεία': 'I wish to edit my personal details',

    filtering: 'Filtering by:',
    'All Lifechecks': 'All Lifechecks',
    lifecheckSales: 'Lifecheck Sales',
    'Start Date': 'Start Date',
    'End Date': 'End Date',

    nutrigenetix: {
      select_report_locale: {
        doctor: {
          select_lang_desc: 'Select your preferred language to complete the registration and view your patients\'/clients\' reports.',
        },
        adult: {
          select_lang_desc: 'Select your prefered language to complete your registration and view your personalized report.',
        },
        child: {
          select_lang_desc: 'Select your preferred language to complete the registration of your minor and view their personalized report',
        },
      },
      personal_data: {
        doctor: {
          personal_data_info: 'Please enter the details of the person who provided the sample',
          personal_data_title: 'Patients\' personal data',
          gender_info: '(biological sex is defined as the gender they were assigned at birth)',
        },
        adult: {
          personal_data_info: 'Please enter the details of the person who provided the sample',
          personal_data_title: 'User Personal Details',
          gender_info: '(biological sex is defined as the gender you were assigned at birth)',
        },
        child: {
          personal_data_info: 'Please enter the details of the person who provided the sample. For a minor, the parent or guardian will need to provide appropriate consents in the next step.',
          personal_data_title: 'Personal data of minor',
          gender_info: '(biological sex is defined as the gender they were assigned at birth)',
        },
      },
      consents: {
        doctor: {
          consent_title: 'Patient/client declaration of consent',
          gdpr_file_info: 'Here you will find the form that the patient must fill in to carry out the Genetic Analysis.',
          save_file: 'Please keep the completed document for your records.',
          show_file: 'See the Patient/Client Consent form here',
          record_patient_consents: 'Record the consent you received for the following:',
          process_personal_data: 'The patient/client explicitly consents to the collection and processing of their personal data (genetics, health) for the purpose of conducting the Genetic analysis by iDNA Genomics.',
          unable_to_process_warning: 'We are unable to provide services without your consent',
          anonymized_data_consent: 'The patient /client explicitly consents to the use of the anonymized or pseudonymized (coded) results of their genetic analysis for research and statistical purposes',
          advertized_content_consent: 'The patient/client explicitly consents to iDNA Genomics and its partners to send news and promotional material to their email.',
        },
        adult: {
          general_consent: {
            general_consent_title: 'Declaration of consent',
            informed_analysis_purpose: 'I hereby state that I have been fully and thoroughly informed regarding the necessity, purpose and nature of the genetic analysis, as well as the methodology used by iDNA Genomics S.A.',
            proceed_analysis: 'Following this information, I declare that I explicitly provide my consent to the above company to proceed with the above analysis.',
            repeat_analysis: 'In case my sample is found unsuitable for analysis for any reason, I agree that this sample may be destroyed, and a new sample may be requested at no additional charge.',
            real_info: 'Fully acknowledging the consequences of the law, I explicitly declare that all my personal and medical history data provided here are accurate and true.',
          },
          personal_data_consent: {
            consent_personal_data_title: 'Personal Data',
            consent_for_the_following: 'I explicitly provide my consent for the following:',
            process_personal_data: 'For the collection and processing of my personal data (genetic, health) for the purposes of the genetic analysis from iDNA Genomics.',
            unable_to_process_warning: 'We are unable to provide services without your consent.',
            anonymized_data_consent: 'For the use of my anonymized or pseudo-anonymized (in coded form) genetic results for research or statistical purposes.*',
            advertized_content_consent: 'For iDNA Genomics and their partners to send news and promotional material to my email.*',
          },
        },
        child: {
          general_consent: {
            general_consent_title: 'Declaration of consent to conduct the test',
            informed_analysis_purpose: 'I hereby state that I have been fully and thoroughly informed regarding the necessity, purpose and nature of the genetic analysis, as well as the methodology used by iDNA Genomics S.A.',
            proceed_analysis: 'Following this information, I declare that I explicitly provide my consent to the above company to proceed with the above analysis.',
            repeat_analysis: 'In case the sample is found unsuitable for analysis for any reason, I agree that this sample may be destroyed, and a new sample may be requested at no additional charge.',
            real_info: 'Fully acknowledging the consequences of the law, I explicitly declare that personal and medical history data provided here are accurate and true.',
          },
          personal_data_consent: {
            consent_personal_data_title: 'Consent for Personal Data',
            consent_for_the_following: 'I explicitly provide my consent for the following:',
            process_personal_data: 'For the collection and processing of the personal data (genetic, health) for the purposes of the Genetic analysis from iDNA Genomics.',
            unable_to_process_warning: 'We are unable to provide services without your consent.',
            anonymized_data_consent: 'For the use of the anonymized or pseudo-anonymized (in coded form) genetic results for research or statistical purposes.*',
            advertized_content_consent: 'For iDNA Genomics and their partners to send news and promotional material to my email.*',
            guardian_consent: 'Parent Consent*',
          },
        },
      },
      sample: {
        doctor: {
          collect_sample_info: 'See here for detailed information',
          send_to_idna: 'Send your free buccal swab sample box in the address:',
        },
        adult: {
          collect_sample_info: 'Please follow the buccal swab (saliva) sample collection instructions provided in the kit you received or click here',
          collect_sample_info_no_here: 'See detailed instructions on buccal swab (saliva) sample collection',
          send_to_idna: 'Place the saliva sample in the Test Kit box, and return it to iDNA Genomics S.A.',
          send_sample_info: 'Follow the sample dispatch instructions provided in the kit you received or click here',
        },
        child: {
          collect_sample_info: 'See detailed instructions on buccal swab (saliva) sample collection here',
          collect_sample_info_no_here: 'See detailed instructions on buccal swab (saliva) sample collection',
          send_to_idna: 'The Test Kit box, in which you have placed the buccal swab sample, should be sent to iDNA Genomics S.A.',
          send_sample_info: 'Follow the sample dispatch instructions provided in the kit you received or click here',
        },

        common: {
          sample_dispatch_instructions: 'Instructions for sample dispatch',
        },
      },
      results_receipt: {
        doctor: {
          report_availiable: 'Your patient/client personalized report will be available in your myEMR account within 20 business days of receiving the buccal swab sample from our laboratory. You will be notified by email. You will be able to view, download, send via the platform or via email your personalized patient results report.',
          report_availiable_us: 'Your patient’s/ client’s personalized report will be accessible in your account within 30 business days from the day our laboratory receives the saliva sample. A notification will be sent to your registered email. You will be able to view, download, send it through the platform or by email,',
        },
        adult: {
          report_availiable: 'Your personalized report will be accessible in your account within 20 business days from the day our laboratory receives your saliva sample. A notification will be sent to your registered email. In the case you have requested to provide access for a third party to your electronic file and the third party has accepted it, a notification will also be sent to the third party’s email to have access to your personalized report.',
          report_availiable_us: 'Your personalized report will be accessible in your account within 30 business days from the day our laboratory receives your saliva sample. A notification will be sent to your registered email. In the case you have requested to provide access for a third party to your electronic file and the third party has accepted it, a notification will also be sent to the third party’s email to have access to your personalized report.',
        },
        child: {
          report_availiable: 'The personalized report will be accessible in your account within 20 business days from the day our laboratory receives the saliva sample.A notification will be sent to your registered email. In the case you have requested to provide access for a third party to your electronic file and the third party has accepted it, a notification will also be sent to the third party’s email to have access to the personalized report.',
          report_availiable_us: 'The personalized report will be accessible in your account within 20 business days from the day our laboratory receives the saliva sample.A notification will be sent to your registered email. In the case you have requested to provide access for a third party to your electronic file and the third party has accepted it, a notification will also be sent to the third party’s email to have access to the personalized report.',
        },
      },
      questionnaire: {
        adult: {
          first_warning: 'Your answers combined with the results of your genetic analysis will aid clinical decisions regarding your personalized response to nutrients and weight management and will guide nutritional strategies for optimal health and disease prevention and management.',
          second_warning: 'Please verify the data you provided during kit registration process. This information is essential for your personalized report. After completing your registration, you will NOT be able to make any changes.',
        },
        child: {
          first_warning: 'Your answers combined with the results of the genetic analysis will aid clinical decisions regarding the personalized response to nutrients and weight management and will guide nutritional strategies for optimal health and disease prevention and management.',
          second_warning: 'Please verify the data you provided during kit registration process. This information is essential for the personalized report. After completing your registration, you will NOT be able to make any changes.',
        },
        doctor: {
          first_warning: 'Your answers combined with the results of the genetic analysis will aid clinical decisions regarding the personalized response to nutrients and weight management and will guide nutritional strategies for optimal health and disease prevention and management.',
          second_warning: 'Please verify the data you provided during kit registration process. This information is essential for the personalized report. After completing your registration, you will NOT be able to make any changes.',
        },
        common: {
          title: 'Health & Lifestyle Questionnaire',
        },
      },
      review: {
        doctor: {
          review_info_warning: 'Please verify the data you provided during kit registration process. This information is essential for the personalized report. After completing your registration, you will NOT be able to make any changes.',
          personal_data_title: 'Patient Information',
          collect_data_consent: 'The patient/client provides consents for the collection and processing of their personal data (genetics, health) for the purpose of conducting the Genetic analysis by iDNA Genomics',
          anonymized_consent: 'The patient/client provides consent for the use of their anonymized or pseudonymized (coded) results of their genetic analysis for research and statistical purposes',
          advertized_content_consent: 'The patient/client provides consents to iDNA Genomics and its partners to send news and promotional material to their email.',
          sample_date_title: 'Sample Collection Date',
          questionnaire_answers: 'Questionnaire Answers',
        },
        adult: {
          review_info_warning: 'Please verify the data you provided during kit registration process. This information is essential for your personalized report. After completing your registration, you will NOT be able to make any changes.',
          personal_data_title: 'Patient Information',
          health_professional_title: 'Doctor/Health Professional to whom you have sent a follow-up invitation:',
          consent_aggreement_title: 'Declaration of consent',
          proceed_analysis: 'I provide my consent to the company to proceed with the analysis of my sample, which may be repeated if deemed unsuitable and I declare that my data are accurate and true.',
          analysis_real_data_consent: 'I provide my consent for the collection and processing of my personal data for the purposes of the genetic analysis from iDNA Genomics.',
          anonymized_consent: 'I provide my consent for the use of my anonymized or pseudo-anonymized (in coded form) genetic results for research or statistical purposes.',
          advertized_content_consent: 'I provide my consent to iDNA Genomics and their partners to send news and promotional material to my email.',
          sample_date_title: 'Sample Collection Date',
          questionnaire_answers: 'Questionnaire Answers',
        },
        child: {
          review_info_warning: 'Please verify the data you provided during kit registration process. This information is essential for the personalized report. After completing your registration, you will NOT be able to make any changes.',
          personal_data_title: 'Patient Information',
          health_professional_title: 'Doctor/Health Professional to whom you have sent a follow-up invitation:',
          consent_aggreement_title: 'Declaration of consent',
          analysis_real_data_consent: 'I provide my consent to the company to proceed with sample analysis, which may be repeated if deemed unsuitable and I declare that the data are accurate and true.',
          collect_data_consent: 'I provide my consent for the collection and processing of my minor’s personal data for the purposes of the genetic analysis from iDNA',
          anonymized_consent: 'I provide my consent for the use of my minor’s anonymized or pseudo-anonymized (in coded form) genetic results for research or statistical purposes',
          advertized_content_consent: 'I provide my consent to iDNA Genomics and their partners to send news and promotional material to my email',
          sample_date_title: 'Sample Collection Date',
          questionnaire_answers: 'Questionnaire Answers',
        },
      },
      common: {
        doctor_invitation_info: 'Should you wish to provide access to your electronic file to a third party (e.g., Doctor / Healthcare professional), please fill in their details below.',
        search_doctor_title: 'Search Doctor/Health Professional',
        doctor_info_title: 'Doctor/Health Professional Details',
        select_lang_title: 'Available languages',
        select_lang_warning: 'Language selection CANNOT be altered after registration inn complete',
        gender_title: 'Biological Sex*',
        gender_male: 'Male',
        gender_female: 'Female',
        postal_address_title: 'Address',
        contact_info_title: 'Contact Information',
        collect_sample_title: 'Instructions for sample collection',
        sample_date: 'Date of buccal swab sample collection',
        send_sample_title: 'Sample dispatch',
        send_address: 'The shipping address is: iDNA Genomics A.E., Evrota 25-27, 14564, Kifissia, tel. 211 1021821, www.idnagenomics.com.',
        send_address_parts: {
          the_shipping_adress: 'The shipping address is:',
          idna_address: 'iDNA Genomics S.A., 25-27 Evrota street, 14564, Kifissia, Greece',
          idna_phone_and_site: 'Tel. +30 211 102 18 21, www.idnagenomics.com',
        },
        results_receipt_title: 'Results',
        report_language_title: 'Report Language',
      },
    },
    doctors_recommendation: 'Doctor Referral',
    select_referral_doctor: 'Please select the doctor/health professional who recommended the test to you.',
    select_referral_doctor_to_other: 'Please select the doctor/health professional who recommended the test.',
    select_receiver_doctor: 'Please select the doctor/healthcare professional who will receive your personal Results Report',
    select_receiver_doctor_to_other: 'Please select the doctor/healthcare professional who will receive your Results Report',
    send_results_report: 'Send Results Report',

    AMERICA: 'USA',
    USA: 'USA',
    ANDORRA: 'ANDORRA',
    ALBANIA: 'ALBANIA',
    AUSTRIA: 'AUSTRIA',
    'ÅLAND ISLANDS': 'ÅLAND ISLANDS',
    'BOSNIA AND HERZEGOVINA': 'BOSNIA AND HERZEGOVINA',
    BELGIUM: 'BELGIUM',
    BULGARIA: 'BULGARIA',
    BELARUS: 'BELARUS',
    SWITZERLAND: 'SWITZERLAND',
    CYPRUS: 'CYPRUS',
    'CZECH REPUBLIC': 'CZECH REPUBLIC',
    GERMANY: 'GERMANY',
    DENMARK: 'DENMARK',
    ESTONIA: 'ESTONIA',
    SPAIN: 'SPAIN',
    FINLAND: 'FINLAND',
    'FAROE ISLANDS': 'FAROE ISLANDS',
    FRANCE: 'FRANCE',
    'UNITED KINGDOM': 'UNITED KINGDOM',
    GUERNSEY: 'GUERNSEY',
    GREECE: 'GREECE',
    CROATIA: 'CROATIA',
    HUNGARY: 'HUNGARY',
    IRELAND: 'IRELAND',
    'ISLE OF MAN': 'ISLE OF MAN',
    ICELAND: 'ICELAND',
    ITALY: 'ITALY',
    JERSEY: 'JERSEY',
    LIECHTENSTEIN: 'LIECHTENSTEIN',
    LITHUANIA: 'LITHUANIA',
    LUXEMBOURG: 'LUXEMBOURG',
    LATVIA: 'LATVIA',
    MONACO: 'MONACO',
    'MOLDOVA, REPUBLIC OF': 'MOLDOVA, REPUBLIC OF',
    'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF': 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF',
    MALTA: 'MALTA',
    NETHERLANDS: 'NETHERLANDS',
    NORWAY: 'NORWAY',
    POLAND: 'POLAND',
    PORTUGAL: 'PORTUGAL',
    ROMANIA: 'ROMANIA',
    'RUSSIAN FEDERATION': 'RUSSIAN FEDERATION',
    SWEDEN: 'SWEDEN',
    SLOVENIA: 'SLOVENIA',
    'SVALBARD AND JAN MAYEN': 'SVALBARD AND JAN MAYEN',
    SLOVAKIA: 'SLOVAKIA',
    'SAN MARINO': 'SAN MARINO',
    UKRAINE: 'UKRAINE',
    'HOLY SEE (VATICAN CITY STATE)': 'HOLY SEE (VATICAN CITY STATE)',

    'Αναβάθμιση kit': 'Kit upgrade',
    ancestorNotUpgradeable: 'The kit isn\'t upgradable',
    cost: 'Cost:',
    patCustFirstLastName: 'Patient/client full name',
    patFirstLastName: 'Patient\'s full name',
    'Κατέβασμα report': 'Download report',
    'Το προφίλ σου, δηλαδή το σύνολο των φαινοτυπικών σου χαρακτηριστικών, όπως τα δήλωσες μέσα από το ερωτηματολόγιο που συμπλήρωσες.': 'Your profile, i.e., your phenotypic characteristics, as those were stated by you in the questionnaire you filled in.',
    'Τις προσωπικές σου ανάγκες σε ενέργεια, μακροθρεπτικά και μικροθρεπτικά, όχι μόνο με βάση τη διατροφογενετική σου ανάλυση, αλλά έχοντας συνυπολογίσει το προφίλ σου, τον προσωπικό σου στόχο, αλλά και τις διατροφικές προτιμήσεις.': 'Your personal needs in energy, macronutrients and micronutrients, not only based on your nutrigenetic analysis, but having considered your profile, your goal and your dietary preferences.',
    'Το εξατομικευμένο σου εβδομαδιαίο πλάνο διατροφής συνδυάζονται όλες οι ανωτέρω πληροφορίες και ο προσωπικός σου στόχος υγείας (π.χ. απώλεια βάρους), με στόχο την πρόληψη εμφάνισης παθήσεων και τη συνολική υγεία.': 'Υour personalized weekly nutrition plan, all the above information and your personal health goal (e.g., weight loss) are combined, aiming at disease prevention and overall health.',
    'Στην παρούσα ανάλυση θα βρεις τα παρακάτω': 'In the present analysis you will find the following:',
    'Το προφίλ σου': 'Your profile',
    'Εξατομικευμένο πλάνο διατροφής': 'Personalized nutrition plan',
    'Διατροφογενετική vs. Διατροφική κατάσταση': 'Nutrigenetic vs. Nutritional status',
    'Διατροφογενετική Ανάλυση': 'Nutrigenetic Analysis',
    'Πλάνο διατροφής': 'Nutrition Plan',
    'Διατροφογενετική Aνάλυση PDF Version': 'Nutrigenetic analysis PDF Version',
    'Πλάνο Διατροφής PDF Version': 'Nutrition plan PDF Version',
    'Please be advised that we are performing scheduled maintenance to improve our website.': 'Please be advised that we are performing scheduled maintenance to improve our website.',
    'During this period, site functionalities will be unavailable.': 'During this period, site functionalities will be unavailable.',
    'Thank you for your understanding.': 'Thank you for your understanding.',
    afm: 'VAT ID',
    'Επαγγελματίας Υγείας Δημόσιου Φορέα': 'Public Sector Health Professional',
    'Δες τα πλήρη στοιχεία ασθενή/πελάτη': 'View patient/client details',
    'Επιλέξτε τρόπο πληρωμής': 'Choose payment method',
    'Με κάρτα': 'Card',
    'Κατάθεση στην τράπεζα': 'Bank deposit',
    'Στοιχεία χρέωσης': 'Billing details',
    'Θα λάβετε e-mail με τους διαθέσιμους λογαριασμούς μετά την ολοκλήρωση της εγγραφής σας.': 'You will receive an e-mail with the available bank accounts upon completion of your registration.',
    price: 'Price',

    'Promo code was applied successfully': 'Promo code was applied successfully',
    notPromoCode: 'The promo code was not found',
    codeNotAllowedToBeUsed: 'The promo code was not found',
    codeAlreadyUsed: 'Promo code has already been used',
    expiredPromotionCode: 'Promo code has expired',
    notYetAvailable: 'Promo code isn\'t available yet',
    'A new version is available!': 'A new version is available!',
    'Click on “Update” to get the latest version': 'Click on “Update” to get the latest version',
    Update: 'Update',
    'Η εταιρία θα παραμείνει κλειστή': 'The company will remain closed',
    '4/8 - 15/8': '4-15 August',
    'λόγω καλοκαιρινών διακοπών': 'for summer holidays',
    'Δεν έχουν συμπληρωθεί όλα τα στοιχεία': 'Not all details have been filled in',
    ActivatePromoCode: 'Activate your promo code!',
    RegisterPersonalDetails: 'Enter your details and the Serial Number of your kit to receive your unique discount code.',
    EnterSerialNumber: 'Please enter the Serial Number of the kit',
    SubmitPharmacists: 'Submit',
    ForPharmacists: 'For Pharmacists',
    FindSerial: 'How to find the Serial Number',
    SerialInstructions1: 'You will find the Serial Number attached around the box. This code has the format ',
    SerialInstructions2: ', with the first 2 digits consisting of letters and the remaining six consisting of numbers.',
    The: 'The',
    PrevFem: 'Previous',
    NextFem: 'Next',
    'out of': 'out of',
    SentEmail: 'has been sent to you via email.',
    Thankyou: 'Thank you!',
    'Μόνο ενήλικες μπορούν να εγγραφτούν στην πλατφόρμα': 'Only adults can register on the platform',
    'Σχόλια (προσθέστε επιπλέον πληροφορίες σχετικά με το γραφείο σας εντός του νοσοκομείου που εργάζεστε)': 'Comments (add additional information about your office within the hospital you work in):',
    Is: 'is',
    IsNot: 'is not',
    downloadApp: 'Download the app for Android & iOS!',
    noAppointment: 'There is no provision for scheduling an appointment to discuss the results of this test.',
    Request: 'Request',
    RequestDate: 'Request Date',
    Doctor: 'Doctor',
    RequestStatus: 'Request status',
    pharmacogeneticConsent: 'Consent for pharmacogenetic analysis',
    Pending: 'Pending',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    'iDNA Βιταμίνες & Ιχνοστοιχεία': 'iDNA Vitamins & Minerals',
    KitBoost: 'Kit Boost',
    kitBoostButton: 'Kit Boost to iDNA Vitamins & Minerals',
    registrationFail: 'Δεν έχετε δικαίωμα να κάνεντε την συγκεκριμένη εγγραφή',
    kitBoostActivateTitle: 'You have chosen to activate KitBoost for ',
    kitBoostActivateSub: 'This will create a new iDNA Test Vitamins & Minerals Results Report for your customer. Do you want to continue with the activation?',
    kitBoostActivateTitle2: 'KitBoost Activation ',
    kitBoostActivateSub2: 'You have activated KitBoost for {{serial}}. The Vitamin &Minerals Results Report for your client {{name}} will have the serial number {{newSerial}}. You can find it in the Results menu option in your profile on myEMR.',
    kitBoostRowText: 'It has already been Kit Boosted',
    kitBoostError: 'Error: No connection was made with vitamins kit',
    doctorsAMKA: 'Doctor\'s ΑΜΚΑ',
    'Ημερομηνία έκδοση συνταγής': 'Date of issuance of prescription',
    'Ο αριθμός παραστατικού δεν είναι σωστός.': 'The referral number is incorrect.',
    tiranaAddress: 'Trimed Healthcare, Autostrada Tirane – Durres, Km. 10, Kashar, Tirana',
  },
};
